import React, { useEffect, useState, useMemo, useRef } from 'react';
// import Header from "./header";
import { useNavigate, useLocation } from 'react-router-dom';
import "../App.css";
import * as XLSX from 'xlsx';
import '../assets/css/gapsybdmupload.css';
import '../assets/css/Tableproperty.css';
import Papa from "papaparse";
import axios from 'axios';
import { jsPDF } from "jspdf";
import mammoth from "mammoth";
import 'bootstrap/dist/css/bootstrap.min.css';
import { Modal, Button, Form, Dropdown } from 'react-bootstrap';
import { Listoftablesearchbox1, bootstrapbuttonclass, cancelButtonStyle, closeButtonStyle, ListPopSize, UploadLoadingIcon } from "../components/Propertyfile";
import { uploadMutiple, Bulkuploaddata, bdmtablecolumns, PortURL, checksumAPI, allowmodifytemplate, Makerlist_deptwisetemplates, ocrfile, mqemocr, OcrWebsocket, OcrMethod } from '../components/ApiProperty';
import { TableTemplateListGapsy, ListofTableFontsize, PaginationComponentForm1, PaginationComponentForm2 } from "../components/TableProperty";
import Header from './gapsy-header';
import Navigation from './gapsy-Mnavigation';
import Footer from './gapsy-footer';
import "bootstrap/dist/css/bootstrap.min.css"
import 'bootstrap-icons/font/bootstrap-icons.css';
import styles from '../assets/css/gapsy-dashboard.module.css';
import DepartmentDropdown from "../components/Dropdown"; // Adjust path based on file location
import tabStyles from '../assets/css/gapsy-tabs.module.css';
import tableStyles from '../assets/css/sharedTableStyles.module.css';
import { useSession } from '../components/SessionContext';



const GapsyTablelist = () => {
    const [file, setFile] = useState(null);
    const [activeTab, setActiveTab] = useState('manual'); // 'manual' or 'ai'
    const [formData1, setFormData1] = useState({});
    const [uploadStatus, setUploadStatus] = useState('');
    const [uploadProgress, setUploadProgress] = useState(0);
    const [errors, setErrors] = useState([]);
    const fileInputRef = useRef(null);
    const [isValidationPassed, setIsValidationPassed] = useState(false);
    const [columnKeys, setColumnKeys] = useState([]);
    const [selectedDownloadFormat, setSelectedDownloadFormat] = useState(null); // Store selected format
    const [selectedCategory, setSelectedCategory] = useState(null);
    const [showSheetDropdown, setShowSheetDropdown] = useState(false);
    const [Prefix, setPrefix] = useState("");
    const [selectedName, setSelectedName] = useState('');
    // const [recordsCount, setRecordsCount] = useState(0);
    const [showDropdown, setShowDropdown] = useState(true);
    const [selectedFile, setSelectedFile] = useState(null);
    const [showGenerateReportButton, setShowGenerateReportButton] = useState(false);
    const [allErrors, setallErrors] = useState([]);
    const [validRecords, setvalidRecords] = useState("");
    const [validRecords1, setvalidRecords1] = useState("");
    const [validErrorRecords, setvalidErrorRecords] = useState("");
    const [showGenerateReport, setShowGenerateReport] = useState(false);
    const [validationErrors, setValidationErrors] = useState([]);
    const [errorMessages, setErrorMessages] = useState([]);
    const [selectedFormat, setSelectedFormat] = useState("");
    const [showDownloadButton, setShowDownloadButton] = useState(false);
    const [uploadSuccess, setUploadSuccess] = useState(false);
    const [errMsg, setErrMsg] = useState('');
    const [loading, setLoading] = useState(false);
    const [loading1, setLoading1] = useState(false);
    const [showPopModal, setPopShowModal] = useState(false);
    const [showPreview, setShowPreview] = useState(false);
    const [previewData, setPreviewData] = useState([]); // State for preview data
    const [wsLoading, setWsLoading] = useState(false);
    const [showModal, setShowModal] = useState(false); // State to control modal visibility
    const [showNotifyModal, setShowNotifyModal] = useState(false); // State to control notification modal visibility
    const [formSubmitted, setFormSubmitted] = useState(false); // State to prevent form submission until notification selection
    const location = useLocation();
    const [isEactName, setEactName] = useState('');
    const [isExactName, setExactName] = useState('');
    const [modalMessage, setModalMessage] = useState('');
    const [errorModalMessage, setErrorModalMessage] = useState('');
    const [showErrorModal, setShowErrorModal] = useState(false);
    const [showNoDataModal, setShowNoDataModal] = useState(false);
    const [showFileSelectionModal, setShowFileSelectionModal] = useState(false);
    const [fileSelectionMessage, setFileSelectionMessage] = useState('');
    const [showConfirmationModal, setShowConfirmationModal] = useState(false);
    const [confirmationMessage, setConfirmationMessage] = useState('');
    const [showNotifyModalAfterConfirmation, setShowNotifyModalAfterConfirmation] = useState(false);
    const [isUploadAllowed, setIsUploadAllowed] = useState(true);
    const [columnDetails, setColumnDetails] = useState({});
    const [notifyType, setNotifyType] = useState('IN'); // Set EOD as default
    const [errormessage, seterrormessage] = useState('IN');
    const [messageType, setMessageType] = useState(''); // 'success' or 'error'
    const [previewLimit, setPreviewLimit] = useState(100);
    const [columnDropdown, setcolumnDropdown] = useState({});
    const [filteredTables, setFilteredTables] = useState([]);
    const [selectedPrefix, setSelectedPrefix] = useState("");
    const [tableNames, setTableNames] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [recordsPerPage] = useState(7); // Set the number of records per page
    const [modalMessageOne, setModalMessageOne] = useState('');
    const [searchQuery, setSearchQuery] = useState('');
    const prefixes = Object.keys(tableNames);
    const [isUploading, setIsUploading] = useState(false);

    const [sheetOptions, setSheetOptions] = useState([]);
    const [selectedSheets, setSelectedSheets] = useState([]);
    const [recordSuccess, setrecordSuccess] = useState('');
    const [errorData, setErrorData] = useState([]);
    const [errorRecords, seterrorRecords] = useState("");
    const [currentFile, setCurrentFile] = useState(null);
    const [showSheetSelection, setShowSheetSelection] = useState(false);
    const [sheetSelectionModal, setSheetSelectionModal] = useState({
        show: false,
        sheets: [],
        selectedSheets: [],
        workbook: null,
        file: null,
    });
    const [selectedFileName, setSelectedFileName] = useState('');
    const [selectedTableName, setSelectedTableName] = useState('');
    const [jsonReportData, setJsonReportData] = useState([]);
    const [failureReportData, setFailureReportData] = useState([]);
    const [finalizedContent, setFinalilizedContent] = useState([]);
    const { sessionId } = useSession();
    let csrfToken = sessionStorage.getItem("tokenizedSession");

    const userId = localStorage.getItem("userid");
    // setUserId(userId);
    const username = localStorage.getItem("username");

    const apiSessionId = sessionStorage.getItem("sessionId");
    const department = sessionStorage.getItem("dept");

    // const urlParams = new URLSearchParams(window.location.search);
    // const fileName = urlParams.get('fileName');

    const [selectedNumericColumns, setSelectedNumericColumns] = useState([]);


    const navigate = useNavigate();



    useEffect(() => {
        fetchData();
    }, []);

    const fetchData = async () => {
        setvalidErrorRecords([]);
        try {
            const config = {
                headers: { "userId": localStorage.getItem('userid'), 'x-csrf-token': csrfToken },
                withCredentials: true,
                params: { dept: department }
            };
            const response = await axios.post(Makerlist_deptwisetemplates, {}, config);

            const message = "Nothing pending for Upload data";

            if (response.data?.tables?.length) {
                // Categorize tables by prefix
                const categorizedTables = {};

                response.data.tables.forEach((table) => {
                    const [prefix, ...rest] = table.split('_');
                    if (!categorizedTables[prefix]) {
                        categorizedTables[prefix] = [];
                    }
                    categorizedTables[prefix].push(table);
                });

                setTableNames(categorizedTables);
            } else {
                // const updatedMessage = `Nothing pending for Upload data in department: ${department || 'Unknown'}`;
                // responseBKP(response, setModalMessage, setShowModal, setTableNames, message, updatedMessage);
                setTableNames({});
                const dept = sessionStorage.getItem("dept") || "Department not found";
                const updatedMessage = `Nothing pending for Upload data in department: ${dept}`;
            }
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };


    useEffect(() => {
        if (selectedPrefix) {
            // Set the filtered tables based on selectedPrefix
            setFilteredTables(tableNames[selectedPrefix] || []);
        } else {
            setFilteredTables([]); // Clear when no prefix is selected
        }
    }, [selectedPrefix, tableNames]);

    const paginate = (pageNumber) => {
        setCurrentPage(pageNumber);
    };

    const handleTableClick = async (item) => {
        const urlParams = new URLSearchParams(window.location.search);
        const paramValue = urlParams.get('param');
        setSelectedTableName(item);
        setvalidErrorRecords([]);

        if (!item) {
            setSelectedFileName(null); // or clear state as needed
            return;
        }

        const selectedName = item.split('_').slice(1).join('_');
        setSelectedFileName(selectedName);

        const [prefix, ...restParts] = item.split('_');
        const selectedNames = restParts.join('_');

        setPrefix(prefix);
        setSelectedName(selectedNames);
        // setSelectedFileName(item);
        const fileName = `${department}_${item}`;
        const config = {
            headers: {
                "userId": localStorage.getItem('userid'), 'x-csrf-token': csrfToken,
            },
            withCredentials: true,
            params: { "tableName": item, "modify": "Y" }
        };

        try {
            const response = await axios.post(allowmodifytemplate, {}, config);

            console.log("response", response);
            console.log("response.data", response.data);

            const { message, proceed } = response.data;

            if (proceed === "Yes") {
                // navigate(`/BDMupload?fileName=${item}`);
            } else {
                if (message === "No") {
                    setModalMessageOne(`${item} is under Review for Checker.`);
                } else {
                    setModalMessageOne(`${message}`);
                }
            }
        } catch (error) {
            console.error("Error during table click handling:", error);
            setModalMessageOne("An error occurred. Please try again.");
        }
    };

    const filteredRecords = useMemo(() => {
        // if (!selectedPrefix) return [];
        if (!selectedPrefix || !tableNames || !tableNames[selectedPrefix]) return [];

        const query = searchQuery.toLowerCase().trim();
        const filteredTablesForPrefix = tableNames[selectedPrefix] || [];

        return filteredTablesForPrefix.filter((tableName) =>
            tableName.toLowerCase().includes(query)
        );
    }, [tableNames, searchQuery, selectedPrefix]);

    useEffect(() => {
        setCurrentPage(1);
    }, [searchQuery]);

    useEffect(() => {
        setCurrentPage(1);
    }, [selectedPrefix]);

    const sortedRecords = useMemo(() => {
        return [...filteredRecords].sort((a, b) => {
            const aStarts = a.toLowerCase().startsWith(searchQuery.toLowerCase());
            const bStarts = b.toLowerCase().startsWith(searchQuery.toLowerCase());
            return bStarts - aStarts;
        });
    }, [filteredRecords, searchQuery]);

    const indexOfLastRecord = currentPage * recordsPerPage;
    const indexOfFirstRecord = indexOfLastRecord - recordsPerPage;
    const currentRecords = sortedRecords.slice(indexOfFirstRecord, indexOfLastRecord);

    const totalPages = Math.ceil(sortedRecords.length / recordsPerPage);




    const toTitleCase = (str) => {
        return str
            // Replace underscores or hyphens with spaces
            .replace(/[_-]/g, ' ')
            // Add space before capital letters (for camelCase)
            .replace(/([a-z])([A-Z])/g, '$1 $2')
            // Capitalize first letter of each word
            .replace(/\w\S*/g, (w) => w.charAt(0).toUpperCase() + w.slice(1).toLowerCase());
    };



    const handleSearchChange = (e) => {
        const input = e.target.value.trimStart(); // Remove leading spaces
        setSearchQuery(input);

        const pageNumber = parseInt(input, 10);

        // Check if input is a valid page number
        if (!isNaN(pageNumber) && pageNumber >= 1 && pageNumber <= totalPages) {
            paginate(pageNumber);
        }
    };



    const handleTabSwitch = (tab) => {
        if (tab !== activeTab) {
            // Preserve selectedTableName (do not reset)

            // Reset file and format related state
            setSelectedFormat(null);
            setSelectedCategory(null);
            setShowDownloadButton(false);
            setShowDropdown(false);
            setSelectedFile(null);
            setFile(null);
            setvalidErrorRecords([]);
            setShowPreview(false);
            setUploadStatus('');
            setPreviewData([]);
            setCurrentFile(null);
            setSelectedSheets([]);
            setJsonReportData([]);
            setFailureReportData([]);
            setSheetOptions([]);
            setShowSheetSelection(false);
            setColumnKeys([]);
            setSelectedNumericColumns([]);
            setModalMessage('');

            // Reset file input DOM
            if (fileInputRef.current) {
                fileInputRef.current.value = '';
            }

            // Optional: reset form related things
            setFormData1({});
            setErrors({});
            // setSelectedFileName('');
            // setPrefix('');
            setExactName('');
            // setSelectedName('');

            // Finally, switch tab
            setActiveTab(tab);
        }
    };




    const handleFormatSelection = (format, category) => {
        setSelectedFormat(format);
        setSelectedCategory(category);
        setShowDownloadButton(true);
        setShowDropdown(false);

        setSelectedFile(null);
        setFile(null);
        // setIsEactName('');
        setvalidErrorRecords([]);
        setShowPreview(false);
        setUploadStatus('');
        setPreviewData([]);
        setCurrentFile(null);
        setSelectedSheets([]);
        setJsonReportData([]);
        setFailureReportData([]);
        setSheetOptions([]);
        setShowSheetSelection(false);
        setColumnKeys([]);
        setSelectedNumericColumns([]);
        setModalMessage('');

        // Also reset file input DOM element
        if (fileInputRef.current) {
            fileInputRef.current.value = '';
        }
    };



    const handleFormatSelect = (format, category) => {
        setSelectedDownloadFormat(format);
        setSelectedCategory(category);
        setShowDropdown(false);

        // Optional full reset here too, if this also leads to upload
        setSelectedFile(null);
        setFile(null);
        // setIsEactName('');
        setvalidErrorRecords([]);
        setShowPreview(false);
        setUploadStatus('');
        setPreviewData([]);
        setCurrentFile(null);
        setSelectedSheets([]);
        setJsonReportData([]);
        setFailureReportData([]);
        setSheetOptions([]);
        setShowSheetSelection(false);
        setColumnKeys([]);
        setSelectedNumericColumns([]);
        setModalMessage('');

        if (fileInputRef.current) {
            fileInputRef.current.value = '';
        }
    };



    const handleCloseNoDataModal = () => setShowNoDataModal(false);


    useEffect(() => {
        if (columnDetails) {
            console.log("Column details updated:", columnDetails);
        }
    }, [columnDetails]);

    const tableDefaultValues = {

        Finance_return_on_equity: {
            frequency: "Quarterly",
            criticality: "Level 1",
            ownership: "Finance and Planning",
            risk_area: "Earnings and financial performance",
            risk_indicator: "Return on Equity (ROE)",
            definition: "ROE is a financial ratio that measures the performance of the Bank based on its average shareholders' equity outstanding."
        },

        HR_overall_saudization_rate: {
            frequency: "Quarterly",
            criticality: "Level 1",
            ownership: "Human Resources Group",
            risk_area: "People and Conduct Risk",
            risk_indicator: "Overall Saudization Rate (OSR)",
            definition: "The overall Saudization rate reflects compliance with local labor regulations and the bank’s commitment to nationalization objectives."
        }

    };

    const downloadTable = async (tableName, format) => {
        try {
            const config = {
                headers: {
                    userId: localStorage.getItem("userid"), 'x-csrf-token': csrfToken,
                },
                withCredentials: true,
                params: { tableName: selectedTableName },
            };

            await axios.post(bdmtablecolumns, {}, config);
            // const response = await fetch(`${PortURL}/downloads/${selectedTableName}_template.csv`);
            const response = await fetch(`/downloads/${selectedTableName}_template.csv`);
            const csvText = await response.text();

            let blob;
            let downloadFileName = `${tableName}.${format}`;

            if (format === "txt") {
                const tsvContent = csvText.replace(/,/g, "\t");
                blob = new Blob([tsvContent], { type: "text/plain" });
            }
            // else if (["xls", "xlsx", "xlsb", "xlsm"].includes(format)) {

            //     const workbook = XLSX.read(csvText, { type: "string" });

            //     const excelBuffer = XLSX.write(workbook, {
            //         bookType: format,
            //         type: "array"
            //     });

            //     blob = new Blob([excelBuffer], {
            //         type: "application/octet-stream"
            //     });
            // }

            else if (["xls", "xlsx", "xlsb", "xlsm"].includes(format)) {

                const workbookCSV = XLSX.read(csvText, { type: "string" });
                const sheetName = workbookCSV.SheetNames[0];
                const rows = XLSX.utils.sheet_to_json(
                    workbookCSV.Sheets[sheetName],
                    { header: 1 }
                );

                const header = rows[0];

                const defaults = tableDefaultValues[selectedTableName] || {};

                const defaultRow = header.map(col => {
                    const key = col.toLowerCase();
                    return defaults[key] || "";
                });

                const finalData = [header, defaultRow];

                const worksheet = XLSX.utils.aoa_to_sheet(finalData);
                const workbook = XLSX.utils.book_new();
                XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");

                const excelBuffer = XLSX.write(workbook, {
                    bookType: format,
                    type: "array"
                });

                blob = new Blob([excelBuffer], {
                    type: "application/octet-stream"
                });
            }
            else {
                blob = new Blob([csvText], { type: "text/csv" });
            }

            const link = document.createElement("a");
            link.href = URL.createObjectURL(blob);
            link.download = downloadFileName;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);

        } catch (error) {
            console.error("Error downloading table:", error);
        }
    };

    const handleBrowseClick = async () => {
        // event.preventDefault();
        fileInputRef.current.click(); // Trigger file input click
        setShowModal(false); // Close modal if open

        try {
            const config = {
                headers: {
                    "userId": localStorage.getItem('userid'), 'x-csrf-token': csrfToken,
                },
                withCredentials: true,
                params: { "tableName": selectedTableName }
            };

            const apiResponse = await axios.post(checksumAPI, {}, config);
            if (apiResponse.status !== 200) {
                setShowErrorModal(false);
                return;
            }

            const responseData = apiResponse.data;
            console.log("API Response Data:", responseData);
            setColumnDetails(responseData);

            // Fetch dropdown file
            //   const responsefromFile = await fetch(`${PortURL}/demformtemplate/${selectedTableName}.json`);
            const responsefromFile = await fetch(`/demformtemplate/${selectedTableName}.json`);

            if (!responsefromFile.ok) {
                console.error("Error fetching JSON file. Response:", responsefromFile);
                throw new Error("Template file is not available");
            }

            const responsetxt = await responsefromFile.json();

            if (!responsetxt || !responsetxt.details) {
                console.error("Error: JSON file does not contain 'details'");
            } else {
                setcolumnDropdown(responsetxt);
                console.log("columnDropdown is now set:", responsetxt);
            }

        } catch (error) {
            console.error("Error during file validation:", error);
            handleError(`Error validating file: ${error.message}`);
        }
    };


    const handlePreviewOption = () => {

        // Ensure preview happens only if there are no errors and file is valid
        if (previewData.length > 0) {
            setShowPreview(true);
            setShowModal(true);
        } else {
            console.log("File has errors or no data available, showing NoDataModal");
            setShowNoDataModal(true);
        }
    };




    const handleError = (message) => {
        setErrorModalMessage(message);
        setShowErrorModal(true);
        setIsUploadAllowed(true); // Allow upload even if there's an error
    };

    const handleCloseErrorModal = () => {
        setShowErrorModal(false);
        setUploadStatus('');
        setIsUploadAllowed(true);
    };

    const validateDropdownValues = async (csvData, fileResponse) => {
        const totalRows = csvData.rows.length - 1; // Exclude header
        const batchSize = 25000; // Major batch splitting
        const totalBatches = Math.ceil(totalRows / batchSize);

        let invalidEntries = {};
        let invalidPositions = new Set();
        let lengthExceededColumns = {};
        let missingDataColumns = {};
        let errorMap = new Map();

        if (!fileResponse?.details?.length) {
            console.warn("JSON file missing 'details', skipping validation.");
            return true;
        }

        const dropdownColumns = {};
        const columnLengths = {};
        const columnTypes = {};
        const columnKeys = {};

        const dateColumnIndices = [];
        const intColumnIndices = [];
        const decimalColumnIndices = [];
        const booleanColumnIndices = [];
        const doubleColumnIndices = [];
        const characterColumnIndices = [];
        const floatColumnIndices = [];

        fileResponse.details.forEach((col, idx) => {
            const key = col.columnName.trim().toLowerCase();
            columnTypes[key] = col.columnType?.toLowerCase();
            columnKeys[key] = col.columnKey?.toLowerCase();

            if (typeof col.columnFunction === 'string') {
                const dropdownMatch = col.columnFunction.match(/dropdown:\[(.*?)\]/i);
                if (dropdownMatch) {
                    dropdownColumns[key] = dropdownMatch[1].split(",").map(val => val.trim().toUpperCase()).filter(Boolean);
                }
            }

            if (col.columnLength) {
                if (typeof col.columnLength === 'string' && col.columnLength.includes(',')) {
                    const [precision, scale] = col.columnLength.split(',').map(num => parseInt(num.trim(), 10));
                    columnLengths[key] = { precision, scale };
                } else {
                    columnLengths[key] = parseInt(col.columnLength, 10);
                }
            }

            switch (col.columnType?.toLowerCase()) {
                case "date": dateColumnIndices.push(idx); break;
                case "integer": intColumnIndices.push(idx); break;
                case "decimal": decimalColumnIndices.push(idx); break;
                case "float": floatColumnIndices.push(idx); break;
                case "boolean": booleanColumnIndices.push(idx); break;
                case "double": doubleColumnIndices.push(idx); break;
                case "character": characterColumnIndices.push(idx); break;
            }
        });

        const parsedRows = new Map();

        // ✨ New internal chunk-based validateBatch

        // Expected headers from template
        const expectedHeaders = fileResponse.details.map(col =>
            col.columnName.trim().toLowerCase()
        );

        // Actual uploaded headers
        const uploadedHeaders = csvData.headers.map(h =>
            h.trim().toLowerCase()
        );

        // Find missing headers
        const missingHeaders = expectedHeaders.filter(
            h => !uploadedHeaders.includes(h)
        );

        console.log("Missing Headers:", missingHeaders);



        const processErrorsBatch = async (start, end) => {
            const batchErrors = [];
            const primaryKeyColumns = Object.keys(columnKeys).filter(k => columnKeys[k] === "primary key");

            const chunkSize = totalRows > 100000 ? 1000 : totalRows > 50000 ? 2000 : 5000;
            const dateFormatRegex = /^\d{4}-\d{2}-\d{2}$/;
            const exponentialRegex = /^[+-]?\d+(\.\d+)?[eE][+-]?\d+$/;

            const uniqueRows = new Map();
            const duplicateEntries = [];

            for (let i = start; i < end; i += chunkSize) {
                const chunkEnd = Math.min(i + chunkSize, end);

                for (let rowIndex = i; rowIndex < chunkEnd; rowIndex++) {
                    const row = csvData.rows[rowIndex + 1];
                    if (!parsedRows.has(rowIndex)) {
                        const matches = [...row.matchAll(/(?<=^|,)(?:"([^"]*)"|([^,]*))(?=,|$)/g)].map(m => m[1] ?? m[2] ?? '');
                        parsedRows.set(rowIndex, matches);
                    }
                    const matches = parsedRows.get(rowIndex);

                    const lineNumber = rowIndex + 1;
                    const errorMessages = [];

                    // Duplicate entry check
                    const cleanedRow = row.trim();
                    // const primaryKeyValues = primaryKeyColumns.map(pk => matches[csvData.headers.indexOf(pk)]).join(",");

                    const primaryKeyValues = primaryKeyColumns.map((pk) => {
                        const colIndex = csvData.headers.indexOf(pk);
                        if (colIndex === -1) {
                            return `${pk} (header missing)`;
                        }

                        const value = matches[colIndex]?.trim();
                        if (!value) {
                            return `Column ${colIndex + 1}`;
                        }

                        return value;
                    }).join(", ");

                    if (uniqueRows.has(cleanedRow)) {
                        errorMessages.push(`Duplicate entry found for primary key: ${primaryKeyValues}.`);
                    } else {
                        uniqueRows.set(cleanedRow, primaryKeyValues);
                    }

                    // Loop through columns and perform validations
                    csvData.headers.forEach((header, columnIndex) => {
                        const columnName = header.trim().toLowerCase();
                        let cellValue = matches[columnIndex]?.trim() || '';

                        // Invalid value check (dropdown)
                        if (dropdownColumns[columnName] && !dropdownColumns[columnName].includes(cellValue.toUpperCase())) {
                            errorMessages.push(`Column '${columnName}' has invalid dropdown value '${cellValue}'.`);
                        }

                        // Required field check (Primary key or Not null)
                        // if ((columnKeys[columnName] === 'primary key' || columnKeys[columnName] === 'not null') && !cellValue) {
                        //   errorMessages.push(`Column '${columnName}' is required but missing.`);
                        // }


                        // Column length check
                        if (columnLengths[columnName]) {
                            const maxLen = columnLengths[columnName];
                            const formatted = cellValue.replace(/\(([^)]+)\)/g, "-$1");
                            const actualLength = formatted.length;

                            if (typeof maxLen === 'object') {
                                const { precision, scale } = maxLen;
                                const [intPart, decPart = ''] = formatted.replace(/[^\d.]/g, '').split('.');
                                const totalDigits = intPart.length + decPart.length;
                                if (totalDigits > precision || decPart.length > scale) {
                                    errorMessages.push(`Column '${columnName}' exceeds precision/scale.`);
                                }
                            } else if (actualLength > maxLen) {
                                errorMessages.push(`Column '${columnName}' exceeds length ${maxLen}.`);
                            }
                        }

                        // Check for column type mismatch (based on expected type)
                        const detectedFormat = detectValueFormat(cellValue).toLowerCase();
                        let expectedType = getColumnTypeFromDetails(columnName.toLowerCase());

                        // Exponential value validation (specific columns)
                        if (exponentialRegex.test(cellValue)) {
                            let columnType = "unknown";
                            if (columnDetails?.double_columns?.[0]?.col_name.some(col => col.toLowerCase() === columnName)) {
                                columnType = "double";
                            } else if (columnDetails?.decimal_columns?.[0]?.col_name.some(col => col.toLowerCase() === columnName)) {
                                columnType = "decimal";
                            } else if (columnDetails?.float_columns?.[0]?.col_name.some(col => col.toLowerCase() === columnName)) {
                                columnType = "float";
                            } else if (columnDetails?.int_columns?.[0]?.col_name.some(col => col.toLowerCase() === columnName)) {
                                columnType = "int";
                            } else if (columnDetails?.varchar_columns?.[0]?.col_name.some(col => col.toLowerCase() === columnName)) {
                                columnType = "varchar";
                            } else if (columnDetails?.number_columns?.[0]?.col_name.some(col => col.toLowerCase() === columnName)) {
                                columnType = "number";
                            } else if (columnDetails?.boolean_columns?.[0]?.col_name.some(col => col.toLowerCase() === columnName)) {
                                columnType = "boolean";
                            } else if (columnDetails?.date_columns?.[0]?.col_name.some(col => col.toLowerCase() === columnName)) {
                                columnType = "date";
                            }

                            if (!["double", "decimal", "float"].includes(columnType)) {
                                errorMessages.push(`Column '${columnName}' contains an Exponential value '${cellValue}' which is not allowed.`);
                            }
                        }

                        if ((columnKeys[columnName] === 'primary key' || columnKeys[columnName] === 'not null') && !cellValue) {
                            errorMessages.push(`Column '${columnName}' is required but missing.`);
                        }
                        // Check for specific column type mismatches
                        if (cellValue !== "") {
                            if (expectedType === "int") {
                                if (detectValueFormat(cellValue) !== "int") {
                                    errorMessages.push(`Column '${columnName}' should be Integer but found: ${cellValue}`);
                                }

                            }
                            else if (["decimal", "double", "float", "number"].includes(expectedType)) {
                                let sanitized = cellValue.replace(/-\s+/g, '-').replace(/,/g, '');

                                if (/^\(\d+(\.\d+)?\)$/.test(sanitized)) {
                                    sanitized = '-' + sanitized.replace(/[()]/g, '');
                                }
                                const numericValue = Number(sanitized);

                                if (isNaN(numericValue) || cellValue.trim() === "") {
                                    errorMessages.push(`Column '${columnName}' should be a valid number but found: ${cellValue}`);
                                }


                            } else if (expectedType === "date") {
                                if (detectValueFormat(cellValue) !== "date") {
                                    errorMessages.push(`Column '${columnName}' should be in YYYY-MM-DD format but found: ${cellValue}`);
                                }
                            } else if (expectedType === "boolean") {
                                if (detectValueFormat(cellValue) !== "boolean") {
                                    errorMessages.push(`Column '${columnName}' should be true or false but found: ${cellValue}`);
                                }
                            }
                            // varchar: allow any value (no check)
                        }
                    });

                    // Add errors for this row if there are any
                    if (errorMessages.length > 0) {
                        // batchErrors.push(`${lineNumber}|${primaryKeyValues}|${errorMessages.join(' # ')}`);
                        batchErrors.push(`${primaryKeyValues}|Error at Line ${lineNumber}:# ${errorMessages.join(' # ')}`);
                    }
                }
            }

            // Process duplicate entries after batch validation
            if (duplicateEntries.length > 0) {
                duplicateEntries.forEach(({ primaryKeyValues, lineNumber }) => {
                    // batchErrors.push(`${primaryKeyValues}|Error at Line ${lineNumber}: # Duplicate entry found.`);
                    batchErrors.push(`${primaryKeyValues}|Error at Line ${lineNumber}: Duplicate entry found.`);

                });
            }

            return batchErrors;
        };


        const validationPromises = [];
        for (let batchIndex = 0; batchIndex < totalBatches; batchIndex++) {
            const start = batchIndex * batchSize;
            const end = Math.min((batchIndex + 1) * batchSize, totalRows);
            validationPromises.push(processErrorsBatch(start, end)); // Run batches in parallel
        }


        let allErrors = [];
        // Collect errors as batches finish
        const results = await Promise.all(validationPromises);

        results.forEach(batchErrors => {
            if (batchErrors.length > 0) {
                allErrors.push(...batchErrors);
                setErrorMessages(prev => [...(prev || []), ...batchErrors]); // Progressive UI updates
            }
        });


        // const sortedErrors = allErrors.sort((a, b) => parseInt(a.split('|')[0]) - parseInt(b.split('|')[0]));
        const sortedErrors = allErrors.sort((a, b) => parseInt(a.split('|')[1]) - parseInt(b.split('|')[1]));


        if (sortedErrors.length > 0) {
            setErrorMessages(sortedErrors); // Final sorted version
            setIsUploadAllowed(true);
            setvalidErrorRecords(sortedErrors);
            // downloadErrorsAsPDF(sortedErrors)
            console.error("Validation Errors:", sortedErrors);
        } else {
            console.log('No validation errors found!');
        }

        const errorLineNumbers = new Set(
            sortedErrors.map(error => {
                // Extract line number from error message
                const parts = error.split('|');
                const linePart = parts[1]; // Error at Line 3: ...
                const match = linePart.match(/Line (\d+)/);
                return match ? parseInt(match[1], 10) : null;
            }).filter(num => num !== null)
        );

        // Now, collect all valid rows
        const validRows = [];

        for (let rowIndex = 0; rowIndex < totalRows; rowIndex++) {
            const lineNumber = rowIndex + 1;
            if (!errorLineNumbers.has(lineNumber)) {
                validRows.push(csvData.rows[lineNumber]); // Note: rows[0] is usually header
            }
        }

        // Now, format valid rows

        const formattedValidRecords = validRows
            .map(row => {

                const regex = /(?<=^|,)(?:"([^"]*)"|([^,]*))(?=,|$)/g;
                const matches = [...row.matchAll(regex)].map(m => m[1] ?? m[2] ?? '');

                // Convert row into object for easy lookup
                const rowObject = {};
                csvData.headers.forEach((header, index) => {
                    rowObject[header.trim().toLowerCase()] = matches[index]?.trim() || '';
                });

                // Now build full row based on expected template order
                return expectedHeaders.map(columnName => {

                    let value = rowObject[columnName] ?? '';  // If missing → empty

                    const colType = columnTypes[columnName];
                    const colKey = columnKeys[columnName];

                    // Handle negative bracket numbers
                    if (value.startsWith('(') && value.endsWith(')')) {
                        value = `-${value.slice(1, -1)}`;
                    }

                    value = value.replace(/,/g, '');

                    // 🔹 If column completely missing in CSV
                    if (!uploadedHeaders.includes(columnName)) {

                        if (colKey === 'primary key') {
                            return 'DUMMY_PK';   // 🔥 your dummy primary key value
                        }

                        if (['decimal', 'double', 'float', 'integer'].includes(colType)) {
                            return '0';          // numeric dummy
                        }

                        if (colType === 'date') {
                            return '1900-01-01'; // default date
                        }

                        if (colType === 'boolean') {
                            return 'false';
                        }

                        return 'N/A';            // varchar dummy
                    }

                    // 🔹 If value empty but allowed nullable numeric/date
                    if (
                        !value &&
                        (!colKey || colKey === 'null') &&
                        ['decimal', 'double', 'float', 'date'].includes(colType)
                    ) {
                        return '\\N';
                    }

                    return value;
                }).join('|');
            })
            .join('\n');

        // Save final valid records
        setvalidRecords(formattedValidRecords);



        return true;
    };

    const downloadErrorsAsPDF = (errors = [], metadata = {}) => {
        const doc = new jsPDF({ orientation: 'landscape', unit: 'mm', format: 'a4' });

        const userId = localStorage.getItem('userid') || 'Unknown User';
        const createdDate = new Date().toLocaleString();

        // Title
        doc.setFontSize(16);
        doc.setFont('helvetica', 'bold');
        doc.text('Data Validation Report', doc.internal.pageSize.getWidth() / 2, 20, { align: 'center' });

        // Metadata
        doc.setFontSize(11);
        doc.setFont('helvetica', 'normal');
        let metaY = 30;
        doc.text(`TableName: ${selectedFileName}`, 14, metaY);
        doc.text(`Created By: ${userId}`, 14, metaY + 7);
        doc.text(`Created Date: ${createdDate}`, 14, metaY + 14);

        // Early return if no errors
        if (!Array.isArray(errors) || errors.length === 0) {
            doc.text('No validation errors found.', 14, metaY + 28);
            doc.save('validation_errors.pdf');
            return;
        }

        // Table body
        const tableBody = errors.map((error, index) => {
            const [primaryKey, rawMessage = ''] = error.split('|');
            const messages = rawMessage
                .split('#')
                .map(m => m.trim())
                .filter(Boolean)
                .join('\n');

            return [index + 1, primaryKey?.trim(), messages];
        });

        // Draw table
        doc.autoTable({
            startY: metaY + 25,
            head: [['S.No', 'Row Identifier', 'Message']],
            body: tableBody,
            styles: {
                fontSize: 11,
                valign: 'top',
                cellWidth: 'wrap',
                lineWidth: 0.1,
                lineColor: [0, 0, 0],
                textColor: [0, 0, 0],
            },
            columnStyles: {
                0: { cellWidth: 20 },
                1: { cellWidth: 60 },
                2: { cellWidth: 160 },
            },
            headStyles: {
                fillColor: [0, 123, 255],
                textColor: 255,
                fontSize: 14,
                fontStyle: 'bold',
                halign: 'center',
                valign: 'middle',
            },
        });

        doc.save(`${userId}_${selectedName}.pdf`);

    };


    console.log("just for funn ------------- " + validRecords);

    function detectValueFormat(value) {
        if (!value || value.trim() === "") return "empty"; // Empty check first

        const lowerValue = value.toLowerCase();
        if (["true", "false"].includes(lowerValue)) return "boolean"; // Boolean check

        const dateRegex = /^\d{4}-\d{2}-\d{2}$/;
        if (dateRegex.test(value)) return "date"; // Strict date format (YYYY-MM-DD)

        // Number checks
        if (!isNaN(value)) {
            if (/^[+-]?\d+$/.test(value)) return "int"; // Exact integer
            if (/^[+-]?\d*\.\d+$/.test(value)) return "decimal"; // Decimal (non-integer)
            if (/^[+-]?\d+(\.\d+)?[eE][+-]?\d+$/.test(value)) return "exponential"; // Exponential number
        }

        return "string"; // Default fallback
    }


    // const getColumnTypeFromDetails = async (columnName) => {
    function getColumnTypeFromDetails(columnName) {
        // Loop through column types in columnDetails
        const columnTypes = [
            { type: "int", key: "int_columns" },
            { type: "decimal", key: "decimal_columns" },
            { type: "date", key: "date_columns" },
            { type: "double", key: "double_columns" },
            { type: "varchar", key: "varchar_columns" },
            { type: "number", key: "number_columns" },
            { type: "float", key: "float_columns" }
        ];

        for (const { type, key } of columnTypes) {
            if (columnDetails?.[key]?.some(col => col.col_name.includes(columnName))) {
                return type;
            }
        }
        return "string"; // Default if not found
    }



    const toProperCase = (str) =>
        str.replace(/\w\S*/g, (txt) => txt.charAt(0).toUpperCase() + txt.slice(1).toLowerCase());

    const convertCsvToTxt = async (file, fileResponse, validRecords) => {
        const startTime1 = Date.now();
        console.log("Start Time:", new Date(startTime1).toLocaleTimeString());
        return new Promise(async (resolve, reject) => {
            const reader = new FileReader();
            const dateFormatRegex = /^\d{4}-\d{2}-\d{2}$/;
            // const exponentialRegex = /^[+-]?\d+(\.\d+)?[eE][+-]?\d+$/;

            reader.onload = async (event) => {
                const csvContent = event.target.result;
                // const rows = csvContent.split('\n').filter(row => row.trim() !== '');

                const preprocessed = csvContent.replace(/"([^"]*)"/gs, (match, group) => {
                    // collapse CR/LF inside quoted fields into spaces
                    return '"' + group.replace(/[\r\n]+/g, ' ') + '"';
                });

                console.log("Preprocessed CSV Content:", preprocessed);
                const rows = preprocessed
                    .split(/\r?\n/)
                    .filter(row => row.trim() !== '');

                const count = rows.length > 1 ? rows.length - 1 : 0;
                console.log("recordsCount inside onload:", count);
                // setRecordsCount(count);


                console.log("all the rows", rows);

                if (rows.length === 0) {
                    setShowNoDataModal(true);
                    setIsUploadAllowed(false);
                    return reject(new Error('No content in file'));
                }

                const headerLine = rows[0];
                const commaCount = (headerLine.match(/,/g) || []).length;
                const tabCount = (headerLine.match(/\t/g) || []).length;
                const delimiter = tabCount > commaCount ? '\t' : ',';

                // Now use the detected delimiter
                // const headers = headerLine.split(delimiter).map(header => header.trim().toLowerCase());
                const headers = headerLine
                    .split(delimiter)
                    .map(header => header.trim().toLowerCase()); // normalize to lowercase
                const csvData = { headers, rows };
                const isValid = await validateDropdownValues(csvData, fileResponse);
                if (!isValid) {
                    // return;
                    return reject(new Error("Invalid dropdown values found"));

                }
                const expectedOrderedColumns = columnDropdown?.details?.map(col => col.columnName.toLowerCase().trim()) || [];

                const allowedColumns = [
                    ...(columnDetails.int_columns?.[0]?.col_name || []),
                    ...(columnDetails.datetime_columns?.[0]?.col_name || []),
                    ...(columnDetails.date_columns?.[0]?.col_name || []),
                    ...(columnDetails.varchar_columns?.[0]?.col_name || []),
                    ...(columnDetails.char_columns?.[0]?.col_name || []),
                    ...(columnDetails.double_columns?.[0]?.col_name || []),
                    ...(columnDetails.decimal_columns?.[0]?.col_name || []),
                    // ...(columnDetails.numeric_columns?.[0]?.col_name || []),
                    ...(columnDetails.number_columns?.[0]?.col_name || []),
                    ...(columnDetails.float_columns?.[0]?.col_name || []),
                    ...(columnDetails.boolean_columns?.[0]?.col_name || []),
                ].map(col => col.toLowerCase().trim());

                // Check if all headers are allowed
                const invalidHeaders = headers.filter(
                    (header) => !allowedColumns.includes(header.toLowerCase().trim())
                );

                // Identify misspelled or missing columns
                const invalidColumns = headers.filter(header => !allowedColumns.includes(header));
                const missingColumns = allowedColumns.filter(col => !headers.includes(col));

                let errorMessages = [];
                let errorCount = 1; // Initialize error counter
                const hasInvalidColumns = invalidColumns.length > 0;
                const hasMissingColumns = missingColumns.length > 0;


              //  Handle invalid columns
                if (hasInvalidColumns) {
                    invalidColumns.forEach((col) => {
                        const columnDisplay = col?.trim() ? col : ' '; // fallback label
                        const message = `COLUMN_NAME <strong>${columnDisplay}</strong> is Misspelled in the Uploaded Data File`;
                        errorMessages.push(hasMissingColumns ? `${errorCount}. ${message}\n` : message);
                        if (hasMissingColumns) errorCount++; // Increment only if both errors exist
                    });
                }


              //  Handle missing columns
                if (hasMissingColumns) {
                    missingColumns.forEach((col) => {
                        const message = `COLUMN_NAME <strong>${col}</strong> is Missing in the Uploaded Data File`;
                        errorMessages.push(hasInvalidColumns ? `${errorCount}. ${message}\n` : message);
                        if (hasInvalidColumns) errorCount++; // Increment only if both errors exist
                    });
                }

                const toProperCase = (str) =>
                    typeof str === 'string'
                        ? str.replace(/\w\S*/g, (txt) => txt.charAt(0).toUpperCase() + txt.slice(1).toLowerCase())
                        : '';

                let hasOrderMismatch = false;
                const orderMismatchMessages = [];

                if (!hasInvalidColumns && !hasMissingColumns) {
                    headers.forEach((actualHeader, actualIndex) => {
                        const expectedHeader = expectedOrderedColumns[actualIndex];
                        if (actualHeader.toLowerCase().trim() !== expectedHeader) {
                            hasOrderMismatch = true;
                            orderMismatchMessages.push(
                                `Expected <strong>${toProperCase(expectedHeader)}</strong> column at position <strong>${actualIndex + 1}</strong>.`
                            );
                        }
                    });
                }

                if (hasOrderMismatch) {
                    errorMessages.push(...orderMismatchMessages);
                }

                if (errorMessages.length > 0) {
                    setModalMessage(errorMessages.join('<br/>'));
                    console.log("Column mismatch errors:\n", errorMessages.join("\n"));
                    setIsUploadAllowed(false);
                    return reject(new Error(errorMessages.join("\n")));
                }


                // Show the error messages if there are any invalid or missing columns
                if (errorMessages.length > 0) {
                    setModalMessage(errorMessages.join("")); // Ensuring new line separation
                    console.log("Invalid or missing columns:\n", errorMessages.join(""));
                    setIsUploadAllowed(false);
                    // return;
                    return reject(new Error(errorMessages.join("")));

                }

                const isDropdownValid = await validateDropdownValues(csvData, columnDropdown);
                if (!isDropdownValid) {
                    setShowModal(false);  // Ensure preview modal is hidden
                    await new Promise(resolve => setTimeout(resolve, 0)); // Ensure state updates properly
                    setShowErrorModal(true);
                    setIsUploadAllowed(false);
                    // return;
                    return reject(new Error("Invalid dropdown value found"));

                }

                const fileTableName = selectedName;  // This is the name of the file selected by the user

                // Convert both file names to lowercase for case-insensitive comparison
                if (fileTableName.toLowerCase() !== selectedName.toLowerCase()) {
                    setErrorModalMessage(`Table name in the file (${fileTableName}) does not match the expected table name (${selectedName}).`);
                    setShowErrorModal(true);
                    setIsUploadAllowed(false);
                    return reject(new Error(`Table name mismatch: ${fileTableName}`));
                }

                const intColumnIndices = columnDetails?.int_columns?.map(col => headers.indexOf(col.col_name)) || [];
                const decimalColumnIndices = columnDetails?.decimal_columns?.map(col => headers.indexOf(col.col_name)) || [];
                const floatColumnIndices = columnDetails?.float_columns?.map(col => headers.indexOf(col.col_name)) || [];
                const doubleColumnIndices = columnDetails?.double_columns?.map(col => headers.indexOf(col.col_name)) || [];
                const characterColumnIndices = headers.map((col, index) =>
                    !intColumnIndices.includes(index) && !doubleColumnIndices.includes(index) && !decimalColumnIndices.includes(index) && !floatColumnIndices.includes(index) ? index : null
                ).filter(index => index !== null);


                const txtContent = rows.slice(1).map(row => {
                    // Updated regex to correctly handle quoted values with commas inside them
                    const regex = delimiter === ','
                        ? /(?<=^|,)(?:"([^"]*)"|([^,]*))(?=,|$)/g
                        : /(?<=^|\t)(?:"([^"]*)"|([^\t]*))(?=\t|$)/g;

                    // Match all cells (quoted and unquoted)
                    const matches = [...row.matchAll(regex)].map(match => match[1] ?? match[2] ?? '');

                    // Process each column value
                    return matches.map((value, index) => {
                        value = value.trim();

                        // Keep date columns unchanged
                        // if (dateColumnIndices.includes(index)) {
                        //     return value;
                        // }

                        if (dateColumnIndices.includes(index) && value) {
                            return value;   // valid date → return as-is
                        }

                        // **Convert (1254) to -1254**
                        if (value.startsWith('(') && value.endsWith(')')) {
                            value = `-${value.slice(1, -1)}`; // Remove parentheses and add minus
                        }

                        // Remove thousand separators (,) inside numbers, only if they are not quoted
                        if (!value.startsWith('"') && !value.endsWith('"')) {
                            value = value.replace(/,/g, ''); // Converts "599,446" → "599446"
                        }

                        return value;
                    }).join('|');
                }).join('\n');

                const finalTxtContent = txtContent + '\n';
                setFinalilizedContent(finalTxtContent);

                setPreviewData(rows);
                setIsUploadAllowed(true);
                resolve(finalTxtContent);
                const endTime1 = Date.now();
                console.log("Stop Time:", new Date(endTime1).toLocaleTimeString());

            };

            reader.onerror = () => {
                setIsUploadAllowed(false);
                // setFile(null);
                reject(new Error('Error reading file'));
            };

            reader.readAsText(file);
        });
    };


    useEffect(() => {
        if (validErrorRecords.length > 0) {
            setModalMessage('Bulk Upload Process Failed.\nCheck the detailed Error(s) in <strong>Data Validation Report</strong>');
            setMessageType('danger');
            setShowModal(true);
            setShowPreview(false);
            // setPreviewData(false);
        }

    }, [validErrorRecords]);


    const calculateColumnSum = (rows, columnNames, headers) => {
        const normalizeColumnName = (name) => name.replace(/\s+/g, "").toLowerCase(); // Remove spaces & lowercase

        const columnSums = {};
        const columnCounts = {};

        // Normalize column names for comparison
        const normalizedColumnNames = columnNames.map(normalizeColumnName);

        // Create a mapping of normalized headers to actual headers
        const normalizedHeaders = headers.reduce((acc, header, index) => {
            acc[normalizeColumnName(header)] = index; // Store index of each normalized header
            return acc;
        }, {});

        // Initialize sums and counts for all numeric columns
        normalizedColumnNames.forEach((col) => {
            columnSums[col] = 0;
            columnCounts[col] = 0;
        });

        rows.forEach((row) => {
            const regex = /(?<=^|,)(?:"([^"]*)"|([^,]*))(?=,|$)/g; // Proper CSV parsing
            const rowData = [...row.matchAll(regex)].map(match => match[1] ?? match[2] ?? "").map(cell => cell.trim());

            normalizedColumnNames.forEach((colName) => {
                const colIndex = normalizedHeaders[colName]; // Get correct index

                if (colIndex !== undefined) {
                    let value = rowData[colIndex] || "0";

                    // Convert negative values in parentheses, remove commas
                    // value = value.replace(/\(([^)]+)\)/, "-$1").replace(/,/g, "");
                    value = value.replace(/-\s+/g, '-').replace(/\(([^)]+)\)/, "-$1").replace(/,/g, "");

                    let numericValue = parseFloat(value);

                    if (!isNaN(numericValue)) {
                        columnSums[colName] += numericValue;
                        columnCounts[colName] += 1;
                    }
                }
            });
        });

        return { columnSums, columnCounts };
    };


    const handlePreview = () => {
        const normalizeColumnName = (name) => name.replace(/\s+/g, "").toLowerCase(); // Normalize column names

        // Normalize database column names and create a mapping
        const dbColumnNames = [
            ...(columnDetails.int_columns?.[0]?.col_name || []),
            ...(columnDetails.double_columns?.[0]?.col_name || []),
            ...(columnDetails.decimal_columns?.[0]?.col_name || []),
            ...(columnDetails.float_columns?.[0]?.col_name || [])
        ];

        const normalizedDbColumns = dbColumnNames.reduce((acc, col) => {
            acc[normalizeColumnName(col)] = col; // Store mapping of normalized -> original
            return acc;
        }, {});

        // Normalize headers and map to the correct DB column
        const headers = previewData[0]
            ?.split(',')
            .map((header) => normalizeColumnName(header)) || [];

        // Convert uploaded column names to match DB names if possible
        const matchedHeaders = headers.map((header) => normalizedDbColumns[header] || header);

        const dataRows = previewData.slice(1, previewLimit + 1); // Exclude header row


        return calculateColumnSum(dataRows, Object.keys(normalizedDbColumns), matchedHeaders);
    };

    const { columnSums, columnCounts } = handlePreview();

    const anotherFunction = (event) => {
        const selectedFiles = event.target.files;
        const filenames = Array.from(selectedFiles).map((file) => file.name).join("\n");
        setEactName(filenames); // Update the state with all filenames
        // setExactFileType(Customfilename.type);  // This can also be updated to store file types if needed
    };

    const convertPreviewDataToTxt = (previewData) => {
        return new Promise((resolve, reject) => {
            try {
                // Ensure previewData is an array with at least one element
                if (!Array.isArray(previewData) || previewData.length === 0) {
                    return reject(new Error('Preview data is empty or invalid.'));
                }

                // Extract headers and validate
                const headers = previewData[0];
                if (typeof headers !== 'string') {
                    return reject(new Error('Headers must be a string.'));
                }

                const headerArray = headers.split(',').map((value) => value.trim());
                if (!headerArray || headerArray.length === 0) {
                    return reject(new Error('No valid headers found in preview data.'));
                }

                // Extract rows and validate
                const rows = previewData.slice(1);
                if (!rows || rows.length <= 1) {
                    return reject(new Error('No data rows found in preview data.'));
                }

                // Convert rows to pipe-separated format
                const txtContent = previewData.slice(1)
                    .map((row) => {
                        if (typeof row !== 'string') {
                            throw new Error('Row data must be a string.');
                        }

                        // Use regex to split while preserving quoted values
                        const regex = /"(.*?)"|([^,]+)/g;
                        const matches = [...row.matchAll(regex)].map(match => match[1] ?? match[2]);

                        return matches.map(value => value.trim()).join('|');
                    })
                    .join('\n');

                resolve(txtContent);
            } catch (error) {
                reject(error);
            }
        });
    };



    const handleFileChange1 = async (event) => {
        setvalidErrorRecords([]);
        const files = event.target.files;
        const selectedFile1 = files[0];

        setExactName(selectedFile1?.name || '');


        // Check if any file is selected
        if (!files || files.length === 0) {
            setUploadStatus('No file selected.');
            setSelectedFile(null);
            setFile(null);
            return;
        }

        const selectedFile = files[0];
        const fileType = selectedFile.type;
        const fileName = selectedFile.name.toLowerCase();
        const fileExtension = fileName.split('.').pop();

        // Validate format based on selectedFormat
        if (selectedFormat === "Microsoft Excel" && fileExtension !== 'pdf') {
            setFileSelectionMessage("Only PDF files are allowed for Pdf format.");
            setShowFileSelectionModal(true);
            setSelectedFile(null);
            setFile(null);
            return;
        }

        if (selectedFormat === "Image Files" && fileExtension !== 'txt') {
            setFileSelectionMessage("Only TXT files are allowed for Txt File format.");
            setShowFileSelectionModal(true);
            setSelectedFile(null);
            setFile(null);
            return;
        }

        if (selectedFormat === "Text Files" && fileExtension !== 'jpg') {
            setFileSelectionMessage("Only jpg format files are alowed for Image File format.");
            setShowFileSelectionModal(true);
            setSelectedFile(null);
            setFile(null);
            return;
        }

        // Proceed with valid file
        setSelectedFile(selectedFile);
        setSelectedName(selectedFile.name);
        const nameWithoutExtension = selectedFile.name.replace(/\.[^/.]+$/, '');
        setSelectedName(nameWithoutExtension);

        try {
            setLoading(true);
            setErrMsg('');
            setIsUploadAllowed(true); // Reset the flag before processing


            if (fileExtension === 'csv') {
                const fileNameWithoutExtension = selectedFile.name.replace('.csv', '').toLowerCase();
                const normalizedTableName = selectedName.toLowerCase();

                if (fileNameWithoutExtension !== normalizedTableName) {
                    setFileSelectionMessage(`The file name must match the table name: ${selectedName}.`);
                    setShowFileSelectionModal(true);
                    setSelectedFile(null);
                    setFile(null);
                    return;
                }

                const processedContent = await convertPreviewDataToTxt(selectedFile);
                const processedFile = new File([processedContent], `${selectedName}.txt`, {
                    type: 'text/plain',
                });
                setFile(processedFile);
            } else {
                const renamedFile = new File([selectedFile], `${selectedName}.${fileExtension}`, {
                    type: selectedFile.type,
                });
                setFile(renamedFile);
            }

            setUploadStatus('');
        } catch (error) {
            console.error('Error processing file:', error.message);
            setUploadStatus('Error processing file.');
            setIsUploadAllowed(true);
        } finally {
            setLoading(false);
        }
    };



    const handleFileChange = async (event, columnKeys) => {
        setvalidErrorRecords([]);
        const files = event.target.files;

        if (!files || files.length === 0) {
            setUploadStatus("No file selected.");
            return;
        }


        const selectedFiles = Array.from(files);
        let combinedCsvContent = ""; // Store combined content
        let columnHeaders = null; // For consistent column headers
        let mergedFileNames = []; // Store original file names

        for (const file of selectedFiles) {
            // const validExtensions = [".csv", ".tsv", ".txt", ".psv", ".xls", ".xlsx"];
            const validExtensions = [".csv", ".tsv", ".txt", ".psv", ".xls", ".xlsx", ".doc", ".docx"];
            const fileExtension = file.name.split(".").pop().toLowerCase();

            if (!validExtensions.includes(`.${fileExtension}`)) {
                setFileSelectionMessage(
                    `${file.name} - Only CSV, TSV, PSV, TXT, XLS, and XLSX files are allowed.`
                );
                setShowFileSelectionModal(true);
                return;
            }


            if (["doc", "docx"].includes(fileExtension)) {
                if (fileExtension === "doc") {
                    setModalMessage(`${file.name} - .doc format is not supported. Please convert it to .docx and re-upload.`);
                    setShowModal(true);
                    return;
                }

                try {
                    const arrayBuffer = await file.arrayBuffer();
                    const htmlResult = await mammoth.convertToHtml({ arrayBuffer });
                    const textResult = await mammoth.extractRawText({ arrayBuffer });

                    const html = htmlResult.value;
                    const parser = new DOMParser();
                    const doc = parser.parseFromString(html, "text/html");

                    const tables = doc.querySelectorAll("table");

                    let combinedRows = [];
                    let headerRef = null;

                    if (tables.length > 0) {
                        // ✅ Standard processing from HTML tables
                        tables.forEach((table) => {
                            const rows = Array.from(table.querySelectorAll("tr")).map(tr =>
                                Array.from(tr.querySelectorAll("td, th")).map(cell =>
                                    cell.textContent
                                        .replace(/\u00A0/g, ' ')
                                        .replace(/,/g, '')
                                        .replace(/\s+/g, ' ')
                                        .trim()
                                )
                            );

                            for (const row of rows) {
                                if (!row || row.length === 0 || row.every(cell => cell === "")) continue;

                                if (!headerRef) {
                                    headerRef = row.join("|");
                                    combinedRows.push(headerRef);
                                    continue;
                                }

                                if (row.join("|") === headerRef) continue;

                                combinedRows.push(row.join("|"));
                            }
                        });
                    } else {
                        // ⚠️ Fallback: try reading from raw text (basic support)
                        const lines = textResult.value.trim().split("\n").map(line => line.trim()).filter(Boolean);

                        if (lines.length < 2) {
                            setModalMessage(`${file.name} has no usable table content.`);
                            setShowModal(true);
                            return;
                        }

                        // Guess header by number of columns
                        const firstRow = lines[0].split(/\s{2,}|\t+/).filter(Boolean);
                        const colCount = firstRow.length;

                        const structuredRows = [firstRow.join("|")];

                        for (let i = 1; i < lines.length; i++) {
                            const values = lines[i].split(/\s{2,}|\t+/).filter(Boolean);
                            if (values.length === colCount) {
                                structuredRows.push(values.join("|"));
                            }
                        }

                        combinedRows = structuredRows;
                    }

                    if (combinedRows.length < 2) {
                        setModalMessage(`${file.name} - Table doesn't contain enough data.`);
                        setShowModal(true);
                        return;
                    }

                    const csvContent = combinedRows.join("\n");
                    await processFileData(csvContent, file.name, columnKeys);
                    continue;
                } catch (error) {
                    setModalMessage(`Error reading ${file.name}: ${error.message}`);
                    setShowModal(true);
                    return;
                }
            }

            if (["xls", "xlsx", "xlsb", "xlsm"].includes(fileExtension)) {
                try {
                    const reader = new FileReader();
                    reader.onload = async (e) => {
                        const data = new Uint8Array(e.target.result);
                        const workbook = XLSX.read(data, { type: "array" });

                        // Show modal with checkboxes for sheet selection
                        setSheetOptions(workbook.SheetNames);
                        setCurrentFile(file);
                        setShowSheetSelection(true);
                        // setIsSheetSelected(false);
                        setColumnKeys(columnKeys); // Store columnKeys for later use
                    };
                    reader.readAsArrayBuffer(file);
                } catch (error) {
                    setModalMessage(`${error.message}`);
                    setShowModal(true);
                    return;
                }
            } else {
                try {
                    let fileText = await file.text();

                    const fileRows = fileText.split("\n");
                    if (!columnHeaders) {
                        columnHeaders = fileRows[0]; // Store headers from the first file
                        combinedCsvContent += columnHeaders + "\n"; // Add headers only once
                    }

                    const fileData = fileRows.slice(1).join("\n");
                    if (fileData.trim() !== "") {
                        combinedCsvContent += fileData + "\n";
                        mergedFileNames.push(file.name); // Add file name to track
                    }
                    // setIsSheetSelected(true);
                }
                catch (error) {
                    setModalMessage(`Error reading ${file.name}: ${error.message}`);
                    setShowModal(true);
                    return;
                }
            }
        }

        if (combinedCsvContent.trim() !== "") {
            for (const fileName of mergedFileNames) {
                processFileData(combinedCsvContent.trim(), fileName, columnKeys);
            }
        } else {
            setUploadStatus("No valid data found after merging.");
        }
    };



    const processFileData = async (fileText, fileName, columnKeys) => {
        let fileRows = [];

        if (fileName.endsWith(".tsv") || fileText.includes("\t")) {
            fileRows = convertTsvToCsv(fileText).split("\n");
        } else if (fileName.endsWith(".psv") || fileText.includes("|")) {
            fileRows = convertPsvToCsv(fileText).split("\n");
        } else {
            fileRows = fileText.split("\n");
        }

        fileRows = fileRows.map((row) => row.trim()).filter((row) => row.length > 0);
        if (fileRows.length === 0) return;

        const headers = fileRows[0];
        let combinedCsvContent = [headers, ...fileRows.slice(1)];

        finalizeProcessing(combinedCsvContent, columnKeys);
    };

    const processSelectedSheets = async (selectedSheets) => {
        if (!currentFile || selectedSheets.length === 0) {
            setPreviewData([]); // Clear preview when no sheets selected
            // setIsSheetSelected(false); // ADD THIS to reset flag
            return;
        }

        let combinedCsvContent = [];
        let columnHeaders = null;

        const reader = new FileReader();
        reader.onload = (e) => {
            const data = new Uint8Array(e.target.result);
            const workbook = XLSX.read(data, { type: "array" });

            selectedSheets.forEach((sheetName, index) => {
                const worksheet = workbook.Sheets[sheetName];
                const sheetData = XLSX.utils.sheet_to_csv(worksheet)
                    .split("\n")
                    .filter((row) => row.trim() !== "");

                if (sheetData.length === 0) return;

                if (index === 0) {
                    columnHeaders = sheetData[0];
                    combinedCsvContent.push(columnHeaders);
                }
                combinedCsvContent.push(...sheetData.slice(1));
            });

            // setIsSheetSelected(true);
            finalizeProcessing(combinedCsvContent, columnKeys);
        };

        reader.readAsArrayBuffer(currentFile);
    };

    const finalizeProcessing = async (combinedCsvContent, columnKeys) => {
        if (combinedCsvContent.length === 0) {
            setUploadStatus("No valid files selected.");
            return;
        }

        try {
            setLoading1(true);
            setErrMsg("");
            setIsUploadAllowed(true);

            const mergedCsvText = combinedCsvContent.join("\n");
            const normalizedTableName = selectedName.toLowerCase();
            const finalFileName = `${normalizedTableName}.csv`;

            const mergedFile = new File([mergedCsvText], finalFileName, {
                type: "text/csv",
            });

            // Validate CSV content
            const startTime = Date.now();
            console.log("Submit Time:", new Date(startTime).toLocaleTimeString());
            const processedContent = await convertCsvToTxt(mergedFile);
            const endTime = Date.now();
            console.log("end Time:", new Date(endTime).toLocaleTimeString());

            if (!processedContent) {
                setUploadStatus("Error processing files.");
                setIsUploadAllowed(false);
                return;
            }

            const processedFile = new File(
                [processedContent],
                finalFileName.replace(".csv", ".txt"),
                { type: "text/plain" }
            );

            // Run validation
            const csvData = {
                rows: combinedCsvContent,
                headers: combinedCsvContent[0].split(","),
            };
            const dropdownValidationPassed = await validateDropdownValues(
                csvData,
                processedFile
            );



            setFile(processedFile);
            setSelectedFile(processedFile);
            // setPreviewData(combinedCsvContent);
            setUploadStatus("");

            if (dropdownValidationPassed) {
                setShowModal(true);
            }

            setIsUploadAllowed(true);
        } catch (error) {
            console.error("Error processing files:", error.message);
            setUploadStatus("Error processing files.");
            setIsUploadAllowed(false);
        } finally {
            setLoading1(false);
        }
    };

    const convertTsvToCsv = (tsvText) => {
        const rows = tsvText.split('\n').map(row => row.trim()).filter(row => row.length > 0);
        if (rows.length === 0) {
            throw new Error('No content in file');
        }

        const headers = rows[0].split('\t').map(header => header.trim().toLowerCase());
        const csvData = { headers, rows };


        const convertedContent = rows.map(row => {
            const columns = row.split('\t').map(value => value.trim().replace(/"/g, ''));
            return columns.join(',');
        }).join('\n');

        return convertedContent;
    };

    const convertPsvToCsv = (psvText) => {
        const rows = psvText.split('\n').map(row => row.trim()).filter(row => row.length > 0);
        if (rows.length === 0) {
            throw new Error('No content in file');
        }

        const headers = rows[0].split('|').map(header => header.trim().toLowerCase());
        const csvData = { headers, rows };


        const convertedContent = rows.map(row => {
            const columns = row.split('|').map(value => value.trim().replace(/"/g, ''));
            return columns.join(',');
        }).join('\n');

        return convertedContent;
    };


    const handleFormSubmit = async (e) => {

        e.preventDefault();
        setShowPreview(false);

        if (!file) {
            setFileSelectionMessage('Please select a valid file.');
            setShowFileSelectionModal(true);
            setLoading1(false);
            return;
        }

        if (!isUploadAllowed) {
            console.warn("Upload blocked due to validation errors.");
            return;
        } else {
            console.log("Proceeding with upload despite errors.");
        }


        handleSubmit();
    };

    // const downloadFailureIssuePDF = (data = []) => {
    //     const doc = new jsPDF({
    //         orientation: 'landscape',
    //         unit: 'mm',
    //         format: 'a4'
    //     });

    //     const pageWidth = doc.internal.pageSize.getWidth();
    //     let currentY = 45;

    //     const userId = localStorage.getItem('userid') || 'Unknown User';
    //     const createdDate = data[0]?.created_date
    //         ? new Date(data[0].created_date).toLocaleString()
    //         : new Date().toLocaleString();
    //     const capitalize = (str) =>
    //         str
    //             ? str
    //                 .split(' ')
    //                 .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
    //                 .join(' ')
    //             : '';

    //     const displayPrefix = capitalize(Prefix);
    //     const displayTableName = capitalize(selectedName);

    //     /* ---------- TITLE ---------- */
    //     doc.setFontSize(16);
    //     doc.setFont('helvetica', 'bold');
    //     doc.text(`${displayTableName} Mismatch Report`, pageWidth / 2, 20, { align: 'center' });

    //     /* ---------- METADATA ---------- */
    //     doc.setFontSize(11);
    //     doc.setFont('helvetica', 'normal');
    //     doc.text(`Created By: ${userId}`, 14, 30);
    //     doc.text(`Created Date: ${createdDate}`, 14, 37);
    //     // doc.text(`Dept: ${Prefix}`, 14, 44);
    //     // doc.text(`Table: ${selectedName}`, 60, 44);

    //     const metaStartY = 44;

    //     /* ---------- METADATA LABELS ---------- */
    //     doc.setFontSize(11);
    //     doc.setFont('helvetica', 'normal');

    //     doc.text('Department :', 14, metaStartY);
    //     doc.text('Table Name :', 14, metaStartY + 8);

    //     /* ---------- METADATA VALUES (BOLD ONLY) ---------- */
    //     doc.setFont('helvetica', 'bold');

    //     doc.text(displayPrefix || '-', 38, metaStartY);
    //     doc.text(displayTableName || '-', 38, metaStartY + 8);

    //     /* ---------- MOVE CURSOR BELOW METADATA ---------- */
    //     currentY = metaStartY + 18;

    //     // Map of custom column headings



    //     const issueStatusHeadingMap = {
    //         MISSING_IN_CONTROL_LIST: () =>
    //             `Customer exists in ${displayTableName} but no corresponding record exists in CONTROL_LIST`,

    //         DUPLICATE_IN_SECONDARY: () =>
    //             `Customer exists in ${displayTableName} and also exists in another secondary classification table`,

    //         MISMATCH: () =>
    //             `Customer exists in ${displayTableName} and CONTROL_LIST, but asset classification flags differ`
    //     };


    //     if (!Array.isArray(data) || data.length === 0) {
    //         doc.text('No failure issues found.', 14, currentY);
    //         doc.save('Mismatch_report.pdf');
    //         return;
    //     }

    //     /* ---------- GROUP BY ISSUE STATUS ---------- */
    //     const groupedData = data.reduce((acc, row) => {
    //         acc[row.issue_status] = acc[row.issue_status] || [];
    //         acc[row.issue_status].push(row);
    //         return acc;
    //     }, {});

    //     /* ---------- COLUMN RULES ---------- */
    //     const getColumnsByIssueStatus = (rows, issueStatus) => {
    //         let columns = Object.keys(rows[0]).filter(
    //             c => c !== 'created_date'
    //         );

    //         if (issueStatus === 'MISSING_IN_CONTROL_LIST') {
    //             columns = columns.filter(
    //                 c => c !== 'master_class_flag' && c !== 'source_class_flag'
    //             );
    //         }

    //         if (issueStatus === 'DUPLICATE_IN_SECONDARY') {
    //             columns = columns.filter(
    //                 c => c !== 'master_class_flag'
    //             );
    //         }

    //         return columns;
    //     };

    //     /* ---------- ISSUE STATUS SECTIONS ---------- */
    //     Object.entries(groupedData).forEach(([issueStatus, rows]) => {

    //         if (currentY > 165) {
    //             doc.addPage();
    //             currentY = 20;
    //         }

    //         const columnHeaderMap = {
    //             source_class_flag: issueStatus === 'DUPLICATE_IN_SECONDARY'
    //                 ? 'Other Secondary Template Name'
    //                 : 'Source Class Flag',
    //             master_class_flag: 'Master Class Flag'
    //         };
    //         doc.setFontSize(13);
    //         doc.setFont('helvetica', 'bold');
    //         // doc.text(`Issue Status: ${issueStatus}`, 14, currentY);
    //         const issueHeading =
    //             issueStatusHeadingMap[issueStatus]?.(selectedName) ||
    //             `Issue Status: ${issueStatus}`;

    //         doc.text(issueHeading, 14, currentY);

    //         currentY += 6;

    //         const tableColumns = getColumnsByIssueStatus(rows, issueStatus);

    //         // const headers = tableColumns.map(col =>
    //         //     col.replace(/_/g, ' ').toUpperCase()
    //         // );

    //         const headers = tableColumns.map(col =>
    //             columnHeaderMap[col] || col.replace(/_/g, ' ').toUpperCase()
    //         );


    //         const body = rows.map(row =>
    //             tableColumns.map(col => String(row[col] ?? ''))
    //         );

    //         doc.autoTable({
    //             startY: currentY,
    //             head: [headers],
    //             body,

    //             tableWidth: pageWidth - 20,
    //             horizontalPageBreak: false,

    //             styles: {
    //                 fontSize: 8,
    //                 cellWidth: 'auto',
    //                 overflow: 'linebreak',
    //                 valign: 'middle',
    //                 halign: 'left'
    //             },

    //             headStyles: {
    //                 fillColor: [0, 123, 255],
    //                 textColor: 255,
    //                 fontStyle: 'bold',
    //                 halign: 'left'
    //             },

    //             margin: { left: 10, right: 10 },

    //             didDrawPage: (tableData) => {
    //                 currentY = tableData.cursor.y + 12;
    //             }
    //         });
    //     });

    //     doc.save(`${userId}_Mismatch_report.pdf`);
    // };

    const formatTextLikeTableName = (value = '') => {
        const str = String(value).trim();

        // ✅ Handle special cases first
        if (str.toLowerCase() === 'duplicate_in_secondary') return 'Duplicate In Secondary Classification';
        if (str.toLowerCase() === 'mismatch') return 'Classification Mismatch';

        // Default formatting
        return str
            .replace(/_/g, ' ')
            .toLowerCase()
            .replace(/\b\w/g, c => c.toUpperCase());
    };

    const formatSecondaryTemplateName = (text = '') => {
        return text
            .replace(/^[^_]+_/, '')   // remove FIRST prefix only
            .replace(/_TEMP$/i, '')   // remove only trailing _TEMP
            .replace(/_/g, ' ')       // underscores → spaces
            .toLowerCase()
            .replace(/\b\w/g, c => c.toUpperCase());
    };

    const formatUpperHeader = (value = '') =>
        String(value).replace(/_/g, ' ').toUpperCase();

    // Utility function to draw paragraphs with inline bold chunks
    function drawParagraphWithBold(doc, chunks, x, y, maxWidth) {
        const lineHeight = 6;

        // 1️⃣ Build full plain text
        const fullText = chunks.map(c => c.text).join('');

        // 2️⃣ Split into wrapped lines ONCE
        const lines = doc.splitTextToSize(fullText, maxWidth);

        lines.forEach(line => {
            let cursorX = x;
            let remaining = line;

            chunks.forEach(chunk => {
                if (!remaining) return;

                const idx = remaining.indexOf(chunk.text);
                if (idx === -1) return;

                // draw text before bold chunk
                const before = remaining.slice(0, idx);
                if (before) {
                    doc.setFont('helvetica', 'normal');
                    doc.text(before, cursorX, y);
                    cursorX += doc.getTextWidth(before);
                }

                // draw bold chunk
                doc.setFont('helvetica', chunk.bold ? 'bold' : 'normal');
                doc.text(chunk.text, cursorX, y);
                cursorX += doc.getTextWidth(chunk.text);

                remaining = remaining.slice(idx + chunk.text.length);
            });

            // draw leftover normal text
            if (remaining) {
                doc.setFont('helvetica', 'normal');
                doc.text(remaining, cursorX, y);
            }

            y += lineHeight;
        });

        return y;
    }


    // const downloadFailureIssuePDF = (data = []) => {
    //     const doc = new jsPDF({
    //         orientation: 'landscape',
    //         unit: 'mm',
    //         format: 'a4'
    //     });

    //     // const pageWidth = doc.internal.pageSize.getWidth();
    //     // let currentY = 20;

    //     const topMargin = 20;
    //     const bottomMargin = 20;
    //     const leftMargin = 14;
    //     const rightMargin = 14;


    //     const pageWidth = doc.internal.pageSize.getWidth();
    //     const pageHeight = doc.internal.pageSize.getHeight(); // ✅ ADD THIS
    //     let currentY = 20;

    //     const formatDate = (dateStr) =>
    //         dateStr
    //             ? new Date(dateStr).toLocaleDateString('en-GB', {
    //                 day: '2-digit',
    //                 month: 'short',
    //                 year: 'numeric'
    //             })
    //             : '';
    //     const userId = localStorage.getItem('userid') || 'Unknown User';
    //     const createdDate = data[0]?.created_date
    //         ? formatDate(data[0].created_date)
    //         : formatDate(new Date());

    //     const displayTableName = formatTextLikeTableName(selectedName);
    //     const displayPrefix = formatTextLikeTableName(Prefix);
    //     const controlListName = formatTextLikeTableName('CONTROL_LIST');

    //     /* ================= TITLE ================= */
    //     doc.setFontSize(16);
    //     doc.setFont('helvetica', 'bold');
    //     doc.text(
    //         `${displayTableName} Classification Control Check Report`,
    //         pageWidth / 2,
    //         currentY,
    //         { align: 'center' }
    //     );
    //     currentY += 16;

    //     /* ================= META ================= */
    //     doc.setFontSize(10);
    //     const metaItems = [
    //         ['Report Generated By (User ID):', userId],
    //         ['Report Generated On:', createdDate],
    //         ['Department:', displayPrefix],
    //         ['Secondary Template Name:', displayTableName],
    //         ['Master Reference Template:', controlListName]
    //     ];

    //     metaItems.forEach(([label, value]) => {
    //         doc.setFont('helvetica', 'bold');
    //         doc.text(label, 14, currentY);
    //         const labelWidth = doc.getTextWidth(label) + 2;
    //         doc.setFont('helvetica', 'normal');
    //         doc.text(value, 14 + labelWidth, currentY);
    //         currentY += 6;
    //     });

    //     currentY += 4;

    //     /* ================= INTRO ================= */
    //     doc.setFontSize(11);
    //     const maxWidth = pageWidth - 28; // margins 14+14
    //     currentY = drawParagraphWithBold(doc, [
    //         { text: 'This report identifies classification inconsistencies detected while validating  ', bold: false },
    //         { text: displayTableName, bold: true },

    //         { text: ' ', bold: false },
    //         { text: '(secondary template)', bold: false },

    //         { text: ' against the ', bold: false },
    //         { text: controlListName, bold: true },

    //         { text: ' ', bold: false },
    //         { text: '(master reference)', bold: false },

    //         { text: ' and other related secondary classification templates.', bold: false }
    //     ], 14, currentY, maxWidth);

    //     currentY += 10;


    //     /* ================= ISSUE DESCRIPTIONS ================= */
    //     const issueDescriptionMap = {
    //         MISSING_IN_CONTROL_LIST: () =>
    //             `Counterparties present in ${displayTableName} but not found in the ${controlListName}.`,

    //         DUPLICATE_IN_SECONDARY: () =>
    //             `Counterparties present in ${displayTableName} that also exist in one or more other secondary classification templates, resulting in overlapping secondary classifications.`,

    //         MISMATCH: () =>
    //             `Counterparties present in both ${displayTableName} and the ${controlListName}, but with conflicting asset classification flags between the secondary template and the master reference.`
    //     };

    //     const boldWordsMap = {
    //         MISSING_IN_CONTROL_LIST: [
    //             displayTableName,
    //             controlListName
    //         ],
    //         DUPLICATE_IN_SECONDARY: [
    //             displayTableName,
    //             'in one or more other secondary classification templates'
    //         ],
    //         MISMATCH: [
    //             'both ' + displayTableName + ' and the ' + controlListName,
    //             'conflicting asset classification flags'
    //         ]
    //     };

    //     /* ================= GROUP DATA ================= */
    //     const grouped = data.reduce((acc, row) => {
    //         acc[row.issue_status] ??= [];
    //         acc[row.issue_status].push(row);
    //         return acc;
    //     }, {});

    //     let sectionIndex = 1;
    //     const summaryCounts = {};

    //     Object.entries(grouped).forEach(([issueStatus, rows]) => {
    //         if (currentY > 250) {
    //             doc.addPage();
    //             currentY = 20;
    //         }

    //         const issueTitleMap = {
    //             MISSING_IN_CONTROL_LIST: 'Missing in Control List',
    //             DUPLICATE_IN_SECONDARY: 'Duplicate in Secondary Classification',
    //             MISMATCH: 'Asset Classification Mismatch'
    //         };



    //         /* ---- Section Title ---- */
    //         /* ---- Section Title ---- */
    //         doc.setFontSize(13);
    //         doc.setFont('helvetica', 'bold');
    //         doc.text(
    //             `Issue Category ${sectionIndex}: ${issueTitleMap[issueStatus] || formatTextLikeTableName(issueStatus)}`,
    //             14,
    //             currentY
    //         );
    //         currentY += 6;

    //         // Horizontal line under Issue Category
    //         doc.setDrawColor(0, 0, 0);
    //         doc.setLineWidth(0.4);
    //         doc.line(14, currentY, pageWidth - 14, currentY);
    //         currentY += 6;

    //         /* ---- Description Heading ---- */
    //         doc.setFontSize(11);
    //         doc.setFont('helvetica', 'bold');
    //         doc.text('Description:', 14, currentY);
    //         currentY += 10;

    //         /* ---- Description Content ---- */
    //         const descText = issueDescriptionMap[issueStatus]?.() || '';
    //         const boldChunks = boldWordsMap[issueStatus] || [];

    //         // Split text into normal/bold chunks
    //         const textChunks = [];
    //         let lastIndex = 0;
    //         boldChunks.forEach(boldWord => {
    //             const index = descText.indexOf(boldWord, lastIndex);
    //             if (index > lastIndex) {
    //                 textChunks.push({ text: descText.slice(lastIndex, index), bold: false });
    //             }
    //             if (index !== -1) {
    //                 textChunks.push({ text: boldWord, bold: true });
    //                 lastIndex = index + boldWord.length;
    //             }
    //         });
    //         if (lastIndex < descText.length) {
    //             textChunks.push({ text: descText.slice(lastIndex), bold: false });
    //         }

    //         currentY = drawParagraphWithBold(doc, textChunks, 14, currentY, maxWidth);
    //         currentY += 4;

    //         /* ---- Table Columns ---- */
    //         let columns = Object.keys(rows[0]).filter(c => c !== 'created_date');

    //         if (issueStatus === 'MISSING_IN_CONTROL_LIST') {
    //             columns = columns.filter(
    //                 c => !['master_class_flag', 'source_class_flag'].includes(c)
    //             );
    //         }

    //         if (issueStatus === 'DUPLICATE_IN_SECONDARY') {
    //             columns = columns.filter(c => c !== 'master_class_flag');
    //         }


    //         const headers = columns.map(c => {
    //             if (issueStatus === 'DUPLICATE_IN_SECONDARY' && c === 'source_class_flag') {
    //                 return 'OTHER SECONDARY TEMPLATE NAME';
    //             }

    //             if (issueStatus === 'MISMATCH' && c === 'source_class_flag') {
    //                 return 'SECONDARY CLASSIFICATION';
    //             }

    //             if (issueStatus === 'MISMATCH' && c === 'master_class_flag') {
    //                 return 'MASTER CLASSIFICATION';
    //             }

    //             return formatUpperHeader(c);
    //         });

    //         const body = rows.map(r => columns.map(col => formatTextLikeTableName(r[col])));

    //         const drawFooter = (doc) => {
    //             const pageCount = doc.getNumberOfPages();
    //             const pageNumber = doc.internal.getCurrentPageInfo().pageNumber;

    //             doc.setFontSize(9);
    //             doc.setFont('helvetica', 'normal');
    //             doc.text(
    //                 `Page ${pageNumber} of ${pageCount}`,
    //                 pageWidth - rightMargin,
    //                 pageHeight - 8,
    //                 { align: 'right' }
    //             );
    //         };

    //         doc.autoTable({
    //             startY: currentY,
    //             head: [headers],
    //             body,
    //             styles: {
    //                 fontSize: 9,
    //                 cellPadding: 3,
    //                 lineColor: [0, 0, 0],
    //                 lineWidth: 0.3,
    //                 textColor: [0, 0, 0]
    //             },
    //             headStyles: {
    //                 fillColor: [242, 220, 219],
    //                 textColor: [0, 0, 0],
    //                 fontStyle: 'bold'
    //             },
    //             didDrawPage: (data) => {
    //                 drawFooter(doc);               // ✅ footer safe
    //                 currentY = data.cursor.y + 10; // ✅ correct Y
    //             }
    //         });

    //         summaryCounts[issueStatus] = rows.length;
    //         sectionIndex++;
    //     });

    //     /* ================= FOOTER BEFORE SUMMARY ================= */
    //     const summaryRequiredSpace = 70;

    //     if (currentY + summaryRequiredSpace > pageHeight - bottomMargin) {
    //         doc.addPage();
    //         currentY = topMargin;
    //     }


    //     currentY += 12;


    //     doc.setFontSize(14);
    //     doc.setFont('helvetica', 'bold');
    //     doc.text('Summary', 14, currentY);
    //     currentY += 8;


    //     let total = 0;
    //     const summaryBody = Object.entries(summaryCounts).map(([k, v]) => {
    //         total += v;
    //         return [formatTextLikeTableName(k), v];
    //     });

    //     summaryBody.push(['Total Impacted Counterparties', total]);

    //     const drawFooter = (doc) => {
    //         const pageCount = doc.getNumberOfPages();
    //         const pageNumber = doc.internal.getCurrentPageInfo().pageNumber;

    //         doc.setFontSize(9);
    //         doc.setFont('helvetica', 'normal');
    //         doc.text(
    //             `Page ${pageNumber} of ${pageCount}`,
    //             pageWidth - rightMargin,
    //             pageHeight - 8,
    //             { align: 'right' }
    //         );
    //     };
    //     doc.autoTable({
    //         startY: currentY,
    //         head: [['Issue Type', 'Count']],
    //         body: summaryBody,
    //         styles: {
    //             fontSize: 10,
    //             lineColor: [0, 0, 0],
    //             lineWidth: 0.4,
    //             textColor: [0, 0, 0]
    //         },
    //         headStyles: {
    //             fillColor: [242, 220, 219],
    //             textColor: [0, 0, 0],
    //             fontStyle: 'bold'
    //         },
    //         columnStyles: {
    //             0: { cellWidth: 120 },
    //             1: { cellWidth: 40, halign: 'right' }
    //         },
    //         didDrawPage: (data) => {
    //             drawFooter(doc);               // ✅ footer safe
    //             currentY = data.cursor.y + 10; // ✅ correct Y
    //         }
    //     });

    //     // const pageCount = doc.getNumberOfPages();

    //     // for (let i = 1; i <= pageCount; i++) {
    //     //     doc.setPage(i);
    //     //     doc.setFontSize(9);
    //     //     doc.setFont('helvetica', 'normal');
    //     //     doc.text(
    //     //         `Page ${i} of ${pageCount}`,
    //     //         pageWidth - 14,
    //     //         pageHeight - 10,   // ✅ dynamic footer position
    //     //         { align: 'right' }
    //     //     );

    //     // }



    //     doc.save(`${userId}_Control_Check_Report.pdf`);

    //     /* ================= PAGE NUMBERS ================= */
    // };

    // related to Prema format

    // const downloadJsonAsPDF = (data = []) => {
    //     const doc = new jsPDF({
    //         orientation: 'landscape',
    //         unit: 'mm',
    //         format: 'a4'
    //     });

    //     const pageWidth = doc.internal.pageSize.getWidth();
    //     let currentY = 30;

    //     const formatDate = (dateStr) =>
    //         dateStr
    //             ? new Date(dateStr).toLocaleDateString('en-GB', {
    //                 day: '2-digit',
    //                 month: 'short',
    //                 year: 'numeric'
    //             })
    //             : '';

    //     const userId = localStorage.getItem('userid') || 'Unknown User';
    //     const createdDate = data[0]?.created_date
    //         ? formatDate(data[0].created_date)
    //         : formatDate(new Date());

    //     const formatTitle = (str) =>
    //         str
    //             ? str
    //                 .replace(/_/g, ' ')
    //                 .toLowerCase()
    //                 .replace(/\b\w/g, c => c.toUpperCase())
    //             : '';

    //     const displayPrefix = formatTitle(Prefix);
    //     const displayTableName = formatTitle(selectedName);

    //     /* ================= TITLE ================= */
    //     doc.setFontSize(16);
    //     doc.setFont('helvetica', 'bold');
    //     doc.text(
    //         `${displayTableName} Classification Change Monitoring Report`,
    //         pageWidth / 2,
    //         20,
    //         { align: 'center' }
    //     );

    //     const toUpperClean = (val) =>
    //         val ? String(val).replace(/_/g, ' ').toUpperCase() : '';

    //     /* ================= METADATA ================= */
    //     doc.setFontSize(10);

    //     const metaItems = [
    //         ['Report Generated By (User ID):', userId],
    //         ['Report Generated On:', createdDate],
    //         ['Department:', displayPrefix],
    //         ['Table Name:', displayTableName]
    //     ];

    //     metaItems.forEach(([label, value]) => {
    //         doc.setFont('helvetica', 'bold');
    //         doc.text(label, 14, currentY);

    //         const labelWidth = doc.getTextWidth(label) + 2;

    //         doc.setFont('helvetica', 'normal');
    //         doc.text(value || '-', 14 + labelWidth, currentY);

    //         currentY += 6;
    //     });

    //     if (!Array.isArray(data) || data.length === 0) {
    //         doc.text('No mismatch data found.', 14, currentY);
    //         doc.save(`${userId}_Mismatch_Report.pdf`);
    //         return;
    //     }

    //     /* ================= GROUP DATA ================= */
    //     const groupedData = data.reduce((acc, row) => {
    //         acc[row.table_name] ??= [];
    //         acc[row.table_name].push(row);
    //         return acc;
    //     }, {});

    //     const extractCustomerId = (pkValue, reportingDate) =>
    //         pkValue?.split('|').find(v => v !== reportingDate) || '';

    //     /* ================= LOOP EACH TABLE ================= */
    //     Object.entries(groupedData).forEach(([_, rows], index) => {
    //         if (index !== 0) {
    //             doc.addPage();
    //             currentY = 30;
    //         }

    //         /* ---------- Reporting Date ---------- */
    //         const reportingDate = formatDate(rows[0]?.new_reporting_date);

    //         doc.setFontSize(10);
    //         doc.setFont('helvetica', 'bold');
    //         doc.text('Reporting Date:', 14, currentY);

    //         const reportLabelWidth =
    //             doc.getTextWidth('Reporting Date:') + 2;

    //         doc.setFont('helvetica', 'normal');
    //         doc.text(reportingDate, 14 + reportLabelWidth, currentY);

    //         currentY += 8;

    //         /* ---------- Header Dates ---------- */
    //         const prevHeaderDate = formatDate(rows[0]?.old_reporting_date);
    //         const currHeaderDate = formatDate(rows[0]?.new_reporting_date);

    //         const headers = [[
    //             'CUSTOMER ID',
    //             'ATTRIBUTE',
    //             `PREVIOUS VALUE (${prevHeaderDate.toUpperCase()})`,
    //             `CURRENT VALUE (${currHeaderDate.toUpperCase()})`,
    //             'CHANGE TYPE'
    //         ]];

    //         /* ================= DATE COMPARISON ANALYSIS LOGIC ================= */
    //         const customerGrouped = rows.reduce((acc, r) => {
    //             const cid = extractCustomerId(
    //                 r.pk_value,
    //                 r.new_reporting_date
    //             );
    //             acc[cid] ??= [];
    //             acc[cid].push(r);
    //             return acc;
    //         }, {});

    //         const body = [];

    //         Object.entries(customerGrouped).forEach(([cid, custRows]) => {
    //             const allColumns = [
    //                 ...new Set(custRows.map(r => r.column_name))
    //             ];

    //             const mismatches = custRows
    //                 .filter(r => r.old_value !== r.new_value)
    //                 .map(r => r.column_name);

    //             const analysis =
    //                 mismatches.length === allColumns.length
    //                     ? `MISMATCH IN ${[...new Set(mismatches)]
    //                         .map(c => c.replace(/_/g, ' ').toUpperCase())
    //                         .join(', ')}` : 'MISMATCH IN ALL VARIABLES';


    //             custRows.forEach(r => {
    //                 body.push([
    //                     cid,
    //                     toUpperClean(r.column_name),
    //                     r.old_value ?? '',
    //                     r.new_value ?? '',
    //                     analysis
    //                 ]);
    //             });
    //         });

    //         doc.autoTable({
    //             startY: currentY,
    //             head: headers,
    //             body,
    //             styles: {
    //                 fontSize: 10,
    //                 cellPadding: 3,
    //                 valign: 'middle',
    //                 textColor: [0, 0, 0],
    //                 lineColor: [0, 0, 0],
    //                 lineWidth: 0.4
    //             },
    //             headStyles: {
    //                 fillColor: [242, 220, 219],
    //                 textColor: [0, 0, 0],
    //                 fontStyle: 'bold',
    //                 lineColor: [0, 0, 0],
    //                 lineWidth: 0.6
    //             },
    //             columnStyles: {
    //                 0: { cellWidth: 35 },
    //                 1: { cellWidth: 65 },
    //                 2: { cellWidth: 55 },
    //                 3: { cellWidth: 55 },
    //                 4: { cellWidth: 40 }
    //             },
    //             margin: { left: 10, right: 10 },
    //             didDrawPage: d => {
    //                 currentY = d.cursor.y + 10;
    //             }
    //         });
    //     });

    //     /* ================= PAGE NUMBERS ================= */
    //     const pageCount = doc.getNumberOfPages();
    //     for (let i = 1; i <= pageCount; i++) {
    //         doc.setPage(i);
    //         doc.setFontSize(9);
    //         doc.setFont('helvetica', 'normal');
    //         doc.text(
    //             `Page ${i} of ${pageCount}`,
    //             pageWidth - 14,
    //             200,
    //             { align: 'right' }
    //         );
    //     }

    //     doc.save(`${userId}_Control_Report.pdf`);
    // };


    // related to Darresh sir format 

    // const downloadFailureIssuePDF = (data = []) => {
    //     const doc = new jsPDF({
    //         orientation: 'landscape',
    //         unit: 'mm',
    //         format: 'a4'
    //     });

    //     const topMargin = 20;
    //     const bottomMargin = 20;
    //     const leftMargin = 14;
    //     const rightMargin = 14;

    //     const pageWidth = doc.internal.pageSize.getWidth();
    //     const pageHeight = doc.internal.pageSize.getHeight();
    //     let currentY = topMargin;

    //     const formatDate = (dateStr) =>
    //         dateStr
    //             ? new Date(dateStr).toLocaleDateString('en-GB', {
    //                 day: '2-digit',
    //                 month: 'short',
    //                 year: 'numeric'
    //             })
    //             : '';

    //     const userId = localStorage.getItem('userid') || 'Unknown User';
    //     const createdDate = data[0]?.created_date
    //         ? formatDate(data[0].created_date)
    //         : formatDate(new Date());

    //     const displayTableName = formatTextLikeTableName(selectedName);
    //     const displayPrefix = formatTextLikeTableName(Prefix);
    //     const controlListName = formatTextLikeTableName('CONTROL_LIST');

    //     /* ================= TITLE ================= */
    //     doc.setFontSize(16);
    //     doc.setFont('helvetica', 'bold');
    //     doc.text(
    //         `${displayTableName} Classification Control Check Report`,
    //         pageWidth / 2,
    //         currentY,
    //         { align: 'center' }
    //     );
    //     currentY += 16;

    //     /* ================= META ================= */
    //     doc.setFontSize(10);
    //     const metaItems = [
    //         ['Report Generated By (User ID):', userId],
    //         ['Report Generated On:', createdDate],
    //         ['Department:', displayPrefix],
    //         ['Secondary Template Name:', displayTableName],
    //         ['Master Reference Template:', controlListName]
    //     ];

    //     metaItems.forEach(([label, value]) => {
    //         doc.setFont('helvetica', 'bold');
    //         doc.text(label, leftMargin, currentY);
    //         const labelWidth = doc.getTextWidth(label) + 2;
    //         doc.setFont('helvetica', 'normal');
    //         doc.text(value, leftMargin + labelWidth, currentY);
    //         currentY += 6;
    //     });

    //     currentY += 4;

    //     /* ================= INTRO ================= */
    //     doc.setFontSize(11);
    //     const maxWidth = pageWidth - leftMargin - rightMargin;

    //     currentY = drawParagraphWithBold(
    //         doc,
    //         [
    //             { text: 'This report identifies classification inconsistencies detected while validating ', bold: false },
    //             { text: displayTableName, bold: true },
    //             { text: ' (secondary template) against the ', bold: false },
    //             { text: controlListName, bold: true },
    //             { text: ' (master reference) and other related secondary classification templates.', bold: false }
    //         ],
    //         leftMargin,
    //         currentY,
    //         maxWidth
    //     );

    //     currentY += 10;

    //     /* ================= ISSUE DESCRIPTION MAP ================= */
    //     const issueDescriptionMap = {
    //         MISSING_IN_CONTROL_LIST: () =>
    //             `Counterparties present in ${displayTableName} but not found in the ${controlListName}.`,

    //         DUPLICATE_IN_SECONDARY: () =>
    //             `Counterparties present in ${displayTableName} that also exist in one or more other secondary classification templates, resulting in overlapping secondary classifications.`,

    //         MISMATCH: () =>
    //             `Counterparties present in both ${displayTableName} and the ${controlListName}, but with conflicting asset classification flags between the secondary template and the master reference.`
    //     };

    //     const boldWordsMap = {
    //         MISSING_IN_CONTROL_LIST: [displayTableName, controlListName],
    //         DUPLICATE_IN_SECONDARY: [displayTableName, 'one or more other secondary classification templates'],
    //         MISMATCH: ['both ' + displayTableName + ' and the ' + controlListName, 'conflicting asset classification flags']
    //     };

    //     /* ================= GROUP DATA ================= */
    //     const grouped = data.reduce((acc, row) => {
    //         acc[row.issue_status] ??= [];
    //         acc[row.issue_status].push(row);
    //         return acc;
    //     }, {});

    //     let sectionIndex = 1;
    //     const summaryCounts = {};

    //     const drawFooter = () => {
    //         const pageCount = doc.getNumberOfPages();
    //         const pageNumber = doc.internal.getCurrentPageInfo().pageNumber;
    //         doc.setFontSize(9);
    //         doc.setFont('helvetica', 'normal');
    //         doc.text(
    //             `Page ${pageNumber} of ${pageCount}`,
    //             pageWidth - rightMargin,
    //             pageHeight - 8,
    //             { align: 'right' }
    //         );
    //     };

    //     Object.entries(grouped).forEach(([issueStatus, rows]) => {
    //         if (currentY > pageHeight - 60) {
    //             doc.addPage();
    //             currentY = topMargin;
    //         }

    //         const issueTitleMap = {
    //             MISSING_IN_CONTROL_LIST: 'Missing in Control List',
    //             DUPLICATE_IN_SECONDARY: 'Duplicate in Secondary Classification',
    //             MISMATCH: 'Asset Classification Mismatch'
    //         };

    //         /* ---------- SECTION TITLE ---------- */
    //         doc.setFontSize(13);
    //         doc.setFont('helvetica', 'bold');
    //         doc.text(
    //             `Issue Category ${sectionIndex}: ${issueTitleMap[issueStatus]}`,
    //             leftMargin,
    //             currentY
    //         );
    //         currentY += 6;

    //         doc.setLineWidth(0.4);
    //         doc.line(leftMargin, currentY, pageWidth - rightMargin, currentY);
    //         currentY += 8;

    //         /* ---------- DESCRIPTION ---------- */
    //         doc.setFontSize(11);
    //         doc.setFont('helvetica', 'bold');
    //         doc.text('Description:', leftMargin, currentY);
    //         currentY += 8;

    //         const descText = issueDescriptionMap[issueStatus]?.() || '';
    //         const boldChunks = boldWordsMap[issueStatus] || [];

    //         const chunks = [];
    //         let last = 0;
    //         boldChunks.forEach(word => {
    //             const idx = descText.indexOf(word, last);
    //             if (idx > last) chunks.push({ text: descText.slice(last, idx), bold: false });
    //             if (idx !== -1) chunks.push({ text: word, bold: true });
    //             last = idx + word.length;
    //         });
    //         if (last < descText.length) chunks.push({ text: descText.slice(last), bold: false });

    //         currentY = drawParagraphWithBold(doc, chunks, leftMargin, currentY, maxWidth);
    //         currentY += 6;

    //         /* ---------- TABLE ---------- */
    //         let columns = Object.keys(rows[0]).filter(c => c !== 'created_date');

    //         if (issueStatus === 'MISSING_IN_CONTROL_LIST') {
    //             columns = columns.filter(c => !['master_class_flag', 'source_class_flag'].includes(c));
    //         }
    //         if (issueStatus === 'DUPLICATE_IN_SECONDARY') {
    //             columns = columns.filter(c => c !== 'master_class_flag');
    //         }

    //         const headers = columns.map(c => {
    //             if (issueStatus === 'DUPLICATE_IN_SECONDARY' && c === 'source_class_flag') {
    //                 return 'OTHER SECONDARY TEMPLATE NAME';
    //             }
    //             if (issueStatus === 'MISMATCH' && c === 'source_class_flag') {
    //                 return 'SECONDARY CLASSIFICATION';
    //             }
    //             if (issueStatus === 'MISMATCH' && c === 'master_class_flag') {
    //                 return 'MASTER CLASSIFICATION';
    //             }
    //             return formatUpperHeader(c);
    //         });

    //         const body = rows.map(r =>
    //             columns.map(col => formatTextLikeTableName(r[col]))
    //         );

    //         const usableWidth = pageWidth - leftMargin - rightMargin;
    //         const colWidth = usableWidth / headers.length;

    //         const columnStyles = {};
    //         headers.forEach((_, i) => {
    //             columnStyles[i] = { cellWidth: colWidth };
    //         });

    //         doc.autoTable({
    //             startY: currentY,
    //             head: [headers],
    //             body,
    //             tableWidth: usableWidth,
    //             margin: { left: leftMargin, right: rightMargin },
    //             columnStyles,
    //             styles: {
    //                 fontSize: 9,
    //                 cellPadding: 3,
    //                 overflow: 'linebreak',
    //                 lineColor: [0, 0, 0],
    //                 lineWidth: 0.3,
    //                 textColor: [0, 0, 0]
    //             },
    //             headStyles: {
    //                 fillColor: [242, 220, 219],
    //                 textColor: [0, 0, 0],
    //                 fontStyle: 'bold'
    //             },
    //             didDrawPage: () => drawFooter()
    //         });

    //         currentY = doc.lastAutoTable.finalY + 12;
    //         summaryCounts[issueStatus] = rows.length;
    //         sectionIndex++;
    //     });

    //     /* ================= SUMMARY ================= */
    //     if (currentY > pageHeight - 60) {
    //         doc.addPage();
    //         currentY = topMargin;
    //     }

    //     doc.setFontSize(14);
    //     doc.setFont('helvetica', 'bold');
    //     doc.text('Summary', leftMargin, currentY);
    //     currentY += 10;

    //     let total = 0;
    //     const summaryBody = Object.entries(summaryCounts).map(([k, v]) => {
    //         total += v;
    //         return [formatTextLikeTableName(k), v];
    //     });
    //     summaryBody.push(['Total Impacted Counterparties', total]);

    //     doc.autoTable({
    //         startY: currentY,
    //         head: [['ISSUE TYPE', 'COUNT']],
    //         body: summaryBody,
    //         tableWidth: 160,
    //         margin: { left: leftMargin },
    //         columnStyles: {
    //             0: { cellWidth: 120 },
    //             1: { cellWidth: 40, halign: 'right' }
    //         },
    //         styles: {
    //             fontSize: 10,
    //             lineColor: [0, 0, 0],
    //             lineWidth: 0.4,
    //             textColor: [0, 0, 0]
    //         },
    //         headStyles: {
    //             fillColor: [242, 220, 219],
    //             textColor: [0, 0, 0],
    //             fontStyle: 'bold'
    //         },
    //         didDrawPage: () => drawFooter()
    //     });

    //     doc.save(`${userId}_Control_Check_Report.pdf`);
    // };

    const downloadFailureIssuePDF = (data = []) => {
        const doc = new jsPDF({ orientation: 'landscape', unit: 'mm', format: 'a4' });

        const topMargin = 20;
        const leftMargin = 14;
        const rightMargin = 14;
        const pageWidth = doc.internal.pageSize.getWidth();
        const pageHeight = doc.internal.pageSize.getHeight();
        let currentY = topMargin;

        const formatDate = (dateStr) =>
            dateStr
                ? new Date(dateStr).toLocaleDateString('en-GB', {
                    day: '2-digit',
                    month: 'short',
                    year: 'numeric'
                })
                : '';

        const userId = localStorage.getItem('userid') || 'Unknown User';
        const createdDate = data[0]?.created_date
            ? formatDate(data[0].created_date)
            : formatDate(new Date());

        const displayTableName = formatTextLikeTableName(selectedName);
        const displayPrefix = formatTextLikeTableName(Prefix);
        const controlListName = formatTextLikeTableName('CONTROL_LIST');

        // ============ TITLE ============
        doc.setFontSize(16);
        doc.setFont('helvetica', 'bold');
        doc.text(
            `Control Check Report - ${displayTableName} Classification`,
            pageWidth / 2,
            currentY,
            { align: 'center' }
        );
        currentY += 16;

        // Helper function to format issue_status
        const formatIssueStatus = (status) => {
            switch (status) {
                case 'MISSING_IN_CONTROL_LIST':
                    return 'Missing';
                case 'DUPLICATE_IN_SECONDARY':
                    return 'Duplicate';
                case 'MISMATCH':
                    return 'Mismatch';
                default:
                    return status || '';
            }
        };


        // ============ META ============
        doc.setFontSize(10);
        const metaItems = [
            ['Report Generated By (User ID):', userId],
            ['Report Generated On:', createdDate],
            ['Department:', displayPrefix],
            ['Secondary Template Name:', displayTableName],
            ['Master Reference Template:', controlListName]
        ];

        metaItems.forEach(([label, value]) => {
            doc.setFont('helvetica', 'bold');
            doc.text(label, leftMargin, currentY);
            const labelWidth = doc.getTextWidth(label) + 2;
            doc.setFont('helvetica', 'normal');
            doc.text(value, leftMargin + labelWidth, currentY);
            currentY += 6;
        });

        currentY += 6;

        // ============ SINGLE TABLE ============
        const headers = [['Reporting Date', 'Customer ID', 'Issue Type', 'Details']];

        const body = data.map(row => {
            const issueText = formatIssueStatus(row.issue_status);

            let details = '';
            switch (row.issue_status) {
                case 'MISSING_IN_CONTROL_LIST':
                    details = 'Not found in Master Reference';
                    break;

                case 'DUPLICATE_IN_SECONDARY': {
                    const templateName = formatSecondaryTemplateName(row.source_class_flag);

                    details =
                        templateName === 'Specialized Lending' ||
                            templateName === 'BSF_SPECIALIZED_LENDING_DATA_TEMP'
                            ? 'Already exists in Specialized Lending'
                            : `Also exists in ${templateName}`;
                    break;
                }

                case 'MISMATCH':
                    details = `Master: ${row.master_class_flag || ''}, Secondary: ${row.source_class_flag || ''}`;
                    break;

                default:
                    details = '';
            }

            return [
                row.reporting_date || '',
                row.customer_id || '',
                issueText,
                details
            ];
        });


        doc.autoTable({
            startY: currentY,
            head: headers,
            body,
            margin: { left: leftMargin, right: rightMargin },
            styles: {
                fontSize: 9,
                cellPadding: 3,
                overflow: 'linebreak',
                lineColor: [0, 0, 0],
                lineWidth: 0.3,
                textColor: [0, 0, 0]
            },
            headStyles: {
                fillColor: [242, 220, 219],
                textColor: [0, 0, 0],
                fontStyle: 'bold'
            },
            columnStyles: {
                0: { cellWidth: 35 },
                1: { cellWidth: 35 },
                2: { cellWidth: 35 },
                3: { cellWidth: 120 }
            },
            didDrawPage: () => {
                const pageCount = doc.getNumberOfPages();
                const pageNumber = doc.internal.getCurrentPageInfo().pageNumber;
                doc.setFontSize(9);
                doc.setFont('helvetica', 'normal');
                doc.text(`Page ${pageNumber} of ${pageCount}`, pageWidth - rightMargin, pageHeight - 8, { align: 'right' });
            }
        });

        doc.save(`${userId}_Control_Check_Report.pdf`);
    };


    // const downloadJsonAsPDF = (data = []) => {
    //     const doc = new jsPDF({
    //         orientation: 'landscape',
    //         unit: 'mm',
    //         format: 'a4'
    //     });

    //     const pageWidth = doc.internal.pageSize.getWidth();
    //     let currentY = 30;

    //     const formatDate = (dateStr) =>
    //         dateStr
    //             ? new Date(dateStr).toLocaleDateString('en-GB', {
    //                 day: '2-digit',
    //                 month: 'short',
    //                 year: 'numeric'
    //             })
    //             : '';

    //     const userId = localStorage.getItem('userid') || 'Unknown User';
    //     const createdDate = data[0]?.created_date
    //         ? formatDate(data[0].created_date)
    //         : formatDate(new Date());

    //     const capitalize = (str) =>
    //         str
    //             ? str
    //                 .split(' ')
    //                 .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
    //                 .join(' ')
    //             : '';

    //     const displayPrefix = capitalize(Prefix);
    //     const displayTableName = capitalize(selectedName);

    //     /* ---------- DATE FORMATTER ---------- */

    //     /* ---------- TITLE ---------- */
    //     doc.setFontSize(16);
    //     doc.setFont('helvetica', 'bold');
    //     doc.text(
    //         `${displayTableName} Classification Change Monitoring Report`,
    //         pageWidth / 2,
    //         20,
    //         { align: 'center' }
    //     );

    //     /* ---------- METADATA ---------- */
    //     // doc.setFontSize(11);
    //     // doc.setFont('helvetica', 'normal');
    //     // doc.text(`Created By: ${userId}`, 14, 30);
    //     // doc.text(`Created Date: ${createdDate}`, 14, 37);

    //     const metaStartY = 44;

    //     /* ---------- METADATA LABELS ---------- */
    //     doc.setFontSize(10);

    //     const metaItems = [
    //         ['Report Generated By (User ID):', userId],
    //         ['Report Generated On:', createdDate],
    //         ['Department:', displayPrefix],
    //         ['Table Name:', displayTableName]
    //     ];

    //     metaItems.forEach(([label, value]) => {
    //         doc.setFont('helvetica', 'bold');
    //         doc.text(label, 14, currentY);

    //         const labelWidth = doc.getTextWidth(label) + 2;

    //         doc.setFont('helvetica', 'normal');
    //         doc.text(value || '-', 14 + labelWidth, currentY);

    //         currentY += 6;
    //     });


    //     /* ---------- MOVE CURSOR BELOW METADATA ---------- */
    //     currentY = metaStartY + 18;

    //     if (!Array.isArray(data) || data.length === 0) {
    //         doc.text('No mismatch data found.', 14, currentY);
    //         doc.save('Mismatch_Report.pdf');
    //         return;
    //     }

    //     const COLORS = {
    //         PREVIOUS_HEADER: [242, 220, 219],
    //         CURRENT_HEADER: [218, 238, 243],
    //         ANALYSIS_HEADER: [230, 230, 230],
    //         MISMATCH_CELL: [252, 213, 180],
    //         BORDER: [0, 0, 0],
    //         TEXT_BLACK: [0, 0, 0]
    //     };

    //     // const formatDate = (d) =>
    //     //     new Date(d).toLocaleDateString('en-GB', {
    //     //         day: '2-digit',
    //     //         month: 'short',
    //     //         year: 'numeric'
    //     //     });

    //     const oldDate = formatDate(data[0].old_reporting_date);
    //     const newDate = formatDate(data[0].new_reporting_date);

    //     const extractCustomerId = (pk, date) =>
    //         pk?.split('|').find(v => v !== date);

    //     const grouped = {};
    //     data.forEach(r => {
    //         const id = extractCustomerId(r.pk_value, r.new_reporting_date);
    //         grouped[id] ??= {};
    //         grouped[id][r.column_name] = { old: r.old_value, new: r.new_value };
    //     });

    //     const columns = [...new Set(data.map(d => d.column_name))];

    //     // doc.setFontSize(16);
    //     // doc.setFont('helvetica', 'bold');
    //     // doc.text(
    //     //     `${data[0].table_name} – Data Comparison Report`,
    //     //     pageWidth / 2,
    //     //     currentY,
    //     //     { align: 'center' }
    //     // );

    //     // currentY += 12;

    //     const headerRow1 = [
    //         {
    //             content: 'CUSTOMER ID',
    //             rowSpan: 2,
    //             styles: { halign: 'center', valign: 'middle', fillColor: COLORS.ANALYSIS_HEADER, textColor: COLORS.TEXT_BLACK }
    //         },
    //         {
    //             content: `PREVIOUS VALUE - ${oldDate}`,
    //             colSpan: columns.length,
    //             styles: { halign: 'center', fillColor: COLORS.PREVIOUS_HEADER, textColor: COLORS.TEXT_BLACK }
    //         },
    //         {
    //             content: `CURRENT VALUE - ${newDate}`,
    //             colSpan: columns.length,
    //             styles: { halign: 'center', fillColor: COLORS.CURRENT_HEADER, textColor: COLORS.TEXT_BLACK }
    //         },
    //         {
    //             content: 'DATE COMPARISON ANALYSIS',
    //             rowSpan: 2,
    //             styles: { halign: 'center', valign: 'middle', fillColor: COLORS.ANALYSIS_HEADER, textColor: COLORS.TEXT_BLACK }
    //         }
    //     ];

    //     const headerRow2 = [
    //         ...columns.map(c => ({
    //             content: c.replace(/_/g, ' '),
    //             styles: { halign: 'center', fillColor: COLORS.PREVIOUS_HEADER, textColor: COLORS.TEXT_BLACK }
    //         })),
    //         ...columns.map(c => ({
    //             content: c.replace(/_/g, ' '),
    //             styles: { halign: 'center', fillColor: COLORS.CURRENT_HEADER, textColor: COLORS.TEXT_BLACK }
    //         }))
    //     ];

    //     const bodyRows = Object.entries(grouped).map(([id, colData]) => {
    //         const oldVals = columns.map(c => colData[c]?.old ?? '');
    //         const newVals = columns.map(c => colData[c]?.new ?? '');

    //         const mismatches = columns.filter(c => colData[c]?.old !== colData[c]?.new);

    //         const analysis =
    //             mismatches.length === columns.length
    //                 ? 'Mismatch in all variables'
    //                 : `Mismatch in ${mismatches.map(c =>
    //                     c.replace(/_/g, ' ').toUpperCase()
    //                 ).join(', ')}`;

    //         return [id, ...oldVals, ...newVals, analysis];
    //     });


    //     doc.autoTable({
    //         startY: currentY,
    //         head: [headerRow1, headerRow2],
    //         body: bodyRows,
    //         styles: {
    //             fontSize: 9,
    //             cellPadding: 2,
    //             valign: 'middle',
    //             lineColor: COLORS.BORDER,
    //             lineWidth: 0.3,
    //             textColor: COLORS.TEXT_BLACK
    //         },
    //         didParseCell(data) {
    //             if (
    //                 data.section === 'body' &&
    //                 data.column.index > columns.length &&
    //                 data.column.index <= columns.length * 2
    //             ) {
    //                 const row = data.row.raw;
    //                 const colIndex = data.column.index - columns.length - 1;
    //                 const oldVal = row[1 + colIndex];
    //                 const newVal = row[1 + columns.length + colIndex];

    //                 if (oldVal !== newVal) {
    //                     data.cell.styles.fillColor = COLORS.MISMATCH_CELL;
    //                 }
    //             }
    //         },
    //         margin: { left: 10, right: 10 }
    //     });

    //     const pageCount = doc.getNumberOfPages();
    //     for (let i = 1; i <= pageCount; i++) {
    //         doc.setPage(i);
    //         doc.setFontSize(9);
    //         doc.setFont('helvetica', 'normal');
    //         doc.text(
    //             `Page ${i} of ${pageCount}`,
    //             pageWidth - 14,
    //             200,
    //             { align: 'right' }
    //         );
    //     }

    //     doc.save(`${userId}_Control_Report.pdf`);
    // };

    const downloadJsonAsPDF = (data = []) => {
        if (!data || !data.length) return;

        const doc = new jsPDF({
            orientation: 'landscape',
            unit: 'mm',
            format: 'a4'
        });

        const pageWidth = doc.internal.pageSize.getWidth();
        let currentY = 30;

        const formatDate = (dateStr) =>
            dateStr
                ? new Date(dateStr).toLocaleDateString('en-GB', {
                    day: '2-digit',
                    month: 'short',
                    year: 'numeric'
                })
                : '';

        const userId = localStorage.getItem('userid') || 'Unknown User';
        const createdDate = data[0]?.created_date
            ? formatDate(data[0].created_date)
            : formatDate(new Date());

        const capitalize = (str) =>
            str
                ? str
                    .split(' ')
                    .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
                    .join(' ')
                : '';

        const displayPrefix = capitalize(Prefix);
        const displayTableName = capitalize(selectedName);

        /* ---------- TITLE ---------- */
        doc.setFontSize(16);
        doc.setFont('helvetica', 'bold');
        doc.text(
            `Monitoring Report - ${displayTableName} Classification Change`,
            pageWidth / 2,
            20,
            { align: 'center' }
        );

        /* ---------- METADATA ---------- */
        doc.setFontSize(10);
        const metaItems = [
            ['Report Generated By (User ID):', userId],
            ['Report Generated On:', createdDate],
            ['Department:', displayPrefix],
            ['Table Name:', displayTableName],
            ['Reporting Date:', formatDate(data[0].new_reporting_date)]
        ];
        metaItems.forEach(([label, value]) => {
            doc.setFont('helvetica', 'bold');
            doc.text(label, 14, currentY);
            const labelWidth = doc.getTextWidth(label) + 2;
            doc.setFont('helvetica', 'normal');
            doc.text(value || '-', 14 + labelWidth, currentY);
            currentY += 6;
        });

        currentY += 6; // space after metadata

        /* ---------- TABLE DATA ---------- */
        // const COLORS = {
        //     PREVIOUS_HEADER: [242, 220, 219],
        //     CURRENT_HEADER: [218, 238, 243],
        //     ANALYSIS_HEADER: [230, 230, 230],
        //     BORDER: [0, 0, 0],
        //     TEXT_BLACK: [0, 0, 0],
        //     MISMATCH_CELL: [252, 213, 180]
        // };

        const COLORS = {
            PREVIOUS_HEADER: [242, 220, 219],
            CURRENT_HEADER: [218, 238, 243],
            ANALYSIS_HEADER: [230, 230, 230],
            BORDER: [0, 0, 0],
            TEXT_BLACK: [0, 0, 0],
            MISMATCH_CELL: [252, 213, 180],   // NEW VALUE mismatch
            CURRENT_MATCH_CELL: [198, 239, 206] // CURRENT VALUE (green)
        };

        // Define column names in order
        const columns = ['CUST_TYPE', 'CUST_SUB_TYPE', 'ECONOMIC_AGENT', 'SEQ_NO'];

        // Table headers: CUSTOMER ID, previous 4, current 4, CLASS, SUBCLASS
        const headerRow1 = [
            { content: 'CUSTOMER ID', rowSpan: 2, styles: { halign: 'center', valign: 'middle', fillColor: COLORS.ANALYSIS_HEADER, textColor: COLORS.TEXT_BLACK } },
            { content: 'CUSTOMER NAME', rowSpan: 2, styles: { halign: 'center', valign: 'middle', fillColor: COLORS.ANALYSIS_HEADER, textColor: COLORS.TEXT_BLACK } },
            { content: 'PREVIOUS VALUE', colSpan: 4, styles: { halign: 'center', fillColor: COLORS.PREVIOUS_HEADER, textColor: COLORS.TEXT_BLACK } },
            { content: 'NEW VALUE', colSpan: 4, styles: { halign: 'center', fillColor: COLORS.CURRENT_HEADER, textColor: COLORS.TEXT_BLACK } },
            { content: 'COUNTERPARTY CLASS', rowSpan: 2, styles: { halign: 'center', valign: 'middle', fillColor: COLORS.ANALYSIS_HEADER, textColor: COLORS.TEXT_BLACK } },
            { content: 'COUNTERPARTY SUBCLASS', rowSpan: 2, styles: { halign: 'center', valign: 'middle', fillColor: COLORS.ANALYSIS_HEADER, textColor: COLORS.TEXT_BLACK } }
        ];

        // Column headers (uppercase, no underscores)
        const headerRow2 = [
            ...columns.map(c => ({ content: c.replace(/_/g, ' '), styles: { halign: 'center', fillColor: COLORS.PREVIOUS_HEADER, textColor: COLORS.TEXT_BLACK } })),
            ...columns.map(c => ({ content: c.replace(/_/g, ' '), styles: { halign: 'center', fillColor: COLORS.CURRENT_HEADER, textColor: COLORS.TEXT_BLACK } }))
        ];

        // Body rows
        // Body rows
        const bodyRows = data.map(row => [
            row.pk_value.split('|')[1],                       // 0 CUSTOMER ID
            row.counterparty_name?.toUpperCase() || '',       // 1 CUSTOMER NAME

            row.old_cust_type || '',                          // 2 PREV CUST TYPE
            row.old_cust_sub_type || '',                      // 3 PREV CUST SUB TYPE
            row.old_economic_agent || '',                     // 4 PREV ECONOMIC AGENT
            row.old_seq_no || '',                             // 5 PREV SEQ NO

            row.new_cust_type || '',                          // 6 CURR CUST TYPE
            row.new_cust_sub_type || '',                      // 7 CURR CUST SUB TYPE
            row.new_economic_agent || '',                     // 8 CURR ECONOMIC AGENT
            row.new_seq_no || '',                             // 9 CURR SEQ NO

            row.counterparty_class?.replace(/_/g, ' ') || '', // 10 CLASS
            row.counterparty_subclass?.replace(/_/g, ' ') || '' // 11 SUBCLASS
        ]);



        // Generate table
        doc.autoTable({
            startY: currentY,
            head: [headerRow1, headerRow2],
            body: bodyRows,

            rowPageBreak: 'avoid',

            styles: {
                fontSize: 9,
                cellPadding: 2,
                valign: 'middle',
                lineColor: COLORS.BORDER,
                lineWidth: 0.3,
                textColor: COLORS.TEXT_BLACK,
                // overflow: 'hidden'
            },

            columnStyles: {
                5: { cellWidth: 20, halign: 'center', overflow: 'hidden' },
                9: { cellWidth: 20, halign: 'center', overflow: 'hidden' }
            },

            // didParseCell: data => {
            //     if (data.section !== 'body') return;

            //     const row = data.row.raw;
            //     const oldVals = row.slice(2, 6);
            //     const newVals = row.slice(6, 10);

            //     if (data.column.index >= 2 && data.column.index <= 9) {
            //         const idx =
            //             data.column.index <= 5
            //                 ? data.column.index - 2
            //                 : data.column.index - 6;

            //         if (oldVals[idx] !== newVals[idx]) {
            //             data.cell.styles.fillColor = COLORS.MISMATCH_CELL;
            //         }
            //     }
            // }

            didParseCell: data => {
                if (data.section !== 'body') return;

                const row = data.row.raw;
                const oldVals = row.slice(2, 6); // CURRENT VALUE
                const newVals = row.slice(6, 10); // NEW VALUE

                const colIndex = data.column.index;

                // CURRENT VALUE columns (2–5)
                if (colIndex >= 2 && colIndex <= 5) {
                    const idx = colIndex - 2;

                    if (oldVals[idx] !== newVals[idx]) {
                        data.cell.styles.fillColor = COLORS.CURRENT_MATCH_CELL; // green
                    }
                }

                // NEW VALUE columns (6–9)
                if (colIndex >= 6 && colIndex <= 9) {
                    const idx = colIndex - 6;

                    if (oldVals[idx] !== newVals[idx]) {
                        data.cell.styles.fillColor = COLORS.MISMATCH_CELL; // mismatch
                    }
                }
            }

        });


        // Footer: page numbers
        const pageCount = doc.getNumberOfPages();
        for (let i = 1; i <= pageCount; i++) {
            doc.setPage(i);
            doc.setFontSize(9);
            doc.setFont('helvetica', 'normal');
            doc.text(`Page ${i} of ${pageCount}`, pageWidth - 14, 200, { align: 'right' });
        }

        doc.save(`${userId}_Control_Report.pdf`);
    };



    const handleSubmit = async () => {
        setFormSubmitted(true);
        setShowNotifyModal(false);

        if (notifyType === 'IN') {
            await handleUploadAndNotify('IN', allErrors, validationErrors, errorMessages);
        } else if (notifyType === 'EOD') {
            await handleUploadAndNotify('EOD', allErrors, validationErrors, errorMessages);
        }

        setShowConfirmationModal(true);
        setShowNotifyModalAfterConfirmation(true);
    };

    const handleUploadAndNotify = async (notifyType) => {
        try {
            setLoading1(true);
            // setIsUploading(true);

            if (!file) {
                console.error("No file selected for upload.");
                setUploadStatus("No file selected.");
                setLoading1(false);
                // setIsUploading(false);
                return;
            }

            // Prepare blob only from validRecords
            const validRecordsBlob = new Blob(
                Array.isArray(validRecords)
                    ? validRecords.map(record => record + "\n")
                    : [validRecords],
                { type: "text/plain" }
            );

            const errorData = "N"; // Since we're not using error records anymore
            setErrorData(errorData);
            const fileNameNoExt = file.name.replace('.txt', '');

            // Create FormData and append only the validRecords blob
            const formData = new FormData();
            formData.append('file', validRecordsBlob, `${selectedName}.txt`);

            const startTime1 = Date.now();
            console.log("Start Time upload:", new Date(startTime1).toLocaleTimeString());

            // Upload
            const uploadResponse = await axios.post(uploadMutiple, formData, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                    'userId': localStorage.getItem('userid'),
                    'x-csrf-token': csrfToken,
                },
                withCredentials: true,
                onUploadProgress: (progressEvent) => {
                    const percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total);
                    setUploadProgress(percentCompleted);
                },
            });

            if (uploadResponse.status === 200) {
                const endTime = Date.now();
                console.log("End Time upload:", new Date(endTime).toLocaleTimeString());

                await callAdditionalApi(selectedName, notifyType, errorData);

                // Reset form after successful upload
                handleClearFile();
                setShowModal(false);
                setPreviewData([]);
            }

        } catch (uploadError) {
            if (uploadError.response?.status === 409) {
                setUploadStatus('File already exists.');
                setShowModal(false);
                setPreviewData([]);
                setShowNotifyModal(true);
                setModalMessage(uploadError.response.data.message);
            } else {
                console.error('Error uploading file:', uploadError.response?.data || uploadError.message);
                setUploadStatus('Error uploading file.');
            }
        } finally {
            setLoading1(false);
            // setIsUploading(false);
        }
    };

    const recordsCount = previewData.length > 1 ? previewData.length - 1 : 0;
    console.log("recordsCount", recordsCount);
    const callAdditionalApi = async (fileName, filePath, notifyType, errorData, errorFileName) => {
        try {
            let config = {
                headers: {
                    "userId": localStorage.getItem('userid'), 'x-csrf-token': csrfToken,
                },
                withCredentials: true,
                params: {
                    "tableName": selectedName,
                    'recordsCount': recordsCount,
                    "Notifications": "IN",
                    "filePath": "/saswork/nas/" + selectedName + ".txt",
                    "dataModel": "BDM",
                    "templateType": "bulkupload",
                    "keyValidation": "Y",
                    "colValidation": "N",
                    "dept": Prefix,
                    "allowModify": " ",
                    "Maker_Remarks": "",
                    "allowUpload": "N"


                }
            };



            const response = await axios.post(Bulkuploaddata, {}, config);

            if (response.data && response.data.active_status && response.data.template_type) {
                localStorage.setItem("active_status", response.data.active_status);
                localStorage.setItem("template_type", response.data.template_type);
                localStorage.setItem("stage", response.data.stage);
                console.log("Stored in localStorage:", {
                    active_status: response.data.active_status,
                    template_type: response.data.template_type,
                    stage: response.data.stage,
                });
            } else {
                console.log("active_status or template_type is missing or response.data is null");
            }

            // if (response.data && response.data.status === "success") {
            //     const apiMessage = response.data.message;
            //     const formattedName = `<strong>${toTitleCase(selectedName)}</strong>`;

            //     // Replace whole word match (case-insensitive) with <strong> version
            //     const updatedMessage = apiMessage.replace(
            //         new RegExp(`\\b${selectedName}\\b`, 'gi'),
            //         formattedName
            //     );

            //     setMessageType('success');
            //     setModalMessage(updatedMessage); // you already use dangerouslySetInnerHTML
            //     setShowNotifyModal(false);
            //     setShowModal(true);
            //     setrecordSuccess("Y");
            //     setShowGenerateReport(true);
            //     setShowGenerateReportButton(true);

            //     if (response.data.secondary_control_status === "FAILED") {
            //         try {
            //             const responsefromFile = await fetch(
            //                 `/uploads/${Prefix}_${selectedName}_scenario1.json`
            //             );

            //             if (!responsefromFile.ok) {
            //                 throw new Error("Failure issue JSON not available");
            //             }

            //             const jsonData = await responsefromFile.json();
            //             setFailureReportData(jsonData);

            //             console.log("Fetched Failure Issue JSON:", jsonData);
            //         } catch (err) {
            //             console.error("Error fetching failure issue JSON:", err.message);
            //         }
            //     }

            //     // try {
            //     //     const responsefromFile = await fetch(`/uploads/Finance_npa_001_scenario2.json`);

            //     //     if (!responsefromFile.ok) {
            //     //         throw new Error("JSON file not available");
            //     //     }

            //     //     const jsonData = await responsefromFile.json();
            //     //     setJsonReportData(jsonData);   // store it

            //     //     console.log("Fetched JSON report data:", jsonData);
            //     // } catch (err) {
            //     //     console.error("Error fetching JSON file:", err.message);
            //     // }

            // }

            if (response.data && response.data.status === "success") {

                //  special condition FIRST
                if (response.data.secondary_control_status === "FAILED") {
                    setMessageType('warning'); // or 'error' if you prefer
                    setModalMessage('Data Mismatch identified with Control List table');
                } else {
                    const apiMessage = response.data.message;
                    const formattedName = `<strong>${toTitleCase(selectedName)}</strong>`;

                    const updatedMessage = apiMessage.replace(
                        new RegExp(`\\b${selectedName}\\b`, 'gi'),
                        formattedName
                    );

                    setMessageType('success');
                    setModalMessage(updatedMessage);
                }

                setShowNotifyModal(false);
                setShowModal(true);
                setrecordSuccess("Y");
                setShowGenerateReport(true);
                setShowGenerateReportButton(true);

                // 🔽 keep your existing failure JSON logic
                if (response.data.secondary_control_status === "FAILED") {
                    try {
                        const responsefromFile = await fetch(
                            `/uploads/${Prefix}_${selectedName}_scenario1.json`
                        );

                        if (!responsefromFile.ok) {
                            throw new Error("Failure issue JSON not available");
                        }

                        const jsonData = await responsefromFile.json();
                        setFailureReportData(jsonData);

                        console.log("Fetched Failure Issue JSON:", jsonData);
                    } catch (err) {
                        console.error("Error fetching failure issue JSON:", err.message);
                    }
                }
            }

            else if (response.data?.status === "deltaDetected") {

                setMessageType('warning');
                setModalMessage(response.data.message);
                setrecordSuccess("N");
                setShowModal(true);
                setShowGenerateReport(true);
                setShowGenerateReportButton(true);

                /* FETCH SCENARIO-2 FILE HERE */
                try {
                    const responsefromFile = await fetch(
                        `/uploads/${Prefix}_${selectedName}_scenario2.json`
                    );

                    if (!responsefromFile.ok) {
                        throw new Error("Scenario-2 JSON file not available");
                    }

                    const jsonData = await responsefromFile.json();
                    setJsonReportData(jsonData);

                    console.log("Fetched Scenario-2 JSON:", jsonData);

                } catch (err) {
                    console.error("Error fetching Scenario-2 file:", err.message);
                }

                //    if (response.data.secondary_control_status === "FAILED") {
                // try {
                //     // const responsefromFile = await fetch(
                //     //     `/uploads/${Prefix}_${selectedName}_scenario1.json`
                //     // );
                //     const responsefromFile = await fetch(
                //         `/uploads/Risk_specialized_lending_scenario1.json`
                //     );

                //     if (!responsefromFile.ok) {
                //         throw new Error("Failure issue JSON not available");
                //     }

                //     const jsonData = await responsefromFile.json();
                //     setFailureReportData(jsonData);

                //     console.log("Fetched Failure Issue JSON:", jsonData);
                // } catch (err) {
                //     console.error("Error fetching failure issue JSON:", err.message);
                // }
                // }

                /* FETCH FAILURE ISSUE JSON */
                // try {
                //     const responsefromFile = await fetch(
                //         `/uploads/${Prefix}_${selectedName}_scenario1.json`
                //     );

                //     if (!responsefromFile.ok) {
                //         throw new Error("Failure issue JSON not available");
                //     }

                //     const jsonData = await responsefromFile.json();
                //     setFailureReportData(jsonData);

                //     console.log("Fetched Failure Issue JSON:", jsonData);

                // } catch (err) {
                //     console.error("Error fetching failure issue JSON:", err.message);
                // }
            }

            else {
                const inserted_count = Number(response?.data?.inserted_count) || 0;
                let failed_count = Number(response?.data?.failed_count) || 0;
                const totalRecords = Number(recordsCount) || 0;


                if (inserted_count === 0.0) {
                    failed_count = totalRecords;
                }

                const record = totalRecords - inserted_count;  // This will always give correct failed count

                // const message = `${recordsCount} record of <strong>${toTitleCase(selectedName)}</strong> Uploaded Failed`;
                const message = `Upload Failed - ${recordsCount} records of <strong>${toTitleCase(selectedName)}`;
                // Show the message (log, alert, toast, etc.)
                console.log(message);

                setModalMessage(message);
                setMessageType('warning');
                setrecordSuccess("N");
                setShowModal(true);
                setShowGenerateReport(true); // Show the "Generate Report" button
                setShowGenerateReportButton(true);


            }
            // setUploadStatus('File uploaded and converted successfully!');
            setUploadStatus();
            // setrecordSuccess('N');
            setUploadSuccess(true);
            setShowNotifyModal(false); // Show the notify modal after successful upload

        } catch (error) {
            setShowNotifyModal(false);
            console.error('Error in additional API call:', error.response ? error.response.data : error.message);
        }
    };

    const handleClearFile = () => {
        // setSelectedFile(null);
        // setFile(null);
        setUploadSuccess(false);
        setErrMsg('');
        setPreviewData([]); // Clear preview data
        setShowNotifyModal(false);

    };

    const handleCloseModal = () => {
        setShowModal(false);
    }


    const callFinalApi = async (fileName, filePath, notifyType, errorData, errorRecordsFileName) => {
        try {
            let config = {
                headers: {
                    "userId": localStorage.getItem('userid'), 'x-csrf-token': csrfToken,
                },
                withCredentials: true,
                params: {
                    "tableName": selectedName,
                    'recordsCount': recordsCount,
                    "Notifications": "IN",
                    "filePath": "/saswork/nas/" + selectedName + ".txt",
                    "dataModel": "BDM",
                    // "errorData": "N", 
                    // "errorFileName": fileName + "_error_records",
                    // "activity": "Insert",
                    // "isOCR": "",
                    "templateType": "BDM OCR Upload",
                    "keyValidation": "Y",
                    "colValidation": "N",
                    "dept": Prefix,
                    "allowModify": " ",
                    "Maker_Remarks": "",
                    "allowUpload": "N"

                }
            };
            // const response = await axios.post('http://172.16.119.156:8081/api/rdm/uploadrdmdata', {}, config);
            // const response = await axios.post(uploadbdmdata, {}, config);
            const response = await axios.post(Bulkuploaddata, {}, config);

            if (response.data && response.data.active_status && response.data.template_type) {
                localStorage.setItem("active_status", response.data.active_status);
                localStorage.setItem("template_type", response.data.template_type);
                localStorage.setItem("stage", response.data.stage);

            } else {
                console.log("active_status or template_type is missing or response.data is null");
            }

            if (response.data && response.data.status === "success") {
                const apiMessage = response.data.message;
                const formattedName = `<strong>${toTitleCase(selectedName)}</strong>`;

                // Replace whole word match (case-insensitive) with <strong> version
                const updatedMessage = apiMessage.replace(
                    new RegExp(`\\b${selectedName}\\b`, 'gi'),
                    formattedName
                );

                setMessageType('success');
                setModalMessage(updatedMessage); // you already use dangerouslySetInnerHTML
                setShowNotifyModal(false);
                setShowModal(true);
                setrecordSuccess("Y");
                setShowGenerateReport(true);
                setShowGenerateReportButton(true);

            }
            else {
                const inserted_count = Number(response?.data?.inserted_count) || 0;
                let failed_count = Number(response?.data?.failed_count) || 0;
                const totalRecords = Number(recordsCount) || 0;


                if (inserted_count === 0) {
                    failed_count = totalRecords;
                }

                // 💡 'record' is just used for message display, so it should reflect failed count
                const record = totalRecords - inserted_count;  // This will always give correct failed count

                const message = `Upload Failed - ${recordsCount} records of <strong>${toTitleCase(selectedName)}`;

                // Show the message (log, alert, toast, etc.)

                // Show custom failure message and enable the "Generate Report" button
                // setModalMessage({inserted_count},"out of",{recordsCount},{failed_count},"records failed.","Please check the logs in Data Validation Report.");
                setModalMessage(message);
                setMessageType('warning');
                setrecordSuccess("N");
                setShowModal(true);
                setShowGenerateReport(true); // Show the "Generate Report" button
                setShowGenerateReportButton(true);
            }
            // setUploadStatus('File uploaded and converted successfully!');
            setUploadStatus();
            // setrecordSuccess('N');
            setUploadSuccess(true);
            setShowNotifyModal(false); // Show the notify modal after successful upload

        } catch (error) {
            setShowNotifyModal(false);
            console.error('Error in additional API call:', error.response ? error.response.data : error.message);
        }
    };

    const handleConfirmUpload = async (notifyType) => {
        try {
            setLoading(true);

            if (!file) {
                console.error("No file selected for upload.");
                setUploadStatus("No file selected.");
                setLoading(false);
                return;
            }

            // Convert valid and error records to TXT format
            const validRecordsBlob = new Blob(
                Array.isArray(validRecords1)
                    ? validRecords1.map(record => record + "\n")
                    : [validRecords1],
                { type: "text/plain" }
            );

            const errorData = "N"; // Since we're not using error records anymore
            setErrorData(errorData);
            const fileNameNoExt = file.name.replace('.txt', '');

            // Create FormData and append only the validRecords blob
            const formData = new FormData();
            formData.append('file', validRecordsBlob, `${selectedName}.txt`);
            const startTime1 = Date.now();
            console.log("Start Time upload:", new Date(startTime1).toLocaleTimeString());

            // Upload
            const uploadResponse = await axios.post(uploadMutiple, formData, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                    'userId': localStorage.getItem('userid'),
                    'x-csrf-token': csrfToken,
                },
                withCredentials: true,
                onUploadProgress: (progressEvent) => {
                    const percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total);
                    setUploadProgress(percentCompleted);
                },
            });

            if (uploadResponse.status === 200) {
                const endTime = Date.now();
                console.log("End Time upload:", new Date(endTime).toLocaleTimeString());
                // const uploadedFileName = uploadResponse.data.fileName || validRecordsFileName;
                // const filePath = `${PortURL}/uploads/`;
                const filePath = `/uploads/`;
                const errorData = errorRecords.length > 0 ? "Y" : "N";
                setErrorData(errorData);
                // Call final API with the error file info
                await callFinalApi(selectedName, notifyType, errorData);

                handleClearFile();
                setShowModal(false);
                setPreviewData([]);
            }
        } catch (error) {
            console.error("Error during upload:", error.message);
            setUploadStatus("Error during file processing.");
        } finally {
            setLoading(false);
        }
    };



    const handleImmediateNotify = async () => {
        try {
            await handleUploadAndNotify1('IN');
            setConfirmationMessage('Immediate notification sent successfully.');
        } catch (error) {
            setConfirmationMessage('Error sending immediate notification.');
        }
    };

    const handleEodNotify = async () => {
        try {
            await handleUploadAndNotify1('EOD');
            setConfirmationMessage('End of day notification sent successfully.');
        } catch (error) {
            setConfirmationMessage('Error sending end of day notification.');
        }
    };


    const handleSubmit1 = async () => {
        setFormSubmitted(true); // Mark form as submitted
        setShowNotifyModal(false); // Close the notification modal

        // Call appropriate notify handler
        if (notifyType === 'IN') {
            await handleImmediateNotify();
        } else if (notifyType === 'EOD') {
            await handleEodNotify();
        }

        // ✅ Show preview modal after processing
        setShowPreview(true);
        setShowModal(true); // <-- This ensures the modal opens

        // Optional: show confirmation modal if still needed
        setShowConfirmationModal(true);
        setShowNotifyModalAfterConfirmation(true);
    };

    const handleconfirm = async () => {

        // handleClearFile();
        setPopShowModal(false);
        setShowModal(false);
        // setShowNotifyModal(true);
        handleConfirmUpload();
    }

    const handleConfirmSubmit = async () => {
        setFormSubmitted(true); // Mark form as submitted
        setShowNotifyModal(false); // Close the notification modal

        // Check the selected notification type and call the corresponding function
        if (notifyType === 'IN') {
            await handleImmediate();
        } else if (notifyType === 'EOD') {
            await handleEod();
        }

        // After calling either function, show confirmation modal
        setShowConfirmationModal(true); // Show the confirmation modal
        setShowNotifyModalAfterConfirmation(true); // Flag to show notify modal after confirmation
    };

    const handleUploadAndNotify1 = async (notifyType) => {
        try {
            setLoading(true);

            const originalName = file.name;
            const ext = originalName.substring(originalName.lastIndexOf('.')); // e.g. ".xlsx"
            const newFileName = `${selectedName}${ext}`; // e.g. EmployeeMaster.xlsx

            const formData = new FormData();
            formData.append('file', file, newFileName);


            // const uploadResponse = await axios.post('http://172.16.119.156:3001/uploadocrfiles', formData, {
            const uploadResponse = await axios.post(mqemocr, formData, {

                headers: {
                    'Content-Type': 'multipart/form-data',
                    'userId': localStorage.getItem('userid'),
                    'x-csrf-token': csrfToken,
                },
                withCredentials: true,
            });

            if (uploadResponse.status === 200) {
                const fileName = file.name;
                // const fileNameNoExt = fileName.replace('.txt', '');
                const filePath = "/sasdepot/dgms/frontend/d-v3/files/uploadocrfiles/";
                await callAdditionalApi1(newFileName, filePath, notifyType);

                // Reset form after successful upload
                // handleClearFile();
                setPopShowModal(false); // Close the preview modal if it's open
                setPreviewData([]);
            }
        } catch (uploadError) {
            if (uploadError.response && uploadError.response.status === 409) { // Assuming 409 Conflict for file already exists
                setUploadStatus('File already exists.');
                setPopShowModal(false); // Close the preview modal if open

                setShowNotifyModal(true); // Show notification modal for file exists
                setModalMessage(uploadError.response.data.message); // Set modal message
            } else {
                console.error('Error uploading file:', uploadError.response ? uploadError.response.data : uploadError.message);
                setUploadStatus('Error uploading file.');
            }
        } finally {
            setLoading(false);
        }
    };

    const handleImmediate = async () => {
        try {
            await handleNotify('IN');
            setConfirmationMessage('Immediate notification sent successfully.');
        } catch (error) {
            setConfirmationMessage('Error sending immediate notification.');
        }
    };

    const handleEod = async () => {
        try {
            await handleNotify('EOD');
            setConfirmationMessage('End of day notification sent successfully.');
        } catch (error) {
            setConfirmationMessage('Error sending end of day notification.');
        }
    };


    const handleNotify = async (notifyType) => {
        try {
            setLoading(true);

            const formData = new FormData();
            formData.append('file', file);



            // if (uploadResponse.status === 200) {
            const fileName = file.name;
            // const fileNameNoExt = fileName.replace('.txt', '');
            const filePath = "/sasdepot/dgms/frontend/d-v3/files/uploadocrfiles/";
            await callAdditionalApi1(fileName, filePath, notifyType);

            // Reset form after successful upload
            // handleClearFile();
            setPopShowModal(false); // Close the preview modal if it's open

        } catch (uploadError) {
            if (uploadError.response && uploadError.response.status === 409) { // Assuming 409 Conflict for file already exists
                setUploadStatus('File already exists.');
                setPopShowModal(false); // Close the preview modal if open
                setPreviewData([]);
                setShowNotifyModal(true); // Show notification modal for file exists
                setModalMessage(uploadError.response.data.message); // Set modal message
            } else {
                console.error('Error uploading file:', uploadError.response ? uploadError.response.data : uploadError.message);
                setUploadStatus('Error uploading file.');
            }
        } finally {
            setLoading(false);
        }
    };


    const callAdditionalApi1 = async (filePath, notifyType) => {
        setWsLoading(true);
        const socket = new WebSocket(OcrWebsocket);
        const currentSessionId = localStorage.getItem('sessionId');
        console.log("currentSessionId", currentSessionId);
        socket.onopen = async () => {
            console.log("WebSocket connection established");

            // Extracting the file format and file name dynamically

            const format = filePath.includes('.') ? filePath.substring(filePath.lastIndexOf('.')) : "";
            const fileNameWithoutExtension = filePath.substring(0, filePath.lastIndexOf('.'));

            console.log("format file", format);
            console.log("fileNameWithoutExtension", fileNameWithoutExtension);
            const config = {
                headers: {
                    "userId": localStorage.getItem('userid'),
                    "sessionId": localStorage.getItem('sessionId'),
                    'x-csrf-token': csrfToken,
                },
                withCredentials: true,
                params: {
                    // "fileName": fileNameWithoutExtension,
                    "fileName": selectedName,
                    "dataModel": "BDM",
                    "role": localStorage.getItem('userRole'),
                    "format": format,
                    "dataFormat": "",
                    "dataType": "",
                    "dept": Prefix
                }
            };

            // console.log("dbfileName", fileName);
            try {
                const response = await axios.post(OcrMethod, {}, config);
            } catch (error) {
                console.error("API error:", error);
                setWsLoading(false);
            }
        };


        let wsMessageHandled = false; // Declare this outside the onmessage block

        socket.onmessage = (event) => {
            if (wsMessageHandled) return; // Prevent multiple calls
            wsMessageHandled = true;

            try {
                const responseData = JSON.parse(event.data);
                console.log("WebSocket message received:", responseData);

                if (!responseData.data) {
                    console.error("Missing 'data' field in WebSocket message.");
                    setWsLoading(false);
                    return;
                }

                const parsedData = typeof responseData.data === "string"
                    ? JSON.parse(responseData.data)
                    : responseData.data;

                if (parsedData.out_path) {
                    // Clear all related states BEFORE calling fetchCSVData
                    setcolumnDropdown({});
                    // setColumnDetails({});
                    setPreviewData([]);
                    setIsUploadAllowed(false);
                    setvalidErrorRecords([]);
                    setValidationErrors([]);
                    setErrorMessages([]);
                    setJsonReportData([]);
                    setFailureReportData([]);
                    setvalidRecords('');
                    setvalidRecords1('');
                    setIsValidationPassed(false);

                    // Delay fetch slightly to ensure all state resets are processed
                    setTimeout(() => {
                        fetchCSVData(parsedData.out_path);
                        setWsLoading(false);
                    }, 0);
                }

            } catch (error) {
                console.error("Error processing WebSocket message:", error.message);
                setWsLoading(false);
            }
        };


        const validateDropdownValues1 = async (csvData, columnDropdown) => {
            const totalRows = csvData.rows.length - 1; // Exclude header
            const batchSize = 25000; // Major batch splitting
            const totalBatches = Math.ceil(totalRows / batchSize);

            if (!columnDropdown?.details?.length) {
                console.warn("JSON file missing 'details', skipping validation.");
                return true;
            }

            const dropdownColumns = {};
            const columnLengths = {};
            const columnTypes = {};
            const columnKeys = {};

            const dateColumnIndices = [];
            const intColumnIndices = [];
            const decimalColumnIndices = [];
            const booleanColumnIndices = [];
            const doubleColumnIndices = [];
            const characterColumnIndices = [];
            const floatColumnIndices = [];

            columnDropdown.details.forEach((col, idx) => {
                const key = col.columnName.trim().toLowerCase();
                columnTypes[key] = col.columnType?.toLowerCase();
                columnKeys[key] = col.columnKey?.toLowerCase();

                if (typeof col.columnFunction === 'string') {
                    const dropdownMatch = col.columnFunction.match(/dropdown:\[(.*?)\]/i);
                    if (dropdownMatch) {
                        dropdownColumns[key] = dropdownMatch[1].split(",").map(val => val.trim().toUpperCase()).filter(Boolean);
                    }
                }

                if (col.columnLength) {
                    if (typeof col.columnLength === 'string' && col.columnLength.includes(',')) {
                        const [precision, scale] = col.columnLength.split(',').map(num => parseInt(num.trim(), 10));
                        columnLengths[key] = { precision, scale };
                    } else {
                        columnLengths[key] = parseInt(col.columnLength, 10);
                    }
                }

                switch (col.columnType?.toLowerCase()) {
                    case "date": dateColumnIndices.push(idx); break;
                    case "integer": intColumnIndices.push(idx); break;
                    case "decimal": decimalColumnIndices.push(idx); break;
                    case "float": floatColumnIndices.push(idx); break;
                    case "boolean": booleanColumnIndices.push(idx); break;
                    case "double": doubleColumnIndices.push(idx); break;
                    case "character": characterColumnIndices.push(idx); break;
                }
            });

            const parsedRows = new Map();
            const processErrorsBatch1 = async (start, end) => {
                console.log(`Processing errors for rows ${start + 1} to ${end}`);
                const batchErrors = [];
                const primaryKeyColumns = Object.keys(columnKeys).filter(k => columnKeys[k] === "primary key");

                const chunkSize = totalRows > 100000 ? 1000 : totalRows > 50000 ? 2000 : 5000;
                const dateFormatRegex = /^\d{4}-\d{2}-\d{2}$/;
                const exponentialRegex = /^[+-]?\d+(\.\d+)?[eE][+-]?\d+$/;

                const uniqueRows = new Map();
                const duplicateEntries = [];

                for (let i = start; i < end; i += chunkSize) {
                    const chunkEnd = Math.min(i + chunkSize, end);

                    for (let rowIndex = i; rowIndex < chunkEnd; rowIndex++) {
                        const row = csvData.rows[rowIndex + 1];
                        if (!parsedRows.has(rowIndex)) {
                            const matches = [...row.matchAll(/(?<=^|,)(?:"([^"]*)"|([^,]*))(?=,|$)/g)].map(m => m[1] ?? m[2] ?? '');
                            parsedRows.set(rowIndex, matches);
                        }
                        const matches = parsedRows.get(rowIndex);

                        const lineNumber = rowIndex + 1;
                        const errorMessages = [];

                        const cleanedRow = row.trim();
                        // const primaryKeyValues = primaryKeyColumns.map(pk => matches[csvData.headers.indexOf(pk)]).join(",");
                        const primaryKeyValues = primaryKeyColumns.map((pk) => {
                            const colIndex = csvData.headers.indexOf(pk);
                            if (colIndex === -1) {
                                return `${pk} (header missing)`;
                            }

                            const value = matches[colIndex]?.trim();
                            if (!value) {
                                return `Column ${colIndex + 1}`;
                            }

                            return value;
                        }).join(", ");

                        if (uniqueRows.has(cleanedRow)) {
                            errorMessages.push(`Duplicate entry found for primary key: ${primaryKeyValues}.`);
                        } else {
                            uniqueRows.set(cleanedRow, primaryKeyValues);
                        }

                        csvData.headers.forEach((header, columnIndex) => {
                            const columnName = header.trim().toLowerCase();
                            let cellValue = matches[columnIndex]?.trim() || '';

                            if (dropdownColumns[columnName] && !dropdownColumns[columnName].includes(cellValue.toUpperCase())) {
                                errorMessages.push(`Column '${columnName}' has invalid dropdown value '${cellValue}'.`);
                            }

                            // if ((columnKeys[columnName] === 'primary key' || columnKeys[columnName] === 'not null') && !cellValue) {
                            //   errorMessages.push(`Column '${columnName}' is required but missing.`);
                            // }


                            if (columnLengths[columnName]) {
                                const maxLen = columnLengths[columnName];
                                const formatted = cellValue.replace(/\(([^)]+)\)/g, "-$1");
                                const actualLength = formatted.length;

                                if (typeof maxLen === 'object') {
                                    const { precision, scale } = maxLen;
                                    const [intPart, decPart = ''] = formatted.replace(/[^\d.]/g, '').split('.');
                                    const totalDigits = intPart.length + decPart.length;
                                    if (totalDigits > precision || decPart.length > scale) {
                                        errorMessages.push(`Column '${columnName}' exceeds precision/scale.`);
                                    }
                                } else if (actualLength > maxLen) {
                                    errorMessages.push(`Column '${columnName}' exceeds length ${maxLen}.`);
                                }
                            }

                            const detectedFormat = detectValueFormat1(cellValue).toLowerCase();
                            let expectedType = getColumnTypeFromDetails1(columnName.toLowerCase());

                            if (exponentialRegex.test(cellValue)) {
                                let columnType = "unknown";
                                if (columnDetails?.double_columns?.[0]?.col_name.some(col => col.toLowerCase() === columnName)) {
                                    columnType = "double";
                                } else if (columnDetails?.decimal_columns?.[0]?.col_name.some(col => col.toLowerCase() === columnName)) {
                                    columnType = "decimal";
                                } else if (columnDetails?.float_columns?.[0]?.col_name.some(col => col.toLowerCase() === columnName)) {
                                    columnType = "float";
                                } else if (columnDetails?.int_columns?.[0]?.col_name.some(col => col.toLowerCase() === columnName)) {
                                    columnType = "int";
                                } else if (columnDetails?.varchar_columns?.[0]?.col_name.some(col => col.toLowerCase() === columnName)) {
                                    columnType = "varchar";
                                } else if (columnDetails?.number_columns?.[0]?.col_name.some(col => col.toLowerCase() === columnName)) {
                                    columnType = "number";
                                } else if (columnDetails?.boolean_columns?.[0]?.col_name.some(col => col.toLowerCase() === columnName)) {
                                    columnType = "boolean";
                                } else if (columnDetails?.date_columns?.[0]?.col_name.some(col => col.toLowerCase() === columnName)) {
                                    columnType = "date";
                                }

                                if (!["double", "decimal", "float"].includes(columnType)) {
                                    errorMessages.push(`Column '${columnName}' contains an Exponential value '${cellValue}' which is not allowed.`);
                                }
                            }

                            if ((columnKeys[columnName] === 'primary key' || columnKeys[columnName] === 'not null') && !cellValue) {
                                errorMessages.push(`Column '${columnName}' is required but missing.`);
                            }
                            if (cellValue !== "") {
                                if (expectedType === "int") {
                                    if (detectValueFormat1(cellValue) !== "int") {
                                        errorMessages.push(`Column '${columnName}' should be Integer but found: ${cellValue}`);
                                    }
                                }

                                else if (["decimal", "double", "float", "number"].includes(expectedType)) {
                                    // Proceed with number validation only if the value is not missing
                                    // const numericValue = Number(cellValue.replace(/,/g, ''));
                                    // if (isNaN(numericValue) || cellValue.trim() === "") {
                                    //     errorMessages.push(`Column '${columnName}' should be a valid number but found: ${cellValue}`);
                                    // }
                                    // let sanitized = cellValue.replace(/\s/g, '').replace(/,/g, '');
                                    let sanitized = cellValue.replace(/-\s+/g, '-').replace(/,/g, '');

                                    if (/^\(\d+(\.\d+)?\)$/.test(sanitized)) {
                                        sanitized = '-' + sanitized.replace(/[()]/g, '');
                                    }
                                    const numericValue = Number(sanitized);

                                    if (isNaN(numericValue) || cellValue.trim() === "") {
                                        errorMessages.push(`Column '${columnName}' should be a valid number but found: ${cellValue}`);
                                    }

                                }
                                else if (expectedType === "date") {
                                    if (detectValueFormat1(cellValue) !== "date") {
                                        errorMessages.push(`Column '${columnName}' should be in YYYY-MM-DD format but found: ${cellValue}`);
                                    }
                                } else if (expectedType === "boolean") {
                                    if (detectValueFormat1(cellValue) !== "boolean") {
                                        errorMessages.push(`Column '${columnName}' should be true or false but found: ${cellValue}`);
                                    }
                                }
                            }
                        });

                        if (errorMessages.length > 0) {
                            batchErrors.push(`${primaryKeyValues}|Error at Line ${lineNumber}:# ${errorMessages.join(' # ')}`);
                        }
                    }
                }

                if (duplicateEntries.length > 0) {
                    duplicateEntries.forEach(({ primaryKeyValues, lineNumber }) => {
                        batchErrors.push(`${primaryKeyValues}|Error at Line ${lineNumber}: Duplicate entry found.`);

                    });
                }

                return batchErrors;
            };




            const validationPromises = [];
            for (let batchIndex = 0; batchIndex < totalBatches; batchIndex++) {
                const start = batchIndex * batchSize;
                const end = Math.min((batchIndex + 1) * batchSize, totalRows);
                validationPromises.push(processErrorsBatch1(start, end)); // Run batches in parallel
            }


            let allErrors = [];
            // Collect errors as batches finish
            const results = await Promise.all(validationPromises);

            results.forEach(batchErrors => {
                if (batchErrors.length > 0) {
                    allErrors.push(...batchErrors);
                    setErrorMessages(prev => [...(prev || []), ...batchErrors]); // Progressive UI updates
                }
            });


            // const sortedErrors = allErrors.sort((a, b) => parseInt(a.split('|')[0]) - parseInt(b.split('|')[0]));
            const sortedErrors = allErrors.sort((a, b) => parseInt(a.split('|')[1]) - parseInt(b.split('|')[1]));


            if (sortedErrors.length > 0) {
                setErrorMessages(sortedErrors); // Final sorted version
                setIsUploadAllowed(true);
                setvalidErrorRecords(sortedErrors);
                // downloadErrorsAsPDF(sortedErrors)
                console.error("Validation Errors:", sortedErrors);
            } else {
                console.log('No validation errors found!');
            }

            const errorLineNumbers = new Set(
                sortedErrors.map(error => {
                    // Extract line number from error message
                    const parts = error.split('|');
                    const linePart = parts[1]; // Error at Line 3: ...
                    const match = linePart.match(/Line (\d+)/);
                    return match ? parseInt(match[1], 10) : null;
                }).filter(num => num !== null)
            );

            const validRows = [];

            for (let rowIndex = 0; rowIndex < totalRows; rowIndex++) {
                const lineNumber = rowIndex + 1;
                if (!errorLineNumbers.has(lineNumber)) {
                    validRows.push(csvData.rows[lineNumber]); // Note: rows[0] is usually header
                }
            }

            const formattedValidRecords = validRows
                .map(row => {
                    const regex = /(?<=^|,)(?:"([^"]*)"|([^,]*))(?=,|$)/g;
                    const matches = [...row.matchAll(regex)].map(m => m[1] ?? m[2] ?? '');

                    return matches.map((value, index) => {
                        value = value.trim();

                        const columnName = csvData.headers[index]?.trim().toLowerCase();
                        const colType = columnTypes[columnName];
                        const colKey = columnKeys[columnName];

                        // if (dateColumnIndices.includes(index)) {
                        //     return value;
                        // }

                        if (dateColumnIndices.includes(index) && value) {
                            return value;   // valid date → return as-is
                        }


                        if (value.startsWith('(') && value.endsWith(')')) {
                            value = `-${value.slice(1, -1)}`;
                        }

                        value = value.replace(/,/g, '');

                        // 🔹 Insert '/N' for empty Decimal/Double/Float columns when columnKey is null
                        if (
                            !value &&
                            (!colKey || colKey === 'null' || colKey === null) &&
                            ['decimal', 'double', 'float', 'date'].includes(colType)
                        ) {
                            value = '\\N';
                        }

                        return value;
                    }).join('|');
                })
                .join('\n');


            // Save final valid records
            setvalidRecords1(formattedValidRecords);


            return true;
        };




        function detectValueFormat1(value) {
            if (!value || value.trim() === "") return "empty"; // Empty check first

            const lowerValue = value.toLowerCase();
            if (["true", "false"].includes(lowerValue)) return "boolean"; // Boolean check

            const dateRegex = /^\d{4}-\d{2}-\d{2}$/;
            if (dateRegex.test(value)) return "date"; // Strict date format (YYYY-MM-DD)

            // Number checks
            if (!isNaN(value)) {
                if (/^[+-]?\d+$/.test(value)) return "int"; // Exact integer
                if (/^[+-]?\d*\.\d+$/.test(value)) return "decimal"; // Decimal (non-integer)
                if (/^[+-]?\d+(\.\d+)?[eE][+-]?\d+$/.test(value)) return "exponential"; // Exponential number
            }

            return "string"; // Default fallback
        }


        // const getColumnTypeFromDetails = async (columnName) => {
        function getColumnTypeFromDetails1(columnName) {
            // Loop through column types in columnDetails
            const columnTypes = [
                { type: "int", key: "int_columns" },
                { type: "decimal", key: "decimal_columns" },
                { type: "date", key: "date_columns" },
                { type: "double", key: "double_columns" },
                { type: "varchar", key: "varchar_columns" },
                { type: "number", key: "number_columns" },
                { type: "float", key: "float_columns" }
            ];

            for (const { type, key } of columnTypes) {
                if (columnDetails?.[key]?.some(col => col.col_name.includes(columnName))) {
                    return type;
                }
            }
            return "string"; // Default if not found
        }

        const fetchCSVData = async (fileName) => {
            try {
                // const filePath = `${PortURL}/uploads/${fileName}`;
                const filePath = `/uploads/${fileName}`;
                const response = await fetch(filePath);

                if (!response.ok) {
                    throw new Error("Nothing Pending for Preview");
                }

                const csvText = await response.text();
                console.log("csvData after fetch", csvText);

                // const lines = csvText
                //     .split("\n")
                //     .map((line) => line.trim())
                //     .filter((line) => line !== "");

                const preprocessed = csvText.replace(/"([^"]*)"/gs, (match, group) => {
                    // collapse CR/LF inside quoted fields into spaces
                    return '"' + group.replace(/[\r\n]+/g, ' ') + '"';
                });

                const lines = preprocessed
                    .split(/\r?\n/)
                    .map((line) => line.trim())
                    .filter((line) => line !== "");

                if (lines.length === 0) {
                    throw new Error("CSV file is empty.");
                }

                const dataRows = lines; // skip original header row

                const jsonHeaders = columnDropdown?.details?.map((col) => col.columnName) || [];
                if (jsonHeaders.length === 0) {
                    throw new Error("No valid headers found from JSON");
                }

                // Reconstruct lines for preview: [newHeaderLine, ...dataLines]
                // const previewLines = [jsonHeaders.join(","), ...dataRows];
                const previewLines = [jsonHeaders.join(","), ...dataRows.slice(1)];
                setPreviewData(previewLines);
                setIsUploadAllowed(true);

                const normalizedHeaders = jsonHeaders.map(h => h.trim().toLowerCase().replace(/\s+/g, ""));
                const csvData = { headers: normalizedHeaders, rows: dataRows };


                const isValid = await validateDropdownValues1(csvData, columnDropdown);
                if (!isValid) return new Error("Invalid dropdown values found");

                const isDropdownValid = await validateDropdownValues1(csvData, columnDropdown);
                if (!isDropdownValid) {
                    setShowModal(false);
                    await new Promise(resolve => setTimeout(resolve, 0));
                    setShowErrorModal(true);
                    setIsUploadAllowed(false);
                    return new Error("Invalid dropdown value found");
                }

                setIsValidationPassed(true);
            } catch (error) {
                console.error("Error fetching CSV data:", error.message);
                setIsValidationPassed(false);
            }
        };


        socket.onerror = (error) => {
            console.error("WebSocket error:", error);
        };

        socket.onclose = () => {
            console.log("WebSocket connection closed");
        };
    };

    const handleCancel = () => {
        setShowModal(false);
        setShowNoDataModal(false);
        setShowPreview(false);
        setShowDownloadButton(false);
        setShowDropdown(false);
        setShowSheetSelection(false);

        // Clear only if there are no validation errors
        if (validErrorRecords.length === 0) {
            setSelectedFile(null);  // Only clear file if no validation errors
            setSelectedFormat('');
            setSelectedDownloadFormat('');
            setSelectedCategory('');
            setExactName('');
            setcolumnDropdown({});
            setColumnDetails({});

        }

        setFile(null);
        setCurrentFile(null);
        setUploadStatus('');
        setPreviewData([]);
        setSelectedSheets([]);
        // setJsonReportData([]);
        setSheetOptions([]);
        setColumnKeys([]);
        setSelectedNumericColumns([]);
        setModalMessage('');
        setIsUploadAllowed(false);
        setIsValidationPassed(false);

        if (fileInputRef.current) {
            fileInputRef.current.value = '';
        }
    };



    const handleCheckboxChange = (columnName) => {
        setSelectedNumericColumns((prevSelected) => {
            const updatedSelection = prevSelected.includes(columnName)
                ? prevSelected.filter((col) => col !== columnName) // Remove if already selected
                : [...prevSelected, columnName]; // Add if not selected

            return updatedSelection;
        });
    };

    const handleSheetCheckboxChange = (sheetName) => {
        setSelectedSheets((prevSelectedSheets) => {
            const newSelectedSheets = prevSelectedSheets.includes(sheetName)
                ? prevSelectedSheets.filter((name) => name !== sheetName) // Remove if unchecked
                : [...prevSelectedSheets, sheetName]; // Add if checked

            processSelectedSheets(newSelectedSheets);

            return newSelectedSheets;
        });
    };


    // Function to detect date-like values (YYYY-MM-DD, YYYY/MM/DD, etc.)
    const isDateValue = (value) => {
        return /^\d{4}[-/]\d{2}[-/]\d{2}$/.test(value.trim()); // Matches formats like 2021-08-25 or 2021/08/25
    };

    // Extract headers
    const headers = previewData[0]?.split(",").map(header => header.trim()) || [];

    // Identify date columns dynamically based on the first few data rows
    const dateColumnIndices = [];
    previewData.slice(1, 5).forEach((row) => { // Check first 5 rows for accuracy
        const columns = row.split(",").map(cell => cell.trim());
        columns.forEach((cell, index) => {
            if (isDateValue(cell)) {
                console.log(cell, "+++", index);
                dateColumnIndices.push(index);
            }
        });
    });


    // Ensure uniqueness of date column indices
    const uniqueDateColumnIndices = [...new Set(dateColumnIndices)];


    const int_columns = columnDetails?.int_columns?.[0]?.col_name?.map(col => col.toLowerCase()) || [];
    const decimal_columns = columnDetails?.decimal_columns?.[0]?.col_name?.map(col => col.toLowerCase()) || [];
    const float_columns = columnDetails?.float_columns?.[0]?.col_name?.map(col => col.toLowerCase()) || [];
    const number_columns = columnDetails?.number_columns?.[0]?.col_name?.map(col => col.toLowerCase()) || [];

    // const numeric_columns = columnDetails?.numeric_columns?.[0]?.col_name?.map(col => col.toLowerCase()) || [];
    const date_columns = columnDetails?.date_columns?.[0]?.col_name?.map(col => col.toLowerCase()) || [];
    const character_columns = columnDetails?.character_columns?.[0]?.col_name?.map(col => col.toLowerCase()) || [];
    // const char_columns = columnDetails?.char_columns?.[0]?.col_name?.map(col => col.toLowerCase()) || [];

    const boolean_columns = columnDetails?.boolean_columns?.[0]?.col_name?.map(col => col.toLowerCase()) || [];
    const double_columns = columnDetails?.double_columns?.[0]?.col_name?.map(col => col.toLowerCase()) || [];


    const formatMappings = {
        "Microsoft Excel": ".xls, .xlsx",
        "Text Files": ".txt, .csv",
        "Image Files": ".txt",
        "doc Files": ".doc,.docx"
    };

    const microsoftFileFormats = ["xls", "xlsx", "xlsb", "xlsm"];

    const textFileFormats = ["csv", "txt"];

    // const handleFormatSelect = (format) => {
    //   setSelectedDownloadFormat(format); // Store the selected format

    // };

    useEffect(() => {
        setSelectedDownloadFormat(null); // Reset selected download format
        setSelectedCategory(null); // Reset selected category
    }, [selectedFormat]);

    const handleDownloadClick = () => {
        if (selectedDownloadFormat) {
            downloadTable(selectedName, selectedDownloadFormat); // Trigger download
        } else {
            // alert("Please select a file format before downloading."); // Validation message
        }
    };

    const handleDashboard = () => {
        navigate('/gapsyMdashboard');
    };

    return (
        <div className={`d-flex flex-column min-vh-100 ${styles.pageFullBackground}`}>
            <Header />
            <Navigation />
            <div className="top-0 px-4 py-2 text-white">
                <div className="d-flex justify-content-between align-items-center flex-wrap">
                    <div>
                        <nav aria-label="breadcrumb">
                            <ol className="breadcrumb mb-1">
                                <li className="breadcrumb-item">
                                    <a className={`text-info ${styles.textInfo}`} onClick={handleDashboard} style={{ textDecoration: 'none' }}>
                                        <i className="bi bi-house me-2" style={{ cursor: "pointer" }}></i>/
                                    </a>
                                </li>
                                <li className={`breadcrumb-item active ${styles.breadcrumbItem}`} aria-current="page">
                                    <i className="bi bi-file-earmark-arrow-up me-2"></i>2.2 Bulk Upload
                                </li>
                            </ol>
                        </nav>
                    </div>

                </div>
            </div>
            {/* <div className="gapsybdmupload-page"> */}
            <main className="flex-grow-1 container-fluid" style={{ margin: 0, padding: 0, background: "none" }}>
                <div className={styles.mainContainer}>
                    <div className="container-fluid py-2">
                        <div className="row">
                            <div className="col-lg-4 col-md-12">
                                <div className={`card h-100 ${styles.cardBorder} ${styles.card}`}>
                                    <div className="card-body">

                                        <div className="d-flex align-items-center gap-2 mb-3">


                                            <div>
                                                <DepartmentDropdown
                                                    selectedPrefix={selectedPrefix}
                                                    setSelectedPrefix={setSelectedPrefix}
                                                    prefixes={prefixes}
                                                />
                                            </div>

                                            {/* Search Bar */}
                                            <div className="flex-grow-1">
                                                <Listoftablesearchbox1
                                                    searchQuery={searchQuery}
                                                    onSearchChange={handleSearchChange}
                                                />
                                            </div>
                                        </div>


                                        <TableTemplateListGapsy
                                            currentRecords={currentRecords}
                                            ListofTableFontsize={ListofTableFontsize}
                                            handleTableClick={handleTableClick}
                                            currentPage={currentPage}  // Pass currentPage
                                            recordsPerPage={recordsPerPage}  // Pass recordsPerPage
                                        />
                                        {/* </div> */}


                                        {/* </div> */}
                                        {sortedRecords.length > recordsPerPage && (
                                            <PaginationComponentForm2
                                                currentPage={currentPage}
                                                totalPages={totalPages}
                                                paginate={paginate}
                                                recordsPerPage={recordsPerPage}
                                                tableNames={sortedRecords} // ← pass sorted list
                                            />
                                        )}


                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-8 col-md-12">
                                <div className={`card h-100 ${styles.cardBorder} ${styles.card}`}>
                                    <div className="card-body p-1">
                                        {/* Tabs */}
                                        <div className={tabStyles.tabContainer}>
                                            <div
                                                className={`${tabStyles.tab} ${activeTab === 'manual' ? tabStyles.activeTab : ''}`}
                                                onClick={() => {
                                                    handleTabSwitch('manual');
                                                    setSelectedPrefix('');
                                                    setSearchQuery('');
                                                }}
                                            >
                                                <i className="bi bi-pencil-square me-1"></i> Manual
                                            </div>
                                            <div
                                                className={`${tabStyles.tab} ${activeTab === 'ai' ? tabStyles.activeTab : ''}`}
                                                onClick={() => {
                                                    handleTabSwitch('ai');
                                                    setSelectedPrefix('');
                                                    setSearchQuery('');
                                                }}
                                            >
                                                <i className="bi bi-robot me-1"></i> AI-OCR
                                            </div>

                                        </div>
                                        <h6 className={`pb-1 mb-2 ${styles.borderBottom}`}>
                                            {selectedFileName
                                                ?.split('_')
                                                .map(word => word.charAt(0).toUpperCase() + word.slice(1))
                                                .join(' ')}
                                        </h6>

                                        {/* Tab Content */}
                                        {activeTab === 'manual' && (
                                            <div className='row'>
                                                <div className='col-md-6'>
                                                    <div className={`mb-3 ${styles.supportedFileFormats} p-1`} style={{ minHeight: "250px" }}>
                                                        <span className={styles.subheading}>Select a File Format: </span>
                                                        <div className="d-flex gap-4 mt-1">
                                                            {["Microsoft Excel", "Text Files", "doc Files"].map((format) => {
                                                                const isSelected = selectedFormat === format;

                                                                const iconDetails = {
                                                                    "Microsoft Excel": {
                                                                        icon: "bi-file-earmark-excel-fill",
                                                                        color: "text-success",
                                                                        label: "Excel",
                                                                        tooltip: "Microsoft Excel Formats",
                                                                    },
                                                                    "Text Files": {
                                                                        icon: "bi-filetype-csv",
                                                                        color: "text-primary",
                                                                        label: "Text",
                                                                        tooltip: "Text or CSV Files",
                                                                    },
                                                                    "doc Files": {
                                                                        icon: "bi-filetype-doc",
                                                                        color: "text-primary",
                                                                        label: "Word",
                                                                        tooltip: "Word Document Files",
                                                                    }
                                                                };

                                                                const { icon, color, label, tooltip } = iconDetails[format];

                                                                return (
                                                                    <div
                                                                        key={format}
                                                                        role="button"
                                                                        data-bs-toggle="tooltip"
                                                                        data-bs-placement="top"
                                                                        title={tooltip}
                                                                        onClick={() => handleFormatSelection(format)}
                                                                        className={`d-flex flex-column align-items-center justify-content-center p-2 border rounded ${isSelected ? "border-primary bg-light" : "border-secondary"
                                                                            } ${styles.iconFormatOption}`}
                                                                        style={{
                                                                            cursor: "pointer",
                                                                            width: "80px",
                                                                            transition: "transform 0.2s ease-in-out",
                                                                        }}
                                                                    >
                                                                        <i className={`bi ${icon} fs-2 ${color}`}></i>
                                                                        <span className="small text-dark text-center mt-1">{label}</span>
                                                                    </div>
                                                                );
                                                            })}
                                                        </div>
                                                        <div style={{
                                                            minHeight: "80px",
                                                            visibility:
                                                                (selectedFormat === "Microsoft Excel" && !selectedFile && showDownloadButton && currentRecords.length !== 0) ||
                                                                    (selectedFormat === "Text Files" && !selectedFile && showDownloadButton && currentRecords.length !== 0) ||
                                                                    (selectedFormat === "doc Files" && !selectedFile && showDownloadButton && currentRecords.length !== 0) ||
                                                                    (selectedFormat === "Microsoft Excel" && sheetOptions.length > 0)
                                                                    ? "visible"
                                                                    : "hidden"
                                                        }}
                                                        >
                                                            {/* Microsoft Excel Template Download */}
                                                            {selectedFormat === "Microsoft Excel" && !selectedFile && showDownloadButton && sheetOptions.length === 0 && currentRecords.length !== 0 && (
                                                                <>

                                                                    <div className="d-flex justify-content-between mt-3">
                                                                        <div className="custom-dropdown" onMouseEnter={() => setShowDropdown(true)} onMouseLeave={() => setShowDropdown(false)}>
                                                                            <div className="d-flex align-items-center gap-2 flex-wrap">
                                                                                <button className={`btn btn-sm btn-download ${selectedDownloadFormat && selectedCategory === "Microsoft Excel" ? "btn-btn-download text-white" : ""}`} onClick={handleDownloadClick}>
                                                                                    <i className="bi btn-download"></i>
                                                                                    {selectedDownloadFormat ? `Download(.${selectedDownloadFormat})` : "Download"}
                                                                                </button>

                                                                                {selectedFormat && showDownloadButton && !selectedFile && (
                                                                                    <p className="mb-0 fst-italic fw-normal mx-1">Download the Template to prepare the Data</p>
                                                                                )}
                                                                            </div>
                                                                            {showDropdown && (
                                                                                <ul className="custom-dropdown-menu">
                                                                                    {microsoftFileFormats.map((format) => (
                                                                                        <li key={format}>
                                                                                            <button
                                                                                                className="custom-dropdown-item"
                                                                                                onClick={() => {
                                                                                                    handleFormatSelect(format, "Microsoft Excel");
                                                                                                    setShowDropdown(false);
                                                                                                }}
                                                                                            >
                                                                                                .{format}
                                                                                            </button>
                                                                                        </li>
                                                                                    ))}
                                                                                </ul>
                                                                            )}
                                                                        </div>
                                                                    </div>
                                                                </>
                                                            )}

                                                            {/* doc Files Template Download */}
                                                            {selectedFormat === "doc Files" && !selectedFile && showDownloadButton && sheetOptions.length === 0 && currentRecords.length !== 0 && (
                                                                <div className="d-flex justify-content-start mt-3">
                                                                    <button
                                                                        className={`btn btn-sm btn-download ${selectedDownloadFormat && selectedCategory === "doc Files" ? "btn-btn-download text-white" : ""}`}
                                                                        onClick={() => handleFormatSelect("docx", "doc Files")} // or any default doc template logic
                                                                    >
                                                                        <i className="bi bi-download"></i> Download
                                                                    </button>
                                                                    <p className="mb-0 fst-italic fw-normal mx-2">Download the Template to prepare the Data</p>
                                                                </div>
                                                            )}

                                                            {/* Text Files Template Download */}
                                                            {selectedFormat === "Text Files" && !selectedFile && showDownloadButton && sheetOptions.length === 0 && currentRecords.length !== 0 && (
                                                                <>
                                                                    <div className="d-flex justify-content-between mt-3">
                                                                        <div
                                                                            className="custom-dropdown"
                                                                            onMouseEnter={() => setShowDropdown(true)}
                                                                            onMouseLeave={() => setShowDropdown(false)}
                                                                        >
                                                                            <div className="d-flex align-items-center gap-2 flex-wrap">
                                                                                <button
                                                                                    className={`btn btn-sm btn-download ${selectedDownloadFormat && selectedCategory === "Text Files" ? "btn-btn-download text-white" : ""}`}
                                                                                    onClick={handleDownloadClick}
                                                                                >
                                                                                    <i className="bi btn-download"></i>
                                                                                    {selectedDownloadFormat ? `Download(.${selectedDownloadFormat})` : "Download"}
                                                                                </button>

                                                                                {selectedFormat && showDownloadButton && !selectedFile && (
                                                                                    <p className="mb-0 fst-italic fw-normal mx-1">Download the Template to prepare the Data</p>
                                                                                )}
                                                                            </div>

                                                                            {showDropdown && (
                                                                                <ul className="custom-dropdown-menu">
                                                                                    {textFileFormats.map((format) => (
                                                                                        <li key={format}>
                                                                                            <button
                                                                                                className="custom-dropdown-item"
                                                                                                onClick={() => {
                                                                                                    handleFormatSelect(format, "Text Files");
                                                                                                    setShowDropdown(false);
                                                                                                }}
                                                                                            >
                                                                                                .{format}
                                                                                            </button>
                                                                                        </li>
                                                                                    ))}
                                                                                </ul>
                                                                            )}
                                                                        </div>
                                                                    </div>
                                                                </>
                                                            )}

                                                            {/* Microsoft Excel Sheet Options */}
                                                            {selectedFormat === "Microsoft Excel" && sheetOptions.length > 0 && (
                                                                <div
                                                                    className="custom-dropdown-sheet mt-3"
                                                                    onMouseEnter={() => setShowSheetDropdown(true)}
                                                                    onMouseLeave={() => setShowSheetDropdown(true)}
                                                                >
                                                                    <button className="btn btn-outline-dark btn-sm dropdown-toggle" type="button">
                                                                        Select Sheets
                                                                    </button>
                                                                    {showSheetDropdown && (
                                                                        <ul className="custom-dropdown-menu-sheet list-unstyled m-0 p-0">
                                                                            {sheetOptions.map((sheetName, index) => (
                                                                                <li key={index} className="d-flex align-items-center gap-2 p-2">
                                                                                    <input
                                                                                        type="checkbox"
                                                                                        id={`sheet-${index}`}
                                                                                        checked={selectedSheets.includes(sheetName)}
                                                                                        onChange={() => handleSheetCheckboxChange(sheetName)}
                                                                                        className="form-check-input"
                                                                                    />
                                                                                    <label htmlFor={`sheet-${index}`} className="form-check-label">
                                                                                        {sheetName}
                                                                                    </label>
                                                                                </li>
                                                                            ))}
                                                                        </ul>
                                                                    )}
                                                                </div>
                                                            )}
                                                        </div>

                                                    </div>
                                                </div>
                                                <div className='col-md-6'>
                                                    <div className="mb-3">
                                                        <div className="flex-grow-1 justify-content-center w-100">
                                                            <div
                                                                className={`p-1 mx-2 my-2 ${styles.uploadArea}`}
                                                                onClick={() => {
                                                                    if (!selectedFile && selectedFormat && selectedFileName) {
                                                                        handleBrowseClick();
                                                                    }
                                                                }}
                                                                style={{
                                                                    cursor: selectedFormat && selectedFileName ? 'pointer' : 'not-allowed',
                                                                    opacity: selectedFormat && selectedFileName ? 1 : 0.5,
                                                                    pointerEvents: selectedFormat && selectedFileName ? 'auto' : 'none',
                                                                }}
                                                                title={
                                                                    !selectedFormat
                                                                        ? "Please select file format"
                                                                        : !selectedFileName
                                                                            ? "Please select table name"
                                                                            : "Click to browse file"
                                                                }
                                                            >
                                                                {!selectedFile && validErrorRecords.length === 0 && (
                                                                    <>
                                                                        <i className="bi bi-cloud-upload fs-1 text-muted mb-2 d-block text-center"></i>
                                                                        <h5 className="mb-1">Upload File</h5>
                                                                        <p className="text-muted mb-0">Click to browse</p>
                                                                    </>
                                                                )}

                                                                <div className="text-center" style={{ marginTop: selectedFile ? '37px' : '36px' }}>
                                                                    {selectedFile && (
                                                                        <div
                                                                            id="fileList"
                                                                            className="mt-3 mb-3 d-flex align-items-center justify-content-center flex-wrap gap-2"
                                                                        >
                                                                            <div
                                                                                id="selectedFiles"
                                                                                className="text-muted d-flex flex-wrap gap-2 mb-0"
                                                                            >
                                                                                {isEactName.split("\n").map((filename, index) => (
                                                                                    <div key={index} className="d-flex flex-column border rounded p-2">
                                                                                        <div><strong>📄 File Name:</strong> {filename}</div>
                                                                                        {selectedFile && (
                                                                                            <div><strong>📏 File Size:</strong> {selectedFile.size} bytes</div>
                                                                                        )}
                                                                                    </div>
                                                                                ))}
                                                                            </div>
                                                                        </div>
                                                                    )}

                                                                    <input
                                                                        type="file"
                                                                        ref={fileInputRef}
                                                                        id="fileInput"
                                                                        style={{ display: "none" }}
                                                                        multiple
                                                                        accept={selectedFormat ? formatMappings[selectedFormat] : ""}
                                                                        disabled={!selectedFormat || !selectedFileName}
                                                                        onChange={(event) => {
                                                                            if (!selectedFormat || !selectedFileName) return;
                                                                            handleFileChange(event);
                                                                            anotherFunction(event);
                                                                        }}
                                                                    />
                                                                </div>
                                                            </div>

                                                            <div className="d-flex flex-column align-items-center gap-2 mt-2">
                                                                {selectedFile && validErrorRecords.length === 0 && (
                                                                    <div className="d-flex gap-2 mb-3">
                                                                        <button
                                                                            onClick={handlePreviewOption}
                                                                            className="btn btn-sm btn-outline-primary"
                                                                            title='Preview'
                                                                        >
                                                                            Preview
                                                                        </button>
                                                                        <button
                                                                            onClick={handleFormSubmit}
                                                                            className="btn btn-success btn-sm"
                                                                            title='Upload'
                                                                        >
                                                                            Upload
                                                                        </button>
                                                                        <button
                                                                            onClick={handleCancel}
                                                                            className="btn btn-outline-secondary btn-sm"
                                                                            title='Cancel'
                                                                        >
                                                                            Cancel
                                                                        </button>
                                                                    </div>
                                                                )}

                                                                {validErrorRecords.length > 0 && (
                                                                    <div className="d-flex justify-content-center mb-1">
                                                                        <button
                                                                            className="btn btn-outline-primary btn-sm"
                                                                            onClick={() => downloadErrorsAsPDF(validErrorRecords)}
                                                                        >
                                                                            Data Validation Report
                                                                        </button>
                                                                    </div>
                                                                )}
                                                                {jsonReportData.length > 0 && (
                                                                    <div className="d-flex justify-content-center mb-1">
                                                                        <button
                                                                            className="btn btn-outline-primary btn-sm"
                                                                            onClick={() => downloadJsonAsPDF(jsonReportData)}
                                                                        >
                                                                            Mismatch Report
                                                                        </button>
                                                                    </div>
                                                                )}
                                                                {failureReportData.length > 0 && (
                                                                    <div className="d-flex justify-content-center mb-1">
                                                                        <button
                                                                            className="btn btn-outline-primary btn-sm"
                                                                            onClick={() => downloadFailureIssuePDF(failureReportData)}
                                                                        >
                                                                            Mismatch Report
                                                                        </button>
                                                                    </div>
                                                                )}

                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>

                                            </div>
                                        )}

                                        {activeTab === 'ai' && (
                                            <div className='row'>
                                                <div className='col-md-6'>
                                                    <div className={`mb-3 ${styles.supportedFileFormats} p-1`} style={{ minHeight: "250px" }}>
                                                        <span className={styles.subheading}>Select a File Format: </span>
                                                        <div className="d-flex gap-4 mt-1">
                                                            {["Microsoft Excel", "Text Files", 'Image Files'].map((format) => {
                                                                const isSelected = selectedFormat === format;

                                                                const iconDetails = {
                                                                    "Microsoft Excel": {
                                                                        icon: "bi-file-earmark-pdf-fill",
                                                                        color: "text-success",
                                                                        label: "PDF",
                                                                        tooltip: "pdf",
                                                                    },
                                                                    "Text Files": {
                                                                        icon: "bi-file-earmark-image-fill",
                                                                        color: "text-primary",
                                                                        label: "Image",
                                                                        tooltip: "png or jpg",
                                                                    },
                                                                    "Image Files": {
                                                                        icon: "bi-filetype-csv",
                                                                        color: "text-primary",
                                                                        label: "Text",
                                                                        tooltip: "Text",
                                                                    }
                                                                };

                                                                const { icon, color, label, tooltip } = iconDetails[format];

                                                                return (
                                                                    <div
                                                                        key={format}
                                                                        role="button"
                                                                        data-bs-toggle="tooltip"
                                                                        data-bs-placement="top"
                                                                        title={tooltip}
                                                                        onClick={() => handleFormatSelection(format)}
                                                                        className={`d-flex flex-column align-items-center justify-content-center p-2 border rounded ${isSelected ? "border-primary bg-light" : "border-secondary"
                                                                            } ${styles.iconFormatOption}`}
                                                                        style={{
                                                                            cursor: "pointer",
                                                                            width: "80px",
                                                                            transition: "transform 0.2s ease-in-out",
                                                                        }}
                                                                    >
                                                                        <i className={`bi ${icon} fs-2 ${color}`}></i>
                                                                        <span className="small text-dark text-center mt-1">{label}</span>
                                                                    </div>
                                                                );
                                                            })}
                                                        </div>


                                                    </div>
                                                </div>
                                                <div className='col-md-6'>
                                                    <div className="mb-3">
                                                        <div className="flex-grow-1 justify-content-center w-100">
                                                            <div
                                                                className={`p-1 mx-2 my-2 ${styles.uploadArea}`}
                                                                onClick={() => {
                                                                    if (!selectedFile && selectedFormat && selectedFileName) {
                                                                        handleBrowseClick();
                                                                    }
                                                                }}
                                                                style={{
                                                                    cursor: selectedFormat && selectedFileName ? 'pointer' : 'not-allowed',
                                                                    opacity: selectedFormat && selectedFileName ? 1 : 0.5,
                                                                    pointerEvents: selectedFormat && selectedFileName ? 'auto' : 'none',
                                                                }}
                                                                title={
                                                                    !selectedFormat
                                                                        ? "Please select file format"
                                                                        : !selectedFileName
                                                                            ? "Please select table name"
                                                                            : "Click to browse file"
                                                                }
                                                            >
                                                                {!selectedFile && validErrorRecords.length === 0 && (
                                                                    <>
                                                                        <i className="bi bi-cloud-upload fs-1 text-muted mb-2 d-block text-center"></i>
                                                                        <h5 className="mb-1">Upload File</h5>
                                                                        <p className="text-muted mb-0">Click to browse</p>
                                                                    </>
                                                                )}

                                                                <div className="text-center" style={{ marginTop: selectedFile ? '37px' : '36px' }}>
                                                                    {selectedFile && (
                                                                        <div id="fileList"
                                                                            className="mt-3 mb-3 d-flex align-items-center justify-content-center flex-wrap gap-2"
                                                                        >
                                                                            <div
                                                                                id="selectedFiles"
                                                                                className="text-muted d-flex flex-wrap gap-2 mb-0"
                                                                            >
                                                                                {isExactName.split("\n").map((filename, index) => (
                                                                                    <div key={index} className="d-flex flex-column border rounded p-2">
                                                                                        <div><strong>📄 File Name:</strong> {filename}</div>
                                                                                        {selectedFile && (
                                                                                            <div><strong>📏 File Size:</strong> {selectedFile.size} bytes</div>
                                                                                        )}
                                                                                    </div>
                                                                                ))}
                                                                            </div>
                                                                        </div>
                                                                    )}

                                                                    <input
                                                                        type="file"
                                                                        ref={fileInputRef}
                                                                        id="fileInput"
                                                                        style={{ display: "none" }}
                                                                        multiple
                                                                        disabled={!selectedFormat || !selectedFileName}
                                                                        onChange={(event) => {
                                                                            if (!selectedFormat || !selectedFileName) return;
                                                                            handleFileChange1(event);
                                                                        }}
                                                                    />
                                                                </div>
                                                            </div>

                                                            {/* Buttons & Report Area Below */}
                                                            <div className="d-flex flex-column align-items-center gap-2 mt-2">
                                                                {/* Scan and Preview + Cancel */}
                                                                {selectedFile && !isValidationPassed && validErrorRecords.length === 0 && (
                                                                    <div className="d-flex justify-content-center gap-2 mb-3">
                                                                        <button
                                                                            title="Scan and Preview"
                                                                            onClick={handleSubmit1}
                                                                            className="btn btn-sm btn-outline-primary"
                                                                        >
                                                                            Scan and Preview
                                                                        </button>
                                                                        <button
                                                                            className="btn btn-outline-secondary btn-sm"
                                                                            style={cancelButtonStyle}
                                                                            onClick={handleCancel}
                                                                            title="Cancel"
                                                                        >
                                                                            Cancel
                                                                        </button>
                                                                    </div>
                                                                )}

                                                                {/* Preview + Upload + Cancel */}
                                                                {selectedFile && validErrorRecords.length === 0 && isValidationPassed && (
                                                                    <div className="d-flex justify-content-center gap-2 mb-3">
                                                                        <button
                                                                            onClick={handlePreviewOption}
                                                                            className="btn btn-sm btn-outline-primary"
                                                                            title="Preview"
                                                                        >
                                                                            Preview
                                                                        </button>
                                                                        <button
                                                                            onClick={handleconfirm}
                                                                            className="btn btn-success btn-sm"
                                                                            title="Upload"
                                                                        >
                                                                            Upload
                                                                        </button>
                                                                        <button
                                                                            className="btn btn-outline-secondary btn-sm"
                                                                            onClick={handleCancel}
                                                                            title="Cancel"
                                                                        >
                                                                            Cancel
                                                                        </button>
                                                                    </div>
                                                                )}

                                                                {/* Data Validation Report */}
                                                                {validErrorRecords.length > 0 && (
                                                                    <div className="d-flex justify-content-center mb-1">
                                                                        <button
                                                                            className="btn btn-outline-primary btn-sm"
                                                                            onClick={() => downloadErrorsAsPDF(validErrorRecords)}
                                                                        >
                                                                            Data Validation Report
                                                                        </button>
                                                                    </div>
                                                                )}
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        )}
                                        {errMsg && (
                                            <div className="alert alert-danger alert-dismissible fade show" role="alert">
                                                {errMsg}
                                                <button type="button" className="close" data-dismiss="alert" aria-label="Close" onClick={() => setErrMsg('')}>
                                                    <span aria-hidden="true">&times;</span>
                                                </button>
                                            </div>
                                        )}
                                        {loading && (
                                            <div className="loading-overlay">
                                                <UploadLoadingIcon />
                                            </div>

                                        )}
                                        {loading1 && (
                                            <div className="loading-overlay">
                                                <UploadLoadingIcon />
                                            </div>

                                        )}
                                        {wsLoading && (
                                            <div className="loading-overlay">
                                                {/* <div className="spinner-border text-primary" role="status">
                                                      <span className="visually-hidden">Loading...</span>
                                                    </div> */}
                                                <UploadLoadingIcon />
                                            </div>
                                        )}
                                        {isUploading && (
                                            <div className="loading-overlay">
                                                <div className="progress w-50">
                                                    <div
                                                        className="progress-bar progress-bar-striped progress-bar-animated"
                                                        role="progressbar"
                                                        style={{ width: `${uploadProgress}%` }}
                                                        aria-valuenow={uploadProgress}
                                                        aria-valuemin="0"
                                                        aria-valuemax="100"
                                                    >
                                                        {uploadProgress}%
                                                    </div>
                                                </div>
                                            </div>
                                        )}


                                        {(showPreview && previewData.length > 0) && (
                                            <Modal
                                                show={showModal}
                                                onHide={handleCloseModal}
                                                dialogClassName="modal-xl"
                                                centered
                                            >
                                                <Modal.Header className="bg-light border-bottom px-0 py-2">
                                                    <div className="container-fluid px-0">
                                                        <div className="row align-items-center w-100 gx-0">
                                                            {/* Left-aligned Table Name */}
                                                            <div className="col-auto ps-3">
                                                                <h6 className="mb-0">
                                                                    <strong>Table Name:</strong> <span>{selectedFileName}</span>
                                                                </h6>
                                                            </div>

                                                            {/* Center-aligned Validation Text */}
                                                            <div className="col text-center">
                                                                <span className="text-success fw-semibold">
                                                                    ✅ Validated Successfully
                                                                </span>
                                                            </div>

                                                            {/* Right-aligned Close Button */}
                                                            <div className="col-auto">
                                                                <div className="d-flex justify-content-end pe-3">
                                                                    <button
                                                                        onClick={handleCloseModal}
                                                                        type="button"
                                                                        className="btn-close"
                                                                        aria-label="Close"
                                                                    ></button>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </Modal.Header>

                                                <Modal.Body style={{ overflowY: 'auto' }}>
                                                    {columnDetails && (
                                                        <div className={`${styles.checksumDetails}`}>
                                                            <div className="text-dark">
                                                                No. of Columns:
                                                                <span>  {previewData.length > 0 ? previewData[0].split(',').length : 0}</span>

                                                            </div>

                                                            {(
                                                                columnDetails.boolean_columns ||
                                                                columnDetails.varchar_columns ||
                                                                columnDetails.date_columns ||
                                                                columnDetails.int_columns
                                                            ) && <span style={{ marginLeft: '5px' }}>(</span>}

                                                            {columnDetails.boolean_columns && (
                                                                <span title={columnDetails.boolean_columns[0].col_name.join(", ")} style={{ cursor: 'pointer' }}>
                                                                    <div className='table-on-homepage-only'>
                                                                        Boolean: <strong className='total-number' style={{ cursor: 'pointer' }}>
                                                                            {columnDetails.boolean_columns[0].count}
                                                                        </strong>
                                                                    </div>
                                                                </span>
                                                            )}

                                                            {columnDetails.varchar_columns && (
                                                                <span title={columnDetails.varchar_columns[0].col_name.join(", ")} style={{ cursor: 'pointer', marginRight: '10px' }}>
                                                                    <div className='table-on-homepage-only'>
                                                                        Character: <strong className='total-number' style={{ cursor: 'pointer' }}>
                                                                            {columnDetails.varchar_columns[0].count}
                                                                        </strong>
                                                                    </div>
                                                                </span>
                                                            )}
                                                            {columnDetails.date_columns && (
                                                                <span title={columnDetails.date_columns[0].col_name.join(", ")} style={{ cursor: 'pointer', marginRight: '10px' }}>
                                                                    <div className='table-on-homepage-only'>
                                                                        Date: <strong className='total-number' style={{ cursor: 'pointer' }}>
                                                                            {columnDetails.date_columns[0].count}
                                                                        </strong>
                                                                    </div>
                                                                </span>
                                                            )}

                                                            {(columnDetails.int_columns || columnDetails.decimal_columns || columnDetails.float_columns || columnDetails.double_columns) && (
                                                                <span
                                                                    title={[
                                                                        ...(columnDetails.int_columns?.[0]?.col_name || []),
                                                                        ...(columnDetails.decimal_columns?.[0]?.col_name || []),
                                                                        ...(columnDetails.float_columns?.[0]?.col_name || []),
                                                                        ...(columnDetails.double_columns?.[0]?.col_name || [])
                                                                    ].join(", ")}
                                                                    style={{ cursor: "pointer", marginRight: "10px" }}
                                                                >
                                                                    <div className='table-on-homepage-only'>
                                                                        Numeric:{" "}
                                                                        <strong className='total-number' style={{ cursor: "pointer" }}>
                                                                            {(columnDetails.int_columns?.[0]?.count || 0) +
                                                                                (columnDetails.decimal_columns?.[0]?.count || 0) +
                                                                                (columnDetails.float_columns?.[0]?.count || 0) +
                                                                                (columnDetails.double_columns?.[0]?.count || 0)}
                                                                        </strong>
                                                                    </div>
                                                                </span>
                                                            )}


                                                            {(
                                                                columnDetails.boolean_columns ||
                                                                columnDetails.varchar_columns ||
                                                                columnDetails.date_columns ||
                                                                columnDetails.int_columns
                                                            ) && <span style={{ marginLeft: '-8px' }}>)</span>}


                                                            {(columnDetails.int_columns?.[0]?.col_name?.length ||
                                                                columnDetails.decimal_columns?.[0]?.col_name?.length ||
                                                                columnDetails.number_columns?.[0]?.col_name?.length ||
                                                                columnDetails.double_columns?.[0]?.col_name?.length ||
                                                                columnDetails.float_columns?.[0]?.col_name?.length) > 0 && (

                                                                    <Dropdown style={{ marginLeft: 'auto' }}>
                                                                        <div className='table-on-homepage-only'>
                                                                            <Dropdown.Toggle variant="light" className='dropdown-button-color btn-sm'>
                                                                                Calculate Sum / Total
                                                                            </Dropdown.Toggle>
                                                                            <Dropdown.Menu style={{ maxHeight: '200px', overflowY: 'auto' }}>
                                                                                {[
                                                                                    ...(columnDetails.int_columns?.[0]?.col_name?.map(col => col.toLowerCase()) || []),
                                                                                    ...(columnDetails.decimal_columns?.[0]?.col_name?.map(col => col.toLowerCase()) || []),
                                                                                    ...(columnDetails.number_columns?.[0]?.col_name?.map(col => col.toLowerCase()) || []),
                                                                                    ...(columnDetails.double_columns?.[0]?.col_name?.map(col => col.toLowerCase()) || []),
                                                                                    ...(columnDetails.float_columns?.[0]?.col_name?.map(col => col.toLowerCase()) || [])
                                                                                ].map((col, index) => {
                                                                                    const isSelected = selectedNumericColumns.includes(col);
                                                                                    return (
                                                                                        <Dropdown.Item
                                                                                            key={index}
                                                                                            as="div"
                                                                                            onClick={() => handleCheckboxChange(col)} // Clicking the row selects/unselects
                                                                                            style={{
                                                                                                color: isSelected ? "orange" : "black", // Change text color for better visibility
                                                                                            }}
                                                                                        >
                                                                                            <Form.Check
                                                                                                type="checkbox"
                                                                                                label={<span className='columns-dropdown'>{col}</span>}
                                                                                                checked={isSelected}
                                                                                                onClick={(e) => e.stopPropagation()} // Prevents row click when clicking checkbox
                                                                                                onChange={() => handleCheckboxChange(col)} // Ensure total updates when checkbox is clicked
                                                                                                style={{
                                                                                                    accentColor: isSelected ? "white" : "#E67016", // Checkbox color change
                                                                                                }}
                                                                                            />
                                                                                        </Dropdown.Item>
                                                                                    );
                                                                                })}
                                                                            </Dropdown.Menu>
                                                                        </div>
                                                                    </Dropdown>

                                                                )}
                                                        </div>
                                                    )}
                                                    {/* Total Records Count */}
                                                    {previewData.length > 1 && (
                                                        <div className={`${styles.checksumDetails}`}>
                                                            <div className="text-dark">
                                                                No. of Records: <span>{previewData.length - 1}</span>
                                                            </div>
                                                        </div>
                                                    )}

                                                    {/* Table Preview */}
                                                    {previewData.length > 0 ? (
                                                        <div className='table-on-homepage-only'>
                                                            <div className={`tableWrapper ${tableStyles.tableWrapper}`}>
                                                                <table className={`table table-bordered table-hover text-center customScrollTable ${tableStyles.customScrollTable}`}>
                                                                    <thead className="thead-light">
                                                                        <tr>
                                                                            {previewData[0].split(',').map((header, index) => (
                                                                                <th key={index} style={{ padding: '8px', backgroundColor: '#f8f9fa' }}>{header}</th>
                                                                            ))}
                                                                        </tr>
                                                                    </thead>
                                                                    <tbody>
                                                                        {previewData.slice(1, previewLimit + 1).map((row, rowIndex) => {
                                                                            const regex = /(?<=^|,)(?:"([^"]*)"|([^,]*))(?=,|$)/g;
                                                                            // const matches = [...row.matchAll(regex)].map(match => match[1] ?? match[2] ?? '');
                                                                            const matches = [...row.matchAll(regex)].map(match => (match[1] !== undefined ? match[1] : match[2] ?? ''));
                                                                            return (
                                                                                <tr key={rowIndex}>
                                                                                    {matches.map((cell, cellIndex) => {
                                                                                        let cleanedCell = cell.trim();
                                                                                        // const columnName = previewData[0].split(',')[cellIndex]?.trim();
                                                                                        const columnName = previewData[0].split(',')[cellIndex]?.trim().toLowerCase();
                                                                                        let style = { whiteSpace: 'nowrap', textAlign: 'left' }; // Default left alignment

                                                                                        // Remove parentheses and replace with minus sign
                                                                                        cleanedCell = cleanedCell.replace(/\(([^)]+)\)/, "-$1");
                                                                                        if (
                                                                                            int_columns.map(col => col.toLowerCase()).includes(columnName) ||
                                                                                            decimal_columns.map(col => col.toLowerCase()).includes(columnName) ||
                                                                                            number_columns.map(col => col.toLowerCase()).includes(columnName) ||
                                                                                            float_columns.map(col => col.toLowerCase()).includes(columnName) ||
                                                                                            double_columns.map(col => col.toLowerCase()).includes(columnName)
                                                                                        ) {
                                                                                            style.textAlign = 'right'; // Right-align numeric columns

                                                                                        }

                                                                                        return <td key={cellIndex} style={style}>{cleanedCell}</td>;
                                                                                    })}
                                                                                </tr>
                                                                            );
                                                                        })}
                                                                    </tbody>
                                                                    {/* Footer for totals */}
                                                                    {selectedNumericColumns.length > 0 && (
                                                                        <tfoot
                                                                            className='table-footer-details'
                                                                            style={
                                                                                {
                                                                                    position: "sticky",
                                                                                    bottom: "0",
                                                                                    zIndex: "1",
                                                                                }
                                                                            }
                                                                        >
                                                                            <tr>
                                                                                {previewData[0].split(",").map((header, headerIndex) => {
                                                                                    const normalizeColumnName = (name) => name.replace(/\s+/g, "").toLowerCase(); // Remove spaces & lowercase
                                                                                    const trimmedHeader = normalizeColumnName(header); // Normalize header

                                                                                    const isSelected = selectedNumericColumns
                                                                                        .map(col => normalizeColumnName(col)) // Normalize selected columns
                                                                                        .includes(trimmedHeader);

                                                                                    let totalValue = columnSums[trimmedHeader];

                                                                                    if (isSelected) {
                                                                                        let numericValue = parseFloat(
                                                                                            (totalValue || "0")
                                                                                                .toString()
                                                                                                .replace(/\(([^)]+)\)/, "-$1") // Convert (value) to -value
                                                                                                .replace(/,/g, "") // Remove commas before parsing
                                                                                        );

                                                                                        totalValue = numericValue.toLocaleString("en-US", {
                                                                                            minimumFractionDigits: 2,
                                                                                            maximumFractionDigits: 2,
                                                                                        });
                                                                                    }
                                                                                    return (
                                                                                        <td
                                                                                            key={headerIndex}
                                                                                            className='table-footer-color'

                                                                                        >
                                                                                            {isSelected ? `${totalValue}` : ""}
                                                                                        </td>
                                                                                    );
                                                                                })}
                                                                            </tr>
                                                                        </tfoot>

                                                                    )}
                                                                </table>
                                                            </div>
                                                        </div>

                                                    ) : (
                                                        <div className='table-on-homepage-only'>
                                                            <p className="text-center" style={{ color: '#555', ...ListPopSize }}>No preview data available.</p>
                                                        </div>
                                                    )
                                                    }
                                                    {

                                                        previewLimit + 1 < previewData.length && (
                                                            <div className='table-on-homepage-only'>
                                                                <div className="text-center mt-3">
                                                                    <Button onClick={() => setPreviewLimit(previewLimit + 100)} className="btn btn-sm text-white btn-outline-primary">
                                                                        Load More
                                                                    </Button>
                                                                </div>
                                                            </div>
                                                        )

                                                    }
                                                </Modal.Body >
                                            </Modal >
                                        )}

                                        <Modal show={showErrorModal} onHide={() => setShowErrorModal(false)} centered backdrop="static" keyboard={false}>
                                            <Modal.Header closeButton>
                                                <Modal.Title>Error / Warning</Modal.Title>
                                            </Modal.Header>

                                            {/* Apply Bootstrap scrolling + max height */}
                                            <Modal.Body className="text-break overflow-auto" style={{ maxHeight: "60vh" }}>
                                                {errorModalMessage}
                                            </Modal.Body>

                                            <Modal.Footer>
                                                <Button variant="secondary" style={closeButtonStyle} onClick={handleCloseErrorModal}>
                                                    Close
                                                </Button>
                                            </Modal.Footer>
                                        </Modal>

                                        <Modal show={modalMessage} style={{ marginTop: '12vh' }}>
                                            <div className={`alert alert-${messageType === 'success' ? 'success' : 'danger'} fade show`} role="alert"
                                                style={{ marginBottom: '0', maxHeight: '80vh', overflowY: 'auto' }}>

                                                <div className="d-flex align-items-center">
                                                    {messageType === 'success' ? (
                                                        <span className="me-2" style={{ color: 'green' }}>✅</span>
                                                    ) : (
                                                        <span className="me-2" style={{ color: 'red' }}>❌</span>
                                                    )}
                                                    <p
                                                        style={{
                                                            marginBottom: '0px',
                                                            color: messageType === 'success' ? 'green' : 'red',
                                                            fontSize: '14px',
                                                            whiteSpace: 'pre-wrap' // optional, if you want to preserve spaces or indentation
                                                        }}
                                                        dangerouslySetInnerHTML={{
                                                            __html: modalMessage.replace(/\n/g, '<br />')
                                                        }}
                                                    ></p>



                                                </div>
                                                <button
                                                    type="button"
                                                    className="btn-close position-absolute top-0 end-0 m-2" style={{ fontSize: '10px' }}
                                                    onClick={handleCancel}>
                                                </button>

                                            </div>
                                        </Modal>


                                        <Modal
                                            show={showNoDataModal}
                                            onHide={handleCloseNoDataModal}
                                            dialogClassName="modal-narrow" // Adjust if needed

                                            style={{ marginTop: '12vh' }}
                                        >
                                            <Modal.Header closeButton>
                                                <Modal.Title>Template Preview</Modal.Title>
                                            </Modal.Header>
                                            <Modal.Body>
                                                <p>No preview data available. Please upload a file with valid data.</p>
                                            </Modal.Body>
                                            <Modal.Footer>
                                                <button
                                                    className={bootstrapbuttonclass}
                                                    style={

                                                        closeButtonStyle
                                                    }
                                                    onClick={handleCloseNoDataModal}>Close</button>
                                            </Modal.Footer>
                                        </Modal>
                                        <Modal show={showFileSelectionModal} onHide={() => setShowFileSelectionModal(false)}
                                            backdrop="static" keyboard={false} style={{ marginTop: '12vh' }}>
                                            <Modal.Header style={{
                                                backgroundColor: '#366872',
                                                color: 'white',
                                                padding: '0.5rem 1rem'
                                            }}>
                                                <Modal.Title style={{ fontSize: '16px' }}>Notification</Modal.Title>
                                            </Modal.Header>
                                            <Modal.Body style={{ padding: '0.75rem 1rem', fontSize: '14px' }}>
                                                <p>{fileSelectionMessage}</p>
                                            </Modal.Body>
                                            <Modal.Footer style={{ borderTop: 'none' }}>
                                                <Button variant="secondary"
                                                    onClick={() => setShowFileSelectionModal(false)}>
                                                    Close
                                                </Button>
                                            </Modal.Footer>
                                        </Modal>


                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </main>
            <Footer />
        </div>
    );

}

export default GapsyTablelist;
